<template>
  <div class="">
    <b-card
      header="C-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 1 && screenWidth < 700"
    >
      <b-row class="mobileRow">
        <VueApexCharts
          type="bar"
          :options="chartOptionsLine"
          :series="seriesLine"
        >
        </VueApexCharts>
      </b-row>
      <b-row class="mobileRow">
        <VueApexCharts
          type="donut"
          :options="optionsDonut"
          :series="seriesDonut()"
        >
        </VueApexCharts>
      </b-row>
    </b-card>
    <b-card
      header="C-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 1 && screenWidth >= 700 && screenWidth < 1000"
    >
      <b-col class="mobileRow">
        <VueApexCharts
          type="bar"
          :options="chartOptionsLine"
          :series="seriesLine"
        >
        </VueApexCharts>
      </b-col>
      <b-col class="mobileRow">
        <VueApexCharts
          type="donut"
          :options="optionsDonut"
          :series="seriesDonut()"
        >
        </VueApexCharts>
      </b-col>
    </b-card>
    <b-card
      header="C-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 1 && screenWidth >= 1000"
    >
      <b-row>
        <b-col>
          <VueApexCharts
            type="bar"
            :options="chartOptionsLine"
            :series="seriesLine"
          >
          </VueApexCharts>
        </b-col>
        <b-col>
          <VueApexCharts
            type="donut"
            :options="optionsDonut"
            :series="seriesDonut()"
          >
          </VueApexCharts>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      header="O-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 0 && screenWidth < 700"
    >
      <b-col class="mobileRow">
        <VueApexCharts
          type="bar"
          :options="chartOptionsLine"
          :series="seriesLine2"
        >
        </VueApexCharts>
      </b-col>
      <b-col class="mobileRow">
        <VueApexCharts
          type="donut"
          :options="optionsDonut"
          :series="seriesDonut2()"
        >
        </VueApexCharts>
      </b-col>
    </b-card>
    <b-card
      header="O-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 0 && screenWidth >= 700 && screenWidth < 1000"
    >
      <b-col class="mobileRow">
        <VueApexCharts
          type="bar"
          :options="chartOptionsLine"
          :series="seriesLine2"
        >
        </VueApexCharts>
      </b-col>
      <b-col class="mobileRow">
        <VueApexCharts
          type="donut"
          :options="optionsDonut"
          :series="seriesDonut2()"
        >
        </VueApexCharts>
      </b-col>
    </b-card>
    <b-card
      header="O-1 Device Data"
      header-bg-variant="light"
      v-if="tabNo == 0 && screenWidth >= 1000"
    >
      <b-row>
        <b-col>
          <VueApexCharts
            type="bar"
            :options="chartOptionsLine"
            :series="seriesLine2"
          >
          </VueApexCharts>
        </b-col>
        <b-col>
          <VueApexCharts
            type="donut"
            :options="optionsDonut"
            :series="seriesDonut2()"
          >
          </VueApexCharts>
        </b-col>
      </b-row>
    </b-card>
    <b-row id="ButtonRow"> <b-col> </b-col> </b-row>
    <b-row
      ><b-col><br /></b-col
    ></b-row>
    <!-- NEW VERSION CODE FOR TESTING-->
    <div v-if="screenWidth < 1000">
      <br />
      <b-card>
        <b-row>
          <b-col cols="12">
            <label> Risk Level </label> <br />
            <b-form-select v-model="dbFilterRiskLevel">
              <option selected null>No Risk Filter</option>
              <option value="1">Extremely High Risk</option>
              <option value="2">High Risk</option>
              <option value="3">Moderate Risk</option>
              <option value="4">Low Risk</option>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <label> Filter by Feed </label>
            <b-list-group style="display:flex;">
              <b-row>
                <b-col cols="3">
                  <b-list-group-item>
                    <b-form-checkbox
                      v-model="dbFilterHot"
                      class="checkboxDiv px-0"
                      >Hot</b-form-checkbox
                    >
                  </b-list-group-item>
                </b-col>
                <b-col cols="3">
                  <b-list-group-item>
                    <b-form-checkbox
                      v-model="dbFilterCold"
                      class="checkboxDiv px-0"
                      >Cold</b-form-checkbox
                    >
                  </b-list-group-item>
                </b-col>
                <b-col cols="3">
                  <b-list-group-item>
                    <b-form-checkbox
                      v-model="dbFilterMixed"
                      class="checkboxDiv px-0"
                      >Mixed</b-form-checkbox
                    >
                  </b-list-group-item>
                </b-col>
                <b-col cols="3">
                  <b-list-group-item>
                    <b-form-checkbox
                      v-model="dbFilterReturn"
                      class="checkboxDiv px-0"
                      >Return</b-form-checkbox
                    >
                  </b-list-group-item>
                </b-col>
              </b-row>
            </b-list-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>Filter by Name</b-col>
        </b-row>
        <b-row>
          <b-col
            ><b-form-input
              v-model="searchname"
              placeholder="Enter Device Name"
            ></b-form-input
          ></b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="2"></b-col>
          <b-col cols="4">
            <b-button
              variant="outline-secondary"
              @click="filterDashboardData()"
              size="sm"
              >Apply filter</b-button
            >
          </b-col>
          <b-col cols="4">
            <b-button
              variant="outline-secondary"
              @click="resetValue()"
              size="sm"
              >Clear filter</b-button
            >
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="4"> <p class="filterhead">Current Filters:</p> </b-col>
          <b-col v-if="this.filterInfo.length == 0"
            ><p class="filterbody">No Filters</p></b-col
          >
          <b-col cols="2"
            v-for="(id, idx) in this.filterInfo"
            :key="idx"
            class="text-left"
          >
            <p class="filterbody">
            {{ id }},
            </p>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-if="screenWidth >= 1000">
      <br />
      <b-card>
        <b-row>
          <b-col cols="5">
            <label> Risk Level </label> <br />
            <b-form-select v-model="dbFilterRiskLevel">
              <option selected null>No Risk Filter</option>
              <option value="1">Extremely High Risk</option>
              <option value="2">High Risk</option>
              <option value="3">Moderate Risk</option>
              <option value="4">Low Risk</option>
            </b-form-select>
          </b-col>
          <b-col cols="6">
            <label> Filter by Feed </label>
            <b-list-group class="" horizontal="md">
              <b-list-group-item> </b-list-group-item>
              <b-list-group-item>
                <b-form-checkbox v-model="dbFilterHot" class="checkboxDiv"
                  >Hot</b-form-checkbox
                >
              </b-list-group-item>
              <b-list-group-item>
                <b-form-checkbox v-model="dbFilterCold" class="checkboxDiv"
                  >Cold</b-form-checkbox
                >
              </b-list-group-item>
              <b-list-group-item>
                <b-form-checkbox v-model="dbFilterMixed" class="checkboxDiv"
                  >Mixed</b-form-checkbox
                >
              </b-list-group-item>
              <b-list-group-item>
                <b-form-checkbox v-model="dbFilterReturn" class="checkboxDiv"
                  >Return</b-form-checkbox
                >
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>Filter by Name</b-col>
        </b-row>
        <b-row>
          <b-col cols="6"
            ><b-form-input
              v-model="searchname"
              placeholder="Enter Device Name"
            ></b-form-input
          ></b-col>
        </b-row>
        <br />
        <b-button
          variant="outline-secondary"
          @click="filterDashboardData()"
          size="sm"
          >Apply filter</b-button
        ><b-button variant="outline-secondary" @click="resetValue()" size="sm"
          >Clear filter</b-button
        >
        <br />
        <b-row>
          <b-col cols="2"> <p class="filterhead">Current Filters:</p> </b-col>
          <b-col v-if="this.filterInfo.length == 0"
            ><p class="filterbody">No Filters</p></b-col
          >
          <b-col cols="2"
            v-for="(id, idx) in this.filterInfo"
            :key="idx"
            class="text-left"
          >
            <p class="filterbody">
              {{ id }},
            </p>
          </b-col>
        </b-row>
        <br />
      </b-card>
      <br />
    </div>
    <br />
    <div>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
      <b-tabs
        v-model="tabNo"
        content-class="mt-3"
        justified
        active-nav-item-class="font-weight-bold text-uppercase text-dark"
      >
        <!-- TESTING FLIP -->
         <b-tab active v-if="screenWidth < 1000" v-on:click="LoadO1Data([],'','','')">
          <template #title>
            <b-row>
              <h5 class="mx-auto">O-1 Devices</h5>
            </b-row>
            <b-row>
              <b-avatar-group overlap="0.65" class="mx-auto">
                <b-avatar variant="danger" rounded>{{ O1ExtHiCount }}</b-avatar>
                <b-avatar class="highRisk" rounded>{{ O1HiCount }}</b-avatar>
                <b-avatar variant="warning" rounded>{{ O1ModCount }}</b-avatar>
                <b-avatar variant="success" rounded>{{ O1LowCount }}</b-avatar>
              </b-avatar-group>
            </b-row>
          </template>

          <b-card-group deck>
            <b-card
              v-if="this.O1Array.length == 0"
              border-variant="secondary"
              header="O-1 Devices"
              header-bg-variant="secondary"
              footer-bg-variant="info"
              header-text-variant="white"
              hide-footer
              align="center"
              style="margin-bottom: 1rem;"
            >
              <b-card-text>No data available</b-card-text>
              <b-card-text></b-card-text>
              <!-- <template #footer> </template> -->
            </b-card>

            <!-- NEW SMALL CARDS INC LAYOUT -->

            <b-card
              border-variant="secondary"
              align="center"
              class="TwoWideRepeatDash"
              :header-bg-variant="id.HeaderVariant"
              header-text-variant="dark"
              v-for="(id, idx) in O1Array"
              :key="idx"
              footer-tag="footer"
              footer-bg-variant="light"
              no-body
            >
             <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
                
                
              </template>
                <template #footer>
                <b-button block variant="light" @click="showdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Department}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col cols="1"></b-col> -->
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">1</p></b-col> -->
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'">
                  <b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    >
                    <p class="smalltag"><b-badge :class=id.Probe1TagClass>{{id.Probe1Tag}}</b-badge></p>
                  </b-avatar>
                </b-col>
                 <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                   </b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">2</p></b-col> -->
               <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>
                  
                <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                   <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'TRUE'"
                      rounded
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">3</p></b-col> -->
                <b-col cols="4" v-if="id.Probe3Active == 'TRUE'"><b-avatar
                    :class=id.Probe3Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe3Title
                    ><p class="smalltag"><b-badge :class=id.Probe3TagClass>{{id.Probe3Tag}}</b-badge></p></b-avatar></b-col>
                    <b-col cols="4" v-if="id.Probe3Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe3Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe3TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe3Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col> 
                   <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    vvariant= "light"
                    >{{ id.Probe3MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                  <b-col cols="2">
                    <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    :class = "id.Probe3TempVariant"
                    >{{ id.Probe3AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe3Active == 'TRUE'"
                      :class="id.Probe3FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe3Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">4</p></b-col> -->
                 <b-col cols="4" v-if="id.Probe4Active == 'TRUE'"><b-avatar
                    :class=id.Probe4Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe4Title
                    ><p class="smalltag"><b-badge :class=id.Probe4TagClass>{{id.Probe4Tag}}</b-badge></p></b-avatar></b-col>
                <b-col cols="4" v-if="id.Probe4Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'TRUE'"
                    rounded
                    :class = "id.Probe4TempVariant"
                    >{{ id.Probe4AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe4Active == 'TRUE'"
                      :class="id.Probe4FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe4Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              </b-card>

            <!-- Gary New O1 Layout -->
          </b-card-group>
        </b-tab>
        <b-tab active v-if="screenWidth >= 1000" v-on:click="LoadO1Data([],'','','')">
          <template #title>
            <b-row>
              <b-col> O-1 Devices </b-col>
              <b-col>
                <b-avatar-group overlap="0.65">
                  <b-avatar variant="danger" rounded>{{
                    O1ExtHiCount
                  }}</b-avatar>
                  <b-avatar class="highRisk" rounded>{{ O1HiCount }}</b-avatar>
                  <b-avatar variant="warning" rounded>{{
                    O1ModCount
                  }}</b-avatar>
                  <b-avatar variant="success" rounded>{{
                    O1LowCount
                  }}</b-avatar>
                </b-avatar-group>
              </b-col>
            </b-row>
          </template>
          <b-card-group deck>
            <b-card
              v-if="this.O1Array.length == 0"
              border-variant="secondary"
              header="O-1 Devices"
              header-bg-variant="secondary"
              footer-bg-variant="info"
              header-text-variant="white"
              hide-footer
              align="center"
              style="margin-bottom: 1rem;"
            >
              <b-card-text>No data available</b-card-text>
              <b-card-text></b-card-text>
            </b-card>
             <!-- GARY NEW NEW O1 TEST LAYOUT CARD INC BREACHES-->
              <b-card 
              border-variant="secondary"
              align="center"
              class="ThreeWideRepeatDash"
              :header-bg-variant="id.HeaderVariant"
              header-text-variant="dark"
              v-for="(id, idx) in O1Array"
              :key="idx"
              footer-tag="footer"
              footer-bg-variant="light"
              no-body>
              <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
                
                
              </template>
                <template #footer>
                <b-button block variant="light" @click="showdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Department}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col cols="1"></b-col> -->
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">1</p></b-col> -->
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'">
                  <b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    >
                    <p class="smalltag"><b-badge :class=id.Probe1TagClass>{{id.Probe1Tag}}</b-badge></p>
                  </b-avatar>
                </b-col>
                 <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe1Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">2</p></b-col> -->
               <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>
                  
                <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                   <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'TRUE'"
                      rounded
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">3</p></b-col> -->
                <b-col cols="4" v-if="id.Probe3Active == 'TRUE'"><b-avatar
                    :class=id.Probe3Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe3Title
                    ><p class="smalltag"><b-badge :class=id.Probe3TagClass>{{id.Probe3Tag}}</b-badge></p></b-avatar></b-col>
                    <b-col cols="4" v-if="id.Probe3Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe3Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe3TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe3Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col> 
                   <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    variant= "light"
                    >{{ id.Probe3MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                  <b-col cols="2">
                    <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    :class = "id.Probe3TempVariant"
                    >{{ id.Probe3AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe3Active == 'TRUE'"
                      :class="id.Probe3FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe3Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">4</p></b-col> -->
                 <b-col cols="4" v-if="id.Probe4Active == 'TRUE'"><b-avatar
                    :class=id.Probe4Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe4Title
                    ><p class="smalltag"><b-badge :class=id.Probe4TagClass>{{id.Probe4Tag}}</b-badge></p></b-avatar></b-col>
                <b-col cols="4" v-if="id.Probe4Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'TRUE'"
                    rounded
                    :class = "id.Probe4TempVariant"
                    >{{ id.Probe4AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe4Active == 'TRUE'"
                      :class="id.Probe4FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe4Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              </b-card>

             <!--GARY NEW NEW TEST LAYOUT CARD INC BREACHES END END END-->

          

          </b-card-group>
        </b-tab>
        <!-- end test flip -->

        <b-tab lazy v-if="screenWidth < 1000" v-on:click="LoadC1Data([],'','','')">
          <template #title>
            <b-row>
              <h5 class="mx-auto">C-1 Devices</h5>
            </b-row>
            <b-row>
              <b-avatar-group overlap="0.65" class="mx-auto">
                <b-avatar variant="danger" rounded>{{ C1ExtHiCount }}</b-avatar>
                <b-avatar class="highRisk" rounded>{{ C1HiCount }}</b-avatar>
                <b-avatar variant="warning" rounded>{{ C1ModCount }}</b-avatar>
                <b-avatar variant="success" rounded>{{ C1LowCount }}</b-avatar>
              </b-avatar-group>
            </b-row>
          </template>
          <b-card
            v-if="this.responseArray[0] == 'No Data'"
            border-variant="secondary"
            header="C-1 Devices"
            header-bg-variant="secondary"
            footer-bg-variant="info"
            header-text-variant="white"
            hide-footer
            align="center"
            style="margin-bottom: 1rem;"
          >
            <b-card-text>No data available</b-card-text>
            <b-card-text></b-card-text>
          </b-card>

          <b-card-group deck v-if="this.responseArray[0] != 'No Data'">
            <!-- NEW SMALL CARDS START HERE -->
            <b-card
              border-variant="dark"
              align="center"
              :header-bg-variant="id.variant"
              footer-tag="footer"
              v-for="(id, idx) in responseArray"
              :key="idx"
              class="TwoWideRepeatDash"
            >
            <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
              </template>
              <template #footer>
                <b-button block variant="light" @click="showboxdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.DeptFloor}}</p></b-col></b-row>
              <hr/>
               <b-row no-gutters>
                <!-- <b-col cols="1"></b-col> -->
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">1</p></b-col> -->
                <!-- <b-col align-self="center" cols="3"><p class="smalltag"><b-badge variant="secondary">TMV Cold In</b-badge></p></b-col> -->
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'"><b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    ><p class="smalltag"><b-badge :class=id.Probe1TagClass >{{id.Probe1Tag}}</b-badge></p></b-avatar></b-col>
                   <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                   v-if="id.Probe1Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{id.Probe1Mintemp }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                   v-if="id.Probe1Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active != 'TRUE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                   <b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    >
                </b-col>
              </b-row>
                        <b-row><b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
                          <b-col align-self="end"><b-progress :value="id.Probe1Bio" max=5 :variant="id.Probe1BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
                        </b-row>
                <hr/>
                    <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">2</p></b-col> -->
                <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>      
                  <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                    v-if="id.Probe2Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                    v-if="id.Probe2Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active != 'TRUE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe2Active == 'TRUE'"
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    >
                </b-col>
              </b-row>
                        <b-row><b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
                          <b-col align-self="center"><b-progress :value="id.Probe2Bio" max=5 :variant="id.Probe2BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
                        </b-row>

                <hr/>

              </b-card>
              <!-- <span class="C1DashSubHeadText">
                {{ id.DeptFloor }} <br />
                {{ id.Position }}
              </span> -->
              <!-- <span class="C1DashSubHeadText">
                {{ getNewName(id.DeviceID, "CL") }}
              </span> -->

              <!-- <template #header> -->
                <!-- <h4 class="left">{{ getNewName(id.DeviceID, "CL") }}</h4> -->
                <!-- <b-row><b-col cols="10"><h6 class="left">{{id.DeptFloor}}</h6></b-col></b-row>
                <b-row><b-col cols="10"><h6 class="left">{{id.Position}}</h6></b-col><b-col cols="2"
                    ><BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Up"
                    ></BIconArrowUpRightSquare>
                    <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Down"
                    >
                    </BIconArrowDownRightSquare>
                    <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Stable"
                    >
                    </BIconDashSquare
                  ></b-col></b-row>
                <b-avatar-group class="right">
                  <b-avatar
                    v-if="id.Healthcare == 'TRUE'"
                    v-b-tooltip.hover
                    title="Healthcare"
                    class="healthicon"
                  >
                    H</b-avatar
                  >
                  <b-avatar
                    v-if="id.type == 'double'"
                    class="MultiplePipe"
                    v-b-tooltip.hover
                    title="Double Pipe"
                    ><BIconShare></BIconShare
                  ></b-avatar>
                  <b-avatar
                    v-if="id.Outdoor == 'TRUE'"
                    class="OutdoorIcon"
                    v-b-tooltip.hover
                    title="Outdoor"
                    ><BIconHouse></BIconHouse
                  ></b-avatar>
                  <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>
                  <b-avatar
                    v-if="(id.Feed == 'Hot Feed') & (id.type == 'Single')"
                    class="hoticon"
                    v-b-tooltip.hover
                    title="Hot Feed"
                  >
                    <BIconDropletHalf></BIconDropletHalf>
                  </b-avatar>
                  <b-avatar
                    class="coldicon"
                    v-b-tooltip.hover
                    title="Cold Feed"
                    v-if="(id.Feed == 'Cold Feed') & (id.type == 'Single')"
                    ><BIconDropletHalf></BIconDropletHalf
                  ></b-avatar>
                  <b-avatar
                    v-if="(id.Feed == 'Mixed Feed') & (id.type == 'Single')"
                    class="mixedicon"
                    v-b-tooltip.hover
                    title="Mixed Feed"
                    ><BIconDropletHalf></BIconDropletHalf
                  ></b-avatar>
                  <b-avatar
                    v-if="(id.Feed == 'Return Feed') & (id.type == 'Single')"
                    class="returnicon"
                    v-b-tooltip.hover
                    title="Return Pipe"
                    >R</b-avatar
                  >
                </b-avatar-group>
              </template> -->
              <!-- <template #footer>
                <b-button block variant="light" @click="showboxdetails(id)"
                  >Details</b-button
                >
              </template>
              <section v-if="id.Multipipe == 'FALSE'">
                <b-row>
                  <b-col>
                    <p class="cardhead">Flow Event</p>
                  </b-col>
                  <b-col>
                    <p class="cardhead">Biofilm Risk</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-card
                      ><p class="cardbody" v-if="id.FlowRead == 'N/A'">
                        {{ id.FlowRead }}
                      </p>
                      <p class="cardbody" v-if="id.FlowRead != 'N/A'">
                        {{ id.FlowRead }} hours ago
                      </p></b-card
                    >
                  </b-col>
                  <b-col>
                    <b-card
                      ><p class="cardbody">
                        <b-badge v-if="id.PathogenRead == '1'" variant="success"
                          >Level 1</b-badge
                        >
                        <b-badge v-if="id.PathogenRead == '2'" variant="warning"
                          >Level 2</b-badge
                        >
                        <b-badge v-if="id.PathogenRead == '3'" variant="warning"
                          >Level 3</b-badge
                        >
                        <b-badge v-if="id.PathogenRead == '4'" class="highRisk"
                          >Level 4</b-badge
                        >
                        <b-badge v-if="id.PathogenRead == '5'" variant="danger"
                          >Level 5</b-badge
                        >
                        <b-badge
                          v-if="id.PathogenRead == 'NoBio'"
                          variant="info"
                          >No Data</b-badge
                        >
                      </p></b-card
                    >
                  </b-col>
                </b-row>
                <b-row
                  ><b-col><br /></b-col
                ></b-row>
                <b-row
                  ><b-col><p class="cardhead">Min</p></b-col
                  ><b-col><p class="cardhead">Max</p></b-col
                  ><b-col><p class="cardhead">Avg</p></b-col></b-row
                >
                <b-row>
                  <b-col
                    ><b-card class="cardTemp" no-body
                      ><p class="cardbody" v-if="id.TempLo != 'N/A'">
                        {{ id.TempLo }}&#8451;
                      </p>
                      <p class="cardbody" v-if="id.TempLo == 'N/A'">
                        {{ id.TempLo }}
                      </p></b-card
                    >
                  </b-col>
                  <b-col>
                    <b-card class="cardTemp" no-body
                      ><p class="cardbody" v-if="id.TempHi != 'N/A'">
                        {{ id.TempHi }}&#8451;
                      </p>
                      <p class="cardbody" v-if="id.TempHi == 'N/A'">
                        {{ id.TempHi }}
                      </p>
                    </b-card>
                  </b-col>
                  <b-col>
                    <b-card class="cardTemp" no-body
                      ><p class="cardbody" v-if="id.TempHi != 'N/A'">
                        {{ id.TempMed }}&#8451;
                      </p>
                      <p class="cardbody" v-if="id.TempHi == 'N/A'">
                        {{ id.TempMed }}
                      </p></b-card
                    >
                  </b-col>
                </b-row>
              </section>
              <section v-if="id.Multipipe == 'TRUE'">
                <b-card-group deck>
                  <b-card :header-bg-variant="id.Pipe1.variant">
                    <template #header>
                      Pipe A
                      <BIconArrowUpRightSquare
                        v-if="id.Pipe1.Trending == 'UP'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Up"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        v-if="id.Pipe1.Trending == 'DOWN'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Down"
                      >
                      </BIconArrowDownRightSquare>
                      <BIconDashSquare
                        v-if="id.Pipe1.Trending == 'STABLE'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Stable"
                      >
                      </BIconDashSquare>
                      <b-avatar-group class="right">
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Hot Feed'"
                          class="hoticon"
                          v-b-tooltip.hover
                          title="Hot Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          class="coldicon"
                          v-b-tooltip.hover
                          title="Cold Feed"
                          v-if="id.Pipe1.Feed == 'Cold Feed'"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Mixed Feed'"
                          class="mixedicon"
                          v-b-tooltip.hover
                          title="Mixed Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Return Feed'"
                          class="returnicon"
                          v-b-tooltip.hover
                          title="Return Pipe"
                          >R</b-avatar
                        >
                      </b-avatar-group>
                    </template>
                    <b-row
                      ><b-col
                        ><p class="cardheaddouble">Biofilm Risk</p></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col>
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '1'"
                          variant="success"
                          >Level 1</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '2'"
                          variant="warning"
                          >Level 2</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '3'"
                          variant="warning"
                          >Level 3</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '4'"
                          class="highRisk"
                          >Level 4</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '5'"
                          variant="danger"
                          >Level 5</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == 'NoBio'"
                          variant="info"
                          >No Data</b-badge
                        >
                      </b-col>
                    </b-row>
                    <b-row
                      ><b-col><p class="cardheaddouble">Min</p></b-col
                      ><b-col><p class="cardheaddouble">Max</p></b-col></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe1.TempLo == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempLo }}
                        </p>
                        <p
                          v-if="id.Pipe1.TempLo != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempLo }}c
                        </p> </b-col
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe1.TempHi == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempHi }}
                        </p>
                        <p
                          v-if="id.Pipe1.TempHi != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempHi }}c
                        </p></b-col
                      ></b-row
                    >
                  </b-card>
                  <b-card :header-bg-variant="id.Pipe2.variant">
                    <template #header>
                      Pipe B
                      <BIconArrowUpRightSquare
                        v-if="id.Pipe2.Trending == 'UP'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Up"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        v-if="id.Pipe2.Trending == 'DOWN'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Down"
                      >
                      </BIconArrowDownRightSquare>
                      <BIconDashSquare
                        v-if="id.Pipe2.Trending == 'STABLE'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Stable"
                      >
                      </BIconDashSquare>
                      <b-avatar-group class="right">
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Hot Feed'"
                          class="hoticon"
                          v-b-tooltip.hover
                          title="Hot Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          class="coldicon"
                          v-b-tooltip.hover
                          title="Cold Feed"
                          v-if="id.Pipe2.Feed == 'Cold Feed'"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Mixed Feed'"
                          class="mixedicon"
                          v-b-tooltip.hover
                          title="Mixed Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Return Feed'"
                          class="returnicon"
                          v-b-tooltip.hover
                          title="Return Pipe"
                          >R</b-avatar
                        >
                      </b-avatar-group>
                    </template>
                    <b-row
                      ><b-col
                        ><p class="cardheaddouble">Biofilm Risk</p></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><b-badge
                          v-if="id.Pipe2.PathogenRead == '1'"
                          variant="success"
                          >Level 1</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '2'"
                          variant="warning"
                          >Level 2</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '3'"
                          variant="warning"
                          >Level 3</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '4'"
                          class="highRisk"
                          >Level 4</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '5'"
                          variant="danger"
                          >Level 5</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == 'NoBio'"
                          variant="info"
                          >No Data</b-badge
                        ></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col><p class="cardheaddouble">Min</p></b-col
                      ><b-col><p class="cardheaddouble">Max</p></b-col></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><p
                          v-if="(id.Pipe2.TempLo = 'N/A')"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempLo }}
                        </p>
                        <p
                          v-if="id.Pipe2.TempLo != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempLo }}c
                        </p> </b-col
                      ><b-col class=""
                        ><p
                          v-if="(id.Pipe2.TempHi = 'N/A')"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempHi }}
                        </p>
                        <p
                          v-if="id.Pipe2.TempHi != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempHi }}c
                        </p></b-col
                      ></b-row
                    >
                  </b-card>
                </b-card-group>
              </section> -->
            <!-- </b-card> -->
          </b-card-group>
        </b-tab>
        <b-tab lazy v-if="screenWidth >= 1000" v-on:click="LoadC1Data([],'','','')">
          <template #title>
            <b-row>
              <b-col> C-1 Devices </b-col>
              <b-col>
                <b-avatar-group overlap="0.65">
                  <b-avatar variant="danger" rounded>{{
                    C1ExtHiCount
                  }}</b-avatar>
                  <b-avatar class="highRisk" rounded>{{ C1HiCount }}</b-avatar>
                  <b-avatar variant="warning" rounded>{{
                    C1ModCount
                  }}</b-avatar>
                  <b-avatar variant="success" rounded>{{
                    C1LowCount
                  }}</b-avatar>
                </b-avatar-group>
              </b-col>
            </b-row>
          </template>
          <b-card
            v-if="this.responseArray[0] == 'No Data'"
            border-variant="secondary"
            header="C-1 Devices"
            header-bg-variant="secondary"
            footer-bg-variant="info"
            header-text-variant="white"
            hide-footer
            align="center"
            style="margin-bottom: 1rem;"
          >
            <b-card-text>No data available</b-card-text>
            <b-card-text></b-card-text>
          </b-card>
          <b-card-group deck v-if="this.responseArray[0] != 'No Data'">
            <!-- GARY NEW NEW C1 TEST LAYOUT CARD INC BREACHES-->
            <b-card
              border-variant="dark"
              align="center"
              :header-bg-variant="id.variant"
              footer-tag="footer"
              v-for="(id, idx) in responseArray"
              :key="idx"
              class="ThreeWideRepeatDash"
            > 
            <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
              </template>
              <template #footer>
                <b-button block variant="light" @click="showboxdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.DeptFloor}}</p></b-col></b-row>
              <hr/>
               <b-row no-gutters>
                <!-- <b-col cols="1"></b-col> -->
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg </p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">1</p></b-col> -->
                <!-- <b-col align-self="center" cols="3"><p class="smalltag"><b-badge variant="secondary">TMV Cold In</b-badge></p></b-col> -->
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'"><b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    ><p class="smalltag"><b-badge :class=id.Probe1TagClass>{{id.Probe1Tag}}</b-badge></p></b-avatar></b-col>
                   <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                   v-if="id.Probe1Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                   v-if="id.Probe1Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active != 'TRUE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                   <b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    >
                </b-col>
              </b-row>
                        <b-row><b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
                          <b-col align-self="end"><b-progress :value="id.Probe1Bio" max=5 :variant="id.Probe1BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
                        </b-row>
                <hr/>
                    <b-row no-gutters>
                <!-- <b-col align-self="center" cols="1"><p class="newhead">2</p></b-col> -->
                <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>      
                  <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                    v-if="id.Probe2Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >

                  <b-avatar
                    v-if="id.Probe2Active != 'TRUE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active != 'TRUE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                </b-col>
                <b-col cols="2">
                  <b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe2Active == 'TRUE'"
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    >
                </b-col>
              </b-row>
                        <b-row><b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
                          <b-col align-self="center"><b-progress :value="id.Probe2Bio" max=5 :variant="id.Probe2BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
                        </b-row>

                <hr/>

              </b-card>
            <!-- GARY NEW NEW C1 TEST LAYOUT CARD INC BREACHES END END END-->
            <!-- <b-card
              border-variant="dark"
              align="center"
              :header-bg-variant="id.variant"
              footer-tag="footer"
              v-for="(id, idx) in responseArray"
              :key="idx"
              class="ThreeWideRepeatDash"
            > -->
              <!-- <span class="C1DashSubHeadText">
                {{ id.DeptFloor }} <br />
                {{ id.Position }}
              </span> -->
              <!-- <span class="C1DashSubHeadText">
                {{ getNewName(id.DeviceID, "CL") }} <br />
              </span> -->

              <!-- <b-row>{{ id.DeviceID }} </b-row> -->
              <!-- <template #header> -->
                <!-- <b-row>
                  <b-col cols="10"
                    ><h4 class="left">
                      {{ getNewName(id.DeviceID, "CL") }}
                    </h4></b-col
                  >
                  <b-col cols="2"
                    ><BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Up"
                    ></BIconArrowUpRightSquare>
                    <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Down"
                    >
                    </BIconArrowDownRightSquare>
                    <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Stable"
                    >
                    </BIconDashSquare
                  ></b-col>
                </b-row> -->
                <!-- <b-row><b-col cols="10"><h6 class="left">{{id.DeptFloor}}</h6></b-col></b-row>
                <b-row><b-col cols="10"><h6 class="left">{{id.Position}}</h6></b-col><b-col cols="2"
                    ><BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Up"
                    ></BIconArrowUpRightSquare>
                    <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Down"
                    >
                    </BIconArrowDownRightSquare>
                    <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Stable"
                    >
                    </BIconDashSquare
                  ></b-col></b-row>
                <b-row>
                  <b-col cols="12"
                    ><b-avatar
                      v-if="id.DeviceOnline == 'TRUE'"
                      v-b-tooltip.hover
                      title="Online"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar>
                    <b-avatar
                      v-if="id.Healthcare == 'TRUE'"
                      v-b-tooltip.hover
                      title="Healthcare"
                      class="healthicon"
                    >
                      H</b-avatar
                    >
                    <b-avatar
                      v-if="id.type == 'double'"
                      class="MultiplePipe"
                      v-b-tooltip.hover
                      title="Double Pipe"
                      ><BIconShare></BIconShare
                    ></b-avatar>
                    <b-avatar
                      v-if="id.Outdoor == 'TRUE'"
                      class="OutdoorIcon"
                      v-b-tooltip.hover
                      title="Outdoor"
                      ><BIconHouse></BIconHouse
                    ></b-avatar>
                    <b-avatar
                      v-if="id.Recirculatory == 'TRUE'"
                      class="RecirculatoryIcon"
                      v-b-tooltip.hover
                      title="Recirculatory"
                      ><BIconArrowDownUp></BIconArrowDownUp
                    ></b-avatar>
                    <b-avatar
                      v-if="(id.Feed == 'Hot Feed') & (id.type == 'Single')"
                      class="hoticon"
                      v-b-tooltip.hover
                      title="Hot Feed"
                    >
                      <BIconDropletHalf></BIconDropletHalf>
                    </b-avatar>
                    <b-avatar
                      class="coldicon"
                      v-b-tooltip.hover
                      title="Cold Feed"
                      v-if="(id.Feed == 'Cold Feed') & (id.type == 'Single')"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      v-if="(id.Feed == 'Mixed Feed') & (id.type == 'Single')"
                      class="mixedicon"
                      v-b-tooltip.hover
                      title="Mixed Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      v-if="(id.Feed == 'Return Feed') & (id.type == 'Single')"
                      class="returnicon"
                      v-b-tooltip.hover
                      title="Return Pipe"
                      >R</b-avatar
                    >
                  </b-col>
                </b-row>
              </template>
              <template #footer>
                <b-button block variant="light" @click="showboxdetails(id)"
                  >Details</b-button
                >
              </template>
              <section v-if="id.Multipipe == 'FALSE'"> -->
                <!-- <b-row
                  ><b-col><p class="cardhead">Flow Event</p></b-col
                  ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
                >
                <b-row>
                  <b-card
                    ><p class="cardbody" v-if="id.FlowRead == 'N/A'">
                      {{ id.FlowRead }}
                    </p>
                    <p class="cardbody" v-if="id.FlowRead != 'N/A'">
                      {{ id.FlowRead }} hours ago
                    </p></b-card
                  ><b-card
                    ><p class="cardbody">
                      <b-badge v-if="id.PathogenRead == '1'" variant="success"
                        >Level 1</b-badge
                      >
                      <b-badge v-if="id.PathogenRead == '2'" variant="warning"
                        >Level 2</b-badge
                      >
                      <b-badge v-if="id.PathogenRead == '3'" variant="warning"
                        >Level 3</b-badge
                      >
                      <b-badge v-if="id.PathogenRead == '4'" class="highRisk"
                        >Level 4</b-badge
                      >
                      <b-badge v-if="id.PathogenRead == '5'" variant="danger"
                        >Level 5</b-badge
                      >
                      <b-badge v-if="id.PathogenRead == 'NoBio'" variant="info"
                        >No Data</b-badge
                      >
                    </p></b-card
                  ></b-row
                >
                <b-row
                  ><b-col><br /></b-col
                ></b-row>
                <b-row
                  ><b-col><p class="cardhead">Min</p></b-col
                  ><b-col><p class="cardhead">Max</p></b-col
                  ><b-col><p class="cardhead">Avg</p></b-col></b-row
                >
                <b-row
                  ><b-card class="cardTemp" no-body
                    ><p class="cardbody" v-if="id.TempLo != 'N/A'">
                      {{ id.TempLo }}&#8451;
                    </p>
                    <p class="cardbody" v-if="id.TempLo == 'N/A'">
                      {{ id.TempLo }}
                    </p></b-card
                  ><b-card class="cardTemp" no-body
                    ><p class="cardbody" v-if="id.TempHi != 'N/A'">
                      {{ id.TempHi }}&#8451;
                    </p>
                    <p class="cardbody" v-if="id.TempHi == 'N/A'">
                      {{ id.TempHi }}
                    </p> </b-card
                  ><b-card class="cardTemp" no-body
                    ><p class="cardbody" v-if="id.TempHi != 'N/A'">
                      {{ id.TempMed }}&#8451;
                    </p>
                    <p class="cardbody" v-if="id.TempHi == 'N/A'">
                      {{ id.TempMed }}
                    </p></b-card
                  ></b-row
                >
              </section>
              <section v-if="id.Multipipe == 'TRUE'">
                <b-card-group deck>
                  <b-card :header-bg-variant="id.Pipe1.variant">
                    <template #header>
                      Pipe A
                      <BIconArrowUpRightSquare
                        v-if="id.Pipe1.Trending == 'UP'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Up"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        v-if="id.Pipe1.Trending == 'DOWN'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Down"
                      >
                      </BIconArrowDownRightSquare>
                      <BIconDashSquare
                        v-if="id.Pipe1.Trending == 'STABLE'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Stable"
                      >
                      </BIconDashSquare>
                      <b-avatar-group class="right">
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Hot Feed'"
                          class="hoticon"
                          v-b-tooltip.hover
                          title="Hot Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          class="coldicon"
                          v-b-tooltip.hover
                          title="Cold Feed"
                          v-if="id.Pipe1.Feed == 'Cold Feed'"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Mixed Feed'"
                          class="mixedicon"
                          v-b-tooltip.hover
                          title="Mixed Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe1.Feed == 'Return Feed'"
                          class="returnicon"
                          v-b-tooltip.hover
                          title="Return Pipe"
                          >R</b-avatar
                        >
                      </b-avatar-group>
                    </template>
                    <b-row
                      ><b-col
                        ><p class="cardheaddouble">Biofilm Risk</p></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col>
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '1'"
                          variant="success"
                          >Level 1</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '2'"
                          variant="warning"
                          >Level 2</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '3'"
                          variant="warning"
                          >Level 3</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '4'"
                          class="highRisk"
                          >Level 4</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == '5'"
                          variant="danger"
                          >Level 5</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe1.PathogenRead == 'NoBio'"
                          variant="info"
                          >No Data</b-badge
                        >
                      </b-col>
                    </b-row>

                    <b-row
                      ><b-col><p class="cardheaddouble">Min</p></b-col
                      ><b-col><p class="cardheaddouble">Max</p></b-col></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe1.TempLo == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempLo }}
                        </p>
                        <p
                          v-if="id.Pipe1.TempLo != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempLo }}c
                        </p> </b-col
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe1.TempHi == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempHi }}
                        </p>
                        <p
                          v-if="id.Pipe1.TempHi != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe1.TempHi }}c
                        </p></b-col
                      ></b-row
                    >
                  </b-card>
                  <b-card :header-bg-variant="id.Pipe2.variant">
                    <template #header>
                      Pipe B
                      <BIconArrowUpRightSquare
                        v-if="id.Pipe2.Trending == 'UP'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Up"
                      ></BIconArrowUpRightSquare>
                      <BIconArrowDownRightSquare
                        v-if="id.Pipe2.Trending == 'DOWN'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Trending Down"
                      >
                      </BIconArrowDownRightSquare>
                      <BIconDashSquare
                        v-if="id.Pipe2.Trending == 'STABLE'"
                        font-scale="1"
                        v-b-tooltip.hover
                        title="Stable"
                      >
                      </BIconDashSquare>
                      <b-avatar-group class="right">
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Hot Feed'"
                          class="hoticon"
                          v-b-tooltip.hover
                          title="Hot Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          class="coldicon"
                          v-b-tooltip.hover
                          title="Cold Feed"
                          v-if="id.Pipe2.Feed == 'Cold Feed'"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Mixed Feed'"
                          class="mixedicon"
                          v-b-tooltip.hover
                          title="Mixed Feed"
                          ><BIconDropletHalf></BIconDropletHalf
                        ></b-avatar>
                        <b-avatar
                          v-if="id.Pipe2.Feed == 'Return Feed'"
                          class="returnicon"
                          v-b-tooltip.hover
                          title="Return Pipe"
                          >R</b-avatar
                        >
                      </b-avatar-group>
                    </template>
                    <b-row
                      ><b-col
                        ><p class="cardheaddouble">Biofilm Risk</p></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><b-badge
                          v-if="id.Pipe2.PathogenRead == '1'"
                          variant="success"
                          >Level 1</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '2'"
                          variant="warning"
                          >Level 2</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '3'"
                          variant="warning"
                          >Level 3</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '4'"
                          class="highRisk"
                          >Level 4</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == '5'"
                          variant="danger"
                          >Level 5</b-badge
                        >
                        <b-badge
                          v-if="id.Pipe2.PathogenRead == 'NoBio'"
                          variant="info"
                          >No Data</b-badge
                        ></b-col
                      ></b-row
                    >
                    <b-row
                      ><b-col><p class="cardheaddouble">Min</p></b-col
                      ><b-col><p class="cardheaddouble">Max</p></b-col></b-row
                    >
                    <b-row
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe2.TempLo == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempLo }}
                        </p>
                        <p
                          v-if="id.Pipe2.TempLo != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempLo }}c
                        </p> </b-col
                      ><b-col class=""
                        ><p
                          v-if="id.Pipe2.TempHi == 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempHi }}
                        </p>
                        <p
                          v-if="id.Pipe2.TempHi != 'N/A'"
                          class="doublereadings"
                        >
                          {{ id.Pipe2.TempHi }}c
                        </p></b-col
                      ></b-row
                    >
                  </b-card>
                </b-card-group>
              </section>
            </b-card> -->
          </b-card-group>
        </b-tab>
        <!--NEEDS LOOKED AT SMALL SCREEN SIZE SHOULD MATCH FORMATTING-->
        <!-- <b-tab lazy v-if="screenWidth < 1000" v-on:click="LoadO1Data([],'','','')">
          <template #title>
            <b-row>
              <h5 class="mx-auto">O-1 Devices</h5>
            </b-row>
            <b-row>
              <b-avatar-group overlap="0.65" class="mx-auto">
                <b-avatar variant="danger" rounded>{{ O1ExtHiCount }}</b-avatar>
                <b-avatar class="highRisk" rounded>{{ O1HiCount }}</b-avatar>
                <b-avatar variant="warning" rounded>{{ O1ModCount }}</b-avatar>
                <b-avatar variant="success" rounded>{{ O1LowCount }}</b-avatar>
              </b-avatar-group>
            </b-row>
          </template>

          <b-card-group deck>
            <b-card
              v-if="this.O1Array.length == 0"
              border-variant="secondary"
              header="O-1 Devices"
              header-bg-variant="secondary"
              footer-bg-variant="info"
              header-text-variant="white"
              hide-footer
              align="center"
              style="margin-bottom: 1rem;"
            >
              <b-card-text>No data available</b-card-text>
              <b-card-text></b-card-text>
            </b-card>

            <b-card
              border-variant="secondary"
              align="center"
              class="TwoWideRepeatDash"
              :header-bg-variant="id.HeaderVariant"
              header-text-variant="dark"
              v-for="(id, idx) in O1Array"
              :key="idx"
              footer-tag="footer"
              footer-bg-variant="light"
              no-body
            >
             <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
                
                
              </template>
                <template #footer>
                <b-button block variant="light" @click="showdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Department}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'">
                  <b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    >
                    <p class="smalltag"><b-badge :class=id.Probe1TagClass>{{id.Probe1Tag}}</b-badge></p>
                  </b-avatar>
                </b-col>
                 <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                   </b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col></b-row>
              <hr/>
              <b-row no-gutters>
               <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>
                  
                <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                   <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'TRUE'"
                      rounded
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4" v-if="id.Probe3Active == 'TRUE'"><b-avatar
                    :class=id.Probe3Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe3Title
                    ><p class="smalltag"><b-badge :class=id.Probe3TagClass>{{id.Probe3Tag}}</b-badge></p></b-avatar></b-col>
                    <b-col cols="4" v-if="id.Probe3Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe3Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe3TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe3Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col> 
                   <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    vvariant= "light"
                    >{{ id.Probe3MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                  <b-col cols="2">
                    <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    :class = "id.Probe3TempVariant"
                    >{{ id.Probe3AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe3Active == 'TRUE'"
                      :class="id.Probe3FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe3Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                 <b-col cols="4" v-if="id.Probe4Active == 'TRUE'"><b-avatar
                    :class=id.Probe4Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe4Title
                    ><p class="smalltag"><b-badge :class=id.Probe4TagClass>{{id.Probe4Tag}}</b-badge></p></b-avatar></b-col>
                <b-col cols="4" v-if="id.Probe4Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'TRUE'"
                    rounded
                    :class = "id.Probe4TempVariant"
                    >{{ id.Probe4AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe4Active == 'TRUE'"
                      :class="id.Probe4FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe4Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              </b-card>
          </b-card-group>
        </b-tab> -->
        <!-- <b-tab lazy v-if="screenWidth >= 1000" v-on:click="LoadO1Data([],'','','')">
          <template #title>
            <b-row>
              <b-col> O-1 Devices </b-col>
              <b-col>
                <b-avatar-group overlap="0.65">
                  <b-avatar variant="danger" rounded>{{
                    O1ExtHiCount
                  }}</b-avatar>
                  <b-avatar class="highRisk" rounded>{{ O1HiCount }}</b-avatar>
                  <b-avatar variant="warning" rounded>{{
                    O1ModCount
                  }}</b-avatar>
                  <b-avatar variant="success" rounded>{{
                    O1LowCount
                  }}</b-avatar>
                </b-avatar-group>
              </b-col>
            </b-row>
          </template>
          <b-card-group deck>
            <b-card
              v-if="this.O1Array.length == 0"
              border-variant="secondary"
              header="O-1 Devices"
              header-bg-variant="secondary"
              footer-bg-variant="info"
              header-text-variant="white"
              hide-footer
              align="center"
              style="margin-bottom: 1rem;"
            >
              <b-card-text>No data available</b-card-text>
              <b-card-text></b-card-text>
            </b-card>
              <b-card 
              border-variant="secondary"
              align="center"
              class="ThreeWideRepeatDash"
              :header-bg-variant="id.HeaderVariant"
              header-text-variant="dark"
              v-for="(id, idx) in O1Array"
              :key="idx"
              footer-tag="footer"
              footer-bg-variant="light"
              no-body>
              <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{getNewName(id.DeviceID,"CL")}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{id.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="2"><b-avatar
                      v-b-tooltip.hover
                      title="Online"
                      v-if="id.DeviceOnline == 'TRUE'"
                      size="1.5rem"
                      rounded
                      variant="success"
                      class="border"
                      ><BIconWifi></BIconWifi
                    ></b-avatar>
                    <b-avatar
                      v-if="id.DeviceOnline == 'FALSE'"
                      size="1.5rem"
                      v-b-tooltip.hover
                      title="Offline"
                      rounded
                      variant="secondary"
                      class="border"
                      ><BIconWifiOff></BIconWifiOff
                    ></b-avatar></b-col>
                     <b-col cols=2>
                    <b-avatar
                    v-if="id.Recirculatory == 'TRUE'"
                    size="1.5rem"
                    class="RecirculatoryIcon"
                    v-b-tooltip.hover
                    title="Recirculatory"
                    rounded
                    ><BIconArrowDownUp></BIconArrowDownUp
                  ></b-avatar>

                  </b-col>
                    <b-col cols="2">
                    <b-avatar v-b-tooltip.hover
                      title="STABLE"
                      size="1.5rem"
                      variant="light"
                      rounded> <BIconDashSquare
                      v-if="id.Trending == 'STABLE'"
                  />
                  <BIconArrowUpRightSquare
                      v-if="id.Trending == 'UP'"
                    />
                <BIconArrowDownRightSquare
                      v-if="id.Trending == 'DOWN'"
                    /></b-avatar></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
                
                
              </template>
                <template #footer>
                <b-button block variant="light" @click="showdetails(id)"
                  >Details</b-button
                >
              </template>
              <b-row><b-col><p class="CardSubHeader">{{id.Department}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{id.Location}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4"><p class="cardhead">Tag</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4" v-if="id.Probe1Active == 'TRUE'">
                  <b-avatar
                    :class=id.Probe1Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe1Title
                    >
                    <p class="smalltag"><b-badge :class=id.Probe1TagClass>{{id.Probe1Tag}}</b-badge></p>
                  </b-avatar>
                </b-col>
                 <b-col cols="4" v-if="id.Probe1Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar
                  ><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe1Active == 'TRUE'"
                    size="2.5em"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe1Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'TRUE'"
                    rounded
                    :class = "id.Probe1TempVariant"
                    >{{ id.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe1Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe1Active == 'TRUE'"
                      :class="id.Probe1FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe1Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col></b-row>
              <hr/>
              <b-row no-gutters>
               <b-col cols="4" v-if="id.Probe2Active == 'TRUE'"><b-avatar
                    :class=id.Probe2Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe2Title
                    ><p class="smalltag"><b-badge :class=id.Probe2TagClass>{{id.Probe2Tag}}</b-badge></p></b-avatar></b-col>
                  
                <b-col cols="4" v-if="id.Probe2Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                   <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                    v-if="id.Probe2Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe2MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe2Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'TRUE'"
                    rounded
                    :class = "id.Probe2TempVariant"
                    >{{ id.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe2Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'TRUE'"
                      rounded
                      :class="id.Probe2FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe2Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="4" v-if="id.Probe3Active == 'TRUE'"><b-avatar
                    :class=id.Probe3Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe3Title
                    ><p class="smalltag"><b-badge :class=id.Probe3TagClass>{{id.Probe3Tag}}</b-badge></p></b-avatar></b-col>
                    <b-col cols="4" v-if="id.Probe3Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                    <b-col cols="2"><b-avatar
                    v-if="id.Probe3Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe3TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe3Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col> 
                   <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    variant= "light"
                    >{{ id.Probe3MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                  <b-col cols="2">
                    <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'TRUE'"
                    rounded
                    :class = "id.Probe3TempVariant"
                    >{{ id.Probe3AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe3Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  >
                  </b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe3Active == 'TRUE'"
                      :class="id.Probe3FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe3Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              <b-row no-gutters>
                 <b-col cols="4" v-if="id.Probe4Active == 'TRUE'"><b-avatar
                    :class=id.Probe4Class
                    rounded
                    v-b-tooltip.hover
                    :title=id.Probe4Title
                    ><p class="smalltag"><b-badge :class=id.Probe4TagClass>{{id.Probe4Tag}}</b-badge></p></b-avatar></b-col>
                <b-col cols="4" v-if="id.Probe4Active != 'TRUE'"><b-avatar
                    class="lightbackicon"
                    rounded
                    v-b-tooltip.hover
                    title="No Feed"
                    ><p class="smalltag"><b-badge class="noicon">Inactive</b-badge></p></b-avatar></b-col>
                 
                <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4TempLimit }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                   <b-col cols="2"><b-avatar
                    v-if="id.Probe4Active == 'TRUE'"
                    size="2.5rem"
                    rounded
                    variant= "light"
                  >
                    {{ id.Probe4MinTemp }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    v-if="id.Probe4Active == 'FALSE'"
                    size="2.5em"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'TRUE'"
                    rounded
                    :class = "id.Probe4TempVariant"
                    >{{ id.Probe4AvgTempRounded }}<p class="small">&#8451;</p></b-avatar
                  >
                  <b-avatar
                    size="2.5em"
                    v-if="id.Probe4Active == 'FALSE'"
                    rounded
                    variant="light"
                    >--</b-avatar
                  ></b-col>
                <b-col cols="2"><b-avatar
                      size="2.5em"
                      rounded
                      v-if="id.Probe4Active == 'TRUE'"
                      :class="id.Probe4FlowVariant"
                      ><BIconWater font-scale="1.5"></BIconWater
                    ></b-avatar>
                    <b-avatar
                      size="2.5em"
                      v-if="id.Probe4Active == 'FALSE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col>
              </b-row>
              <hr/>
              </b-card>
          </b-card-group>
        </b-tab> -->
      </b-tabs>
      <br/>
    <p class="disclaimer"> <strong>Important:</strong> This dashboard presents pipe surface temperature data and derived metrics produced by an automated monitoring instrument.
    Data and metrics are provided to support the Responsible Person and their appointed competent person.
    This display does not constitute a compliance assessment, a risk assessment, or professional advice.
    Determination of compliance with ACOP L8, HSG274, HTM&nbsp;04-01, or any other applicable regulation is at all times
    the responsibility of the Responsible Person and their appointed competent person.</p>
    </div>
    <b-modal
      ref="FurtherDeviceDetail"
      id="FurtherDeviceDetail"
      title="Device Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
      <DetailData> </DetailData>
    </b-modal>
    <b-modal
      ref="O1DetailsModal"
      id="O1DetailsModal"
      title="O-1 Device Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
    <!-- GARY NEW NEW BREACH TEST DETAILS CARD-->
    <b-card border-variant="secondary"
        align="center"
        :header-bg-variant="furtherDeviceInfo.HeaderVariant"
        header-text-variant="dark">
        <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{furtherDeviceInfo.HumanName}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{furtherDeviceInfo.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="3">Trend: </b-col>
                     <b-col cols="3"><BIconArrowUpRightSquare
                      v-if="furtherDeviceInfo.Trending == 'UP'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Up"
                    ></BIconArrowUpRightSquare>
                    <BIconArrowDownRightSquare
                      v-if="furtherDeviceInfo.Trending == 'DOWN'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Down"
                    >
                    </BIconArrowDownRightSquare>
                    <BIconDashSquare
                      v-if="furtherDeviceInfo.Trending == 'STABLE'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Stable"
                    >
                    </BIconDashSquare
                  ></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
              </template>
               <b-row><b-col><p class="CardSubHeader">{{furtherDeviceInfo.Department}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{furtherDeviceInfo.Location}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
              </b-row>
              <hr/>
               <b-card
          :header-bg-variant="furtherDeviceInfo.Probe1ScoreVariant"
          align="center"
          no-body
          ><template #header>
            <b-row>
              <b-col>Probe 1</b-col>
              <b-col v-if="furtherDeviceInfo.Probe1Active == 'TRUE'">{{furtherDeviceInfo.Probe1Tag}}</b-col>
              <b-col v-if="furtherDeviceInfo.Probe1Active != 'TRUE'">Inactive</b-col></b-row></template>
            <b-row no-gutters align-v="center">
            <b-col cols="2" align-self="center">
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                :class=furtherDeviceInfo.Probe1TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=furtherDeviceInfo.Probe1Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
             
              <b-avatar 
                v-if="furtherDeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe1MinTemp }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                rounded
                :class = "furtherDeviceInfo.Probe1TempVariant"
                >{{ furtherDeviceInfo.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe1Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
             <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe1FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe1Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe1TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe1Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe1TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe1TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe1Active != 'TRUE'
              "
              >N/A</b-col>
              </b-row>
          </b-card>
          <br/>
               <b-card
          :header-bg-variant="furtherDeviceInfo.Probe2ScoreVariant"
          align="center"
          no-body
          ><template #header>
            <b-row>
              <b-col>Probe 2</b-col>
              <b-col v-if="furtherDeviceInfo.Probe2Active == 'TRUE'">{{furtherDeviceInfo.Probe2Tag}}</b-col>
              <b-col v-if="furtherDeviceInfo.Probe2Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
            <b-row no-gutters align-v="center">
            <b-col cols="2" align-self="center"
              >     <b-avatar
              v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                :class=furtherDeviceInfo.Probe2TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=furtherDeviceInfo.Probe2Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                 <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{furtherDeviceInfo.Probe2MinTemp}}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                rounded
                :class = "furtherDeviceInfo.Probe2TempVariant"
                >{{ furtherDeviceInfo.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe2Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
             <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe2FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe2Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe2TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe2Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe2TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe2TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe2Active != 'TRUE'
              "
              >N/A</b-col>
              </b-row>
          </b-card>
          <br/>
               <b-card
          :header-bg-variant="furtherDeviceInfo.Probe3ScoreVariant"
          align="center"
          no-body
          ><template #header>
            <b-row>
              <b-col>Probe 3</b-col>
              <b-col v-if="furtherDeviceInfo.Probe3Active == 'TRUE'">{{furtherDeviceInfo.Probe3Tag}}</b-col>
              <b-col v-if="furtherDeviceInfo.Probe3Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
            <b-row no-gutters align-v="center">
            <b-col cols="2" align-self="center"
              >
                   <b-avatar
                   v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                :class=furtherDeviceInfo.Probe3TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=furtherDeviceInfo.Probe3Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe3TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                 <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe3MinTemp }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                rounded
                :class = "furtherDeviceInfo.Probe3TempVariant"
                >{{ furtherDeviceInfo.Probe3AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe3Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
             <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe3FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe3Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe3TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe3Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe3TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe3TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe3Active != 'TRUE'
              "
              >N/A</b-col>
              </b-row>
          </b-card>
          <br/>
               <b-card
          :header-bg-variant="furtherDeviceInfo.Probe4ScoreVariant"
          align="center"
          no-body
          ><template #header>
            <b-row>
              <b-col>Probe 4</b-col>
              <b-col v-if="furtherDeviceInfo.Probe4Active == 'TRUE'">{{furtherDeviceInfo.Probe4Tag}}</b-col>
              <b-col v-if="furtherDeviceInfo.Probe4Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
            <b-row no-gutters align-v="center">
            <b-col cols="2" align-self="center">
                   <b-avatar
                   v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                :class=furtherDeviceInfo.Probe4TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=furtherDeviceInfo.Probe4Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
               <b-avatar
                v-if="furtherDeviceInfo.Probe4Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ furtherDeviceInfo.Probe4TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{furtherDeviceInfo.Probe4MinTemp}}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                rounded
                :class = "furtherDeviceInfo.Probe4TempVariant"
                >{{ furtherDeviceInfo.Probe4AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe4Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
             <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe4FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe4Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe4TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe4Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe4TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                furtherDeviceInfo.Probe4TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe4Active != 'TRUE'
              "
              >N/A</b-col>
              </b-row>
          </b-card>
    </b-card>
    <!--GARY NEW NEW BREACH TEST DETAILS CARD END END END-->
      <!-- <b-card
        border-variant="secondary"
        align="center"
        :header-bg-variant="furtherDeviceInfo.HeaderVariant"
        header-text-variant="dark"
      >
        <template #header>
          <b-row>
            <b-col cols="10"
              ><h5 class="left">
                {{ furtherDeviceInfo.HumanName }}
              </h5></b-col
            >
            <b-col cols="2"
              ><BIconArrowUpRightSquare
                v-if="furtherDeviceInfo.Trending == 'UP'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Trending Up"
              ></BIconArrowUpRightSquare>
              <BIconArrowDownRightSquare
                v-if="furtherDeviceInfo.Trending == 'DOWN'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Trending Down"
              >
              </BIconArrowDownRightSquare>
              <BIconDashSquare
                v-if="furtherDeviceInfo.Trending == 'STABLE'"
                font-scale="1.5"
                v-b-tooltip.hover
                title="Stable"
              >
              </BIconDashSquare
            ></b-col>
          </b-row>
        </template>
        <b-card-sub-title class="mb-2">
          {{ furtherDeviceInfo.Department }} <br />
          {{ furtherDeviceInfo.Location }}
        </b-card-sub-title>
        <hr />
        <b-row no-gutters>
          <b-col cols="1"></b-col>
          <b-col cols="2"><p class="cardhead">Feed</p></b-col>
          <b-col cols="2"><p class="cardhead">Max/Min</p></b-col>
          <b-col cols="2"><p class="cardhead">Avg</p></b-col>
          <b-col cols="2"><p class="cardhead">Flow</p></b-col>
          <b-col cols="3"><p class="cardhead">Last Flow</p></b-col>
        </b-row>
        <hr /> -->
        <!-- {{ furtherDeviceInfo.Probe1ScoreVariant }}
        {{ furtherDeviceInfo.Probe2ScoreVariant }} -->
        <!-- <b-card
          :header-bg-variant="furtherDeviceInfo.Probe1ScoreVariant"
          align="center"
          no-body
          ><template #header>Probe 1</template>
          <b-row no-gutters align-v="center">
            <b-col cols="1" align-self="center"><p class="newhead"></p></b-col>
            <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe1Feed == 'Cold Feed') &
                    (furtherDeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe1Feed == 'Hot Feed') &
                    (furtherDeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe1Feed == 'Mixed Feed') &
                    (furtherDeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe1Feed == 'Return Feed') &
                    (furtherDeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                :class="furtherDeviceInfo.Probe1TempVariant"
              >
                {{ furtherDeviceInfo.Probe1TempLimit }}&#8451;</b-avatar
              >

              <b-avatar
                v-if="furtherDeviceInfo.Probe1Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                rounded
                variant="secondary"
                >{{ furtherDeviceInfo.Probe1AvgTempRounded }}&#8451;</b-avatar
              >
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe1Active == 'FALSE'"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><span class="FlowIconRight">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe1Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe1FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe1Active == 'FALSE'"
                  rounded
                  variant="light"
                  >--</b-avatar
                >
              </span></b-col
            >

            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe1TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe1Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe1TimeSinceLastFlow }} hours</b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe1TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe1Active == 'FALSE'
              "
              >N/A</b-col
            >
          </b-row></b-card
        >
        <br />
        <b-card
          :header-bg-variant="furtherDeviceInfo.Probe2ScoreVariant"
          align="center"
          no-body
          ><template #header>Probe 2</template>
          <b-row no-gutters align-v="center">
            <b-col cols="1" align-self="center"><p class="newhead"></p></b-col>
            <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe2Feed == 'Cold Feed') &
                    (furtherDeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe2Feed == 'Hot Feed') &
                    (furtherDeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe2Feed == 'Mixed Feed') &
                    (furtherDeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe2Feed == 'Return Feed') &
                    (furtherDeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="furtherDeviceInfo.Probe2Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                :class="furtherDeviceInfo.Probe2TempVariant"
              >
                {{ furtherDeviceInfo.Probe2TempLimit }}&#8451;</b-avatar
              >

              <b-avatar
                v-if="furtherDeviceInfo.Probe2Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                rounded
                variant="secondary"
                >{{ furtherDeviceInfo.Probe2AvgTempRounded }}&#8451;</b-avatar
              >
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe2Active == 'FALSE'"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><span class="FlowIconRight">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe2Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe2FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe2Active == 'FALSE'"
                  rounded
                  variant="light"
                  >--</b-avatar
                >
              </span></b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe2TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe2Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe2TimeSinceLastFlow }} hours</b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe2TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe2Active == 'FALSE'
              "
              >N/A</b-col
            >
          </b-row></b-card
        >
        <br />
        <b-card
          :header-bg-variant="furtherDeviceInfo.Probe3ScoreVariant"
          align="center"
          no-body
          ><template #header>Probe 3</template>
          <b-row no-gutters align-v="center">
            <b-col cols="1" align-self="center"><p class="newhead"></p></b-col>
            <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe3Feed == 'Cold Feed') &
                    (furtherDeviceInfo.Probe3Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe3Feed == 'Hot Feed') &
                    (furtherDeviceInfo.Probe3Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe3Feed == 'Mixed Feed') &
                    (furtherDeviceInfo.Probe3Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe3Feed == 'Return Feed') &
                    (furtherDeviceInfo.Probe3Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="furtherDeviceInfo.Probe3Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                size="2.5rem"
                rounded
                :class="furtherDeviceInfo.Probe3TempVariant"
              >
                {{ furtherDeviceInfo.Probe3TempLimit }}&#8451;</b-avatar
              >

              <b-avatar
                v-if="furtherDeviceInfo.Probe3Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                rounded
                variant="secondary"
                >{{ furtherDeviceInfo.Probe3AvgTempRounded }}&#8451;</b-avatar
              >
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe3Active == 'FALSE'"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><span class="FlowIconRight">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe3Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe3FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe3Active == 'FALSE'"
                  rounded
                  variant="light"
                  >--</b-avatar
                >
              </span></b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe3TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe3Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe3TimeSinceLastFlow }} hours</b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe3TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe3Active == 'FALSE'
              "
              >N/A</b-col
            >
          </b-row></b-card
        >
        <br />
        <b-card
          :header-bg-variant="furtherDeviceInfo.Probe4ScoreVariant"
          align="center"
          no-body
          ><template #header>Probe 4</template>
          <b-row no-gutters align-v="center">
            <b-col cols="1" align-self="center"><p class="newhead"></p></b-col>
            <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe4Feed == 'Cold Feed') &
                    (furtherDeviceInfo.Probe4Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe4Feed == 'Hot Feed') &
                    (furtherDeviceInfo.Probe4Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe4Feed == 'Mixed Feed') &
                    (furtherDeviceInfo.Probe4Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (furtherDeviceInfo.Probe4Feed == 'Return Feed') &
                    (furtherDeviceInfo.Probe4Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="furtherDeviceInfo.Probe4Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2">
              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                size="2.5rem"
                rounded
                :class="furtherDeviceInfo.Probe4TempVariant"
              >
                {{ furtherDeviceInfo.Probe4TempLimit }}&#8451;</b-avatar
              >

              <b-avatar
                v-if="furtherDeviceInfo.Probe4Active == 'FALSE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                rounded
                variant="secondary"
                >{{ furtherDeviceInfo.Probe4AvgTempRounded }}&#8451;</b-avatar
              >
              <b-avatar
                size="2.5em"
                v-if="furtherDeviceInfo.Probe4Active == 'FALSE'"
                rounded
                variant="light"
                >--</b-avatar
              ></b-col
            >
            <b-col cols="2"
              ><span class="FlowIconRight">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="furtherDeviceInfo.Probe4Active == 'TRUE'"
                  :class="furtherDeviceInfo.Probe4FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="furtherDeviceInfo.Probe4Active == 'FALSE'"
                  rounded
                  variant="light"
                  >--</b-avatar
                >
              </span></b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe4TimeSinceLastFlow != 'N/A' &&
                  furtherDeviceInfo.Probe4Active == 'TRUE'
              "
              >{{ furtherDeviceInfo.Probe4TimeSinceLastFlow }} hours</b-col
            >
            <b-col
              cols="3"
              v-if="
                furtherDeviceInfo.Probe4TimeSinceLastFlow == 'N/A' ||
                  furtherDeviceInfo.Probe4Active == 'FALSE'
              "
              >N/A</b-col
            >
          </b-row></b-card
        >
        <br />
      </b-card> -->
      <br />
      <b-card border-variant="" footer-tag="footer">
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="left"
          v-b-tooltip.hover
          title="Notes"
          @click="
            fetchNotes(furtherDeviceInfo.DeviceID, furtherDeviceInfo.HumanName)
          "
          ><BIconFileEarmarkMedical></BIconFileEarmarkMedical
        ></b-avatar>
        <b-avatar
          button
          rounded
          variant="outline-info"
          v-b-tooltip.hover
          v-if="!this.UserProfile.includes('CLI')"
          title="Calibrate"
          v-on:click="showCALWizard(furtherDeviceInfo.DeviceID,'O1')"
          ><BIconWrench></BIconWrench
        ></b-avatar>
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="right"
          v-b-tooltip.hover
          title="File Upload"
          @click="deviceFileUpload('O-1')"
          ><BIconCloudUpload></BIconCloudUpload
        ></b-avatar>
        <template #footer>
          <b-row
            ><b-col
              ><b-button
                block
                variant="outline-info"
                size="sm"
                @click="
                  showFurtherDetail(
                    furtherDeviceInfo.DeviceID,
                    furtherDeviceInfo.HumanName,
                    'O-1'
                  )
                "
                >Device Details</b-button
              ></b-col
            >
            <b-col
              ><b-button
                block
                size="sm"
                variant="outline-info"
                v-on:click="DeviceReportGen(furtherDeviceInfo.DeviceID, 'O-1')"
                >Trend Reports</b-button
              ></b-col
            >
          </b-row>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      ref="BoxDetailsModal"
      id="BoxDetailsModal"
      title="C-1 Device Details"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
    >
    <!--GARY TEST DETAILS C1 INC BREACHES NEW NEW NEW-->
    <b-card border-variant="dark"
          align="center"
          :header-bg-variant="this.c1DeviceInfo.variant"
          footer-tag="footer">
      <template #header>
                <b-row>
                  <b-col cols="6"><p class="CardHeader">{{c1DeviceInfo.HumanName}}</p></b-col>
                  <b-col class="breachcol" cols="3" align="right"><BIconExclamationTriangleFill font-scale="2" variant="warning"></BIconExclamationTriangleFill></b-col><b-col cols="3" class="breachcol"><h4><b-badge variant = "warning">{{c1DeviceInfo.Breaches}}</b-badge></h4></b-col>
                  </b-row>
                <b-row>
                  <b-col cols="3">Trend: </b-col>
                     <b-col cols="3"><BIconArrowUpRightSquare
                      v-if="c1DeviceInfo.Trending == 'UP'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Up"
                    ></BIconArrowUpRightSquare>
                    <BIconArrowDownRightSquare
                      v-if="c1DeviceInfo.Trending == 'DOWN'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Trending Down"
                    >
                    </BIconArrowDownRightSquare>
                    <BIconDashSquare
                      v-if="c1DeviceInfo.Trending == 'STABLE'"
                      font-scale="1.5"
                      v-b-tooltip.hover
                      title="Stable"
                    >
                    </BIconDashSquare
                  ></b-col>
                   <b-col class="breachcol" cols="6">Current Breaches</b-col>
                  </b-row>
              </template>
               <b-row><b-col><p class="CardSubHeader">{{c1DeviceInfo.DeptFloor}}</p></b-col></b-row>
              <b-row><b-col><p class="CardSubHeader">{{c1DeviceInfo.Position}}</p></b-col></b-row>
              <hr/>
              <b-row no-gutters>
                <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead" v-b-popover.hover.top="'Risk colours based on avg temperatures against pathogen growth parameters'" title="Risk Level">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
              </b-row>
              <hr/>
              <b-card
              :header-bg-variant="c1DeviceInfo.Probe1ScoreVariant"
              align="center"
              no-body
              ><template #header>
            <b-row>
              <b-col>Probe 1</b-col>
              <b-col v-if="c1DeviceInfo.Probe1Active == 'TRUE'">{{c1DeviceInfo.Probe1Tag}}</b-col>
              <b-col v-if="c1DeviceInfo.Probe1Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
            <b-row no-gutters align-v="center">
                <b-col cols="2" align-self="center">
                   <b-avatar
                  v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                :class=c1DeviceInfo.Probe1TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=c1DeviceInfo.Probe1Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
             <b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ c1DeviceInfo.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{c1DeviceInfo.Probe1MinTemp}}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                rounded
                :class = "c1DeviceInfo.Probe1TempVariant"
                >{{ c1DeviceInfo.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                  :class="c1DeviceInfo.Probe1FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
              <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe1TimeSinceLastFlow != 'N/A' &&
                  c1DeviceInfo.Probe1Active == 'TRUE'
              "
              >{{ c1DeviceInfo.Probe1TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe1TimeSinceLastFlow == 'N/A' ||
                  c1DeviceInfo.Probe1Active != 'TRUE'
              "
              >N/A</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
              <b-col align-self="center"><b-progress :value="c1DeviceInfo.Probe1Bio" max=5 :variant="c1DeviceInfo.Probe1BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
            </b-row>
              </b-card>
              <br/>
              <b-card
              :header-bg-variant="c1DeviceInfo.Probe2ScoreVariant"
              align="center"
              no-body
              ><template #header>
            <b-row>
              <b-col>Probe 2</b-col>
              <b-col v-if="c1DeviceInfo.Probe2Active == 'TRUE'">{{c1DeviceInfo.Probe2Tag}}</b-col>
              <b-col v-if="c1DeviceInfo.Probe2Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
               <b-row no-gutters align-v="center">
              <b-col cols="2" align-self="center">
                  <b-avatar
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                :class=c1DeviceInfo.Probe2TagClass
                size="2.5rem"
                rounded
                v-b-tooltip.hover
                :title=c1DeviceInfo.Probe2Title
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{ c1DeviceInfo.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant= "light"
              >
                {{c1DeviceInfo.Probe2MinTemp}}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                rounded
                :class = "c1DeviceInfo.Probe2TempVariant"
                >{{ c1DeviceInfo.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
                   <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                  :class="c1DeviceInfo.Probe2FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
              <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe2TimeSinceLastFlow != 'N/A' &&
                  c1DeviceInfo.Probe2Active == 'TRUE'
              "
              >{{ c1DeviceInfo.Probe2TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe2TimeSinceLastFlow == 'N/A' ||
                  c1DeviceInfo.Probe2Active != 'TRUE'
              "
              >N/A</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
              <b-col align-self="center"><b-progress :value="c1DeviceInfo.Probe2Bio" max=5 :variant="c1DeviceInfo.Probe2BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
            </b-row>
              </b-card>
    </b-card>
    <!--GARY TEST DETAIL C1 INC BREACHES END END END-->
      <!-- <b-card-group>
        <b-card
          border-variant="dark"
          align="center"
          :header-bg-variant="this.c1DeviceInfo.variant"
          footer-tag="footer"
          v-if="this.c1DeviceInfo.type != 'double'"
        >
          <b-card-sub-title class="mb-2">
            {{ c1DeviceInfo.DeptFloor }} <br />{{
              c1DeviceInfo.Position
            }}</b-card-sub-title
          >
          <b-row></b-row>
          <template #header>
            <h4 class="left">{{ c1DeviceInfo.HumanName }}</h4>
            <BIconArrowUpRightSquare
              v-if="c1DeviceInfo.Trending == 'UP'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Trending Up"
            ></BIconArrowUpRightSquare>
            <BIconArrowDownRightSquare
              v-if="c1DeviceInfo.Trending == 'DOWN'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Trending Down"
            >
            </BIconArrowDownRightSquare>
            <BIconDashSquare
              v-if="c1DeviceInfo.Trending == 'STABLE'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Stable"
            >
            </BIconDashSquare>
            <b-avatar-group class="right">
              <b-avatar
                v-if="c1DeviceInfo.Healthcare == 'TRUE'"
                class="HealthcareIcon"
                v-b-tooltip.hover
                title="Healthcare"
                ><BIconPlusCircle></BIconPlusCircle
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Outdoor == 'TRUE'"
                class="OutdoorIcon"
                v-b-tooltip.hover
                title="Outdoor"
                ><BIconHouse></BIconHouse
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Recirculatory == 'TRUE'"
                class="RecirculatoryIcon"
                v-b-tooltip.hover
                title="Recirculatory"
                ><BIconArrowDownUp></BIconArrowDownUp
              ></b-avatar>
              <b-avatar
                v-if="
                  (c1DeviceInfo.Feed == 'Hot Feed') &
                    (c1DeviceInfo.type == 'Single')
                "
                class="hoticon"
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="coldicon"
                v-b-tooltip.hover
                title="Cold Feed"
                v-if="
                  (c1DeviceInfo.Feed == 'Cold Feed') &
                    (c1DeviceInfo.type == 'Single')
                "
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="
                  (c1DeviceInfo.Feed == 'Mixed Feed') &
                    (c1DeviceInfo.type == 'Single')
                "
                class="mixedicon"
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="
                  (c1DeviceInfo.Feed == 'Return Feed') &
                    (c1DeviceInfo.type == 'Single')
                "
                class="returnicon"
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              >
            </b-avatar-group>
          </template>
          <b-row
            ><b-col><p class="cardhead">Flow Event</p></b-col
            ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
          >
          <b-row>
            <b-col
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.FlowRead != 'N/A'">
                  {{ c1DeviceInfo.FlowRead }} hours ago
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.FlowRead == 'N/A'">
                  {{ c1DeviceInfo.FlowRead }}
                </p>
              </b-card></b-col
            >
            <b-col
              ><b-card
                ><p class="cardbody">
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == '1'"
                    variant="success"
                    >Level 1</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == '2'"
                    variant="warning"
                    >Level 2</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == '3'"
                    variant="warning"
                    >Level 3</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == '4'"
                    class="highRisk"
                    >Level 4</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == '5'"
                    variant="danger"
                    >Level 5</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.PathogenRead == 'NoBio'"
                    variant="info"
                    >No Data</b-badge
                  >
                </p></b-card
              ></b-col
            ></b-row
          >
          <b-row
            ><b-col><br /></b-col
          ></b-row>
          <b-row
            ><b-col><p class="cardhead">Min</p></b-col
            ><b-col><p class="cardhead">Max</p></b-col
            ><b-col><p class="cardhead">Avg</p></b-col></b-row
          >
          <b-row
            ><b-col class=""
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.TempLo == 'N/A'">
                  {{ c1DeviceInfo.TempLo }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.TempLo != 'N/A'">
                  {{ c1DeviceInfo.TempLo }}&#8451;
                </p>
              </b-card></b-col
            ><b-col class=""
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.TempHi == 'N/A'">
                  {{ c1DeviceInfo.TempHi }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.TempHi != 'N/A'">
                  {{ c1DeviceInfo.TempHi }}&#8451;
                </p></b-card
              ></b-col
            ><b-col class=""
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.TempMed == 'N/A'">
                  {{ c1DeviceInfo.TempMed }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.TempMed != 'N/A'">
                  {{ c1DeviceInfo.TempMed }}&#8451;
                </p></b-card
              ></b-col
            ></b-row
          >
        </b-card>
        <b-card
          border-variant="dark"
          align="center"
          :header-bg-variant="c1DeviceInfo.Pipe1.variant"
          footer-tag="footer"
          v-if="this.c1DeviceInfo.type == 'double'"
        >
          <b-card-sub-title class="mb-2">{{
            c1DeviceInfo.Position
          }}</b-card-sub-title>
          <b-row></b-row>
          <template #header>
            <h4 class="left">
              {{ getNewName(c1DeviceInfo.DeviceID, "CL") }} Pipe A
            </h4>
            <BIconArrowUpRightSquare
              v-if="c1DeviceInfo.Pipe1.Trending == 'UP'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Trending Up"
            ></BIconArrowUpRightSquare>
            <BIconArrowDownRightSquare
              v-if="c1DeviceInfo.Pipe1.Trending == 'DOWN'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Trending Down"
            >
            </BIconArrowDownRightSquare>
            <BIconDashSquare
              v-if="c1DeviceInfo.Pipe1.Trending == 'STABLE'"
              font-scale="1.5"
              v-b-tooltip.hover
              title="Stable"
            >
            </BIconDashSquare>
            <b-avatar-group class="right">
              <b-avatar
                v-if="c1DeviceInfo.Healthcare == 'TRUE'"
                class="HealthcareIcon"
                v-b-tooltip.hover
                title="Healthcare"
                ><BIconPlusCircle></BIconPlusCircle
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Outdoor == 'TRUE'"
                class="OutdoorIcon"
                v-b-tooltip.hover
                title="Outdoor"
                ><BIconHouse></BIconHouse
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Recirculatory == 'TRUE'"
                class="RecirculatoryIcon"
                v-b-tooltip.hover
                title="Recirculatory"
                ><BIconArrowDownUp></BIconArrowDownUp
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Pipe1.Feed == 'Hot Feed'"
                class="hoticon"
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="coldicon"
                v-b-tooltip.hover
                title="Cold Feed"
                v-if="c1DeviceInfo.Pipe1.Feed == 'Cold Feed'"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Pipe1.Feed == 'Mixed Feed'"
                class="mixedicon"
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Pipe1.Feed == 'Return Feed'"
                class="returnicon"
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              >
            </b-avatar-group>
          </template>
          <b-row
            ><b-col><p class="cardhead">Flow Event</p></b-col
            ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
          >
          <b-row
            ><b-col class=""
              ><b-card
                ><p
                  class="cardbody"
                  v-if="c1DeviceInfo.Pipe1.FlowRead != 'N/A'"
                >
                  {{ c1DeviceInfo.Pipe1.FlowRead }} hours ago
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.Pipe1.FlowRead == 'N/A'">
                  {{ c1DeviceInfo.Pipe1.FlowRead }}
                </p>
              </b-card></b-col
            ><b-col
              ><b-card
                ><p class="cardbody">
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == '1'"
                    variant="success"
                    >Level 1</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == '2'"
                    variant="warning"
                    >Level 2</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == '3'"
                    variant="warning"
                    >Level 3</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == '4'"
                    class="highRisk"
                    >Level 4</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == '5'"
                    variant="danger"
                    >Level 5</b-badge
                  >
                  <b-badge
                    v-if="c1DeviceInfo.Pipe1.PathogenRead == 'NoBio'"
                    variant="info"
                    >No Data</b-badge
                  >
                </p></b-card
              ></b-col
            ></b-row
          >
          <b-row
            ><b-col><br /></b-col
          ></b-row>
          <b-row
            ><b-col><p class="cardhead">Min</p></b-col
            ><b-col><p class="cardhead">Max</p></b-col
            ><b-col><p class="cardhead">Avg</p></b-col></b-row
          >
          <b-row
            ><b-col
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempLo == 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempLo }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempLo != 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempLo }}c
                </p>
              </b-card> </b-col
            ><b-col
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempHi == 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempHi }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempHi != 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempHi }}c
                </p></b-card
              ></b-col
            ><b-col
              ><b-card
                ><p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempMed == 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempMed }}
                </p>
                <p class="cardbody" v-if="c1DeviceInfo.Pipe1.TempMed != 'N/A'">
                  {{ c1DeviceInfo.Pipe1.TempMed }}c
                </p></b-card
              ></b-col
            ></b-row
          >
        </b-card>
      </b-card-group>
      <br /> -->
      <!-- <b-card
        align="center"
        border-variant="dark"
        :header-bg-variant="c1DeviceInfo.Pipe2.variant"
        footer-tag="footer"
        v-if="this.c1DeviceInfo.type == 'double'"
      >
        <b-card-sub-title class="mb-2">{{
          c1DeviceInfo.Position
        }}</b-card-sub-title>
        <b-row></b-row>
        <template #header>
          <h4 class="left">
            {{ getNewName(c1DeviceInfo.DeviceID, "CL") }} Pipe B
          </h4>
          <BIconArrowUpRightSquare
            v-if="c1DeviceInfo.Pipe2.Trending == 'UP'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Up"
          ></BIconArrowUpRightSquare>
          <BIconArrowDownRightSquare
            v-if="c1DeviceInfo.Pipe2.Trending == 'DOWN'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Trending Down"
          >
          </BIconArrowDownRightSquare>
          <BIconDashSquare
            v-if="c1DeviceInfo.Pipe2.Trending == 'STABLE'"
            font-scale="1.5"
            v-b-tooltip.hover
            title="Stable"
          >
          </BIconDashSquare>
          <b-avatar-group class="right">
            <b-avatar
              v-if="c1DeviceInfo.Healthcare == 'TRUE'"
              class="HealthcareIcon"
              v-b-tooltip.hover
              title="Healthcare"
              ><BIconPlusCircle></BIconPlusCircle
            ></b-avatar>
            <b-avatar
              v-if="c1DeviceInfo.Outdoor == 'TRUE'"
              class="OutdoorIcon"
              v-b-tooltip.hover
              title="Outdoor"
              ><BIconHouse></BIconHouse
            ></b-avatar>
            <b-avatar
              v-if="c1DeviceInfo.Recirculatory == 'TRUE'"
              class="RecirculatoryIcon"
              v-b-tooltip.hover
              title="Recirculatory"
              ><BIconArrowDownUp></BIconArrowDownUp
            ></b-avatar>
            <b-avatar
              v-if="c1DeviceInfo.Pipe2.Feed == 'Hot Feed'"
              class="hoticon"
              v-b-tooltip.hover
              title="Hot Feed"
              ><BIconDropletHalf></BIconDropletHalf
            ></b-avatar>
            <b-avatar
              class="coldicon"
              v-b-tooltip.hover
              title="Cold Feed"
              v-if="c1DeviceInfo.Pipe2.Feed == 'Cold Feed'"
              ><BIconDropletHalf></BIconDropletHalf
            ></b-avatar>
            <b-avatar
              v-if="c1DeviceInfo.Pipe2.Feed == 'Mixed Feed'"
              class="mixedicon"
              v-b-tooltip.hover
              title="Mixed Feed"
              ><BIconDropletHalf></BIconDropletHalf
            ></b-avatar>
            <b-avatar
              v-if="c1DeviceInfo.Pipe2.Feed == 'Return Feed'"
              class="returnicon"
              v-b-tooltip.hover
              title="Return Pipe"
              >R</b-avatar
            >
          </b-avatar-group>
        </template>
        <b-row
          ><b-col><p class="cardhead">Flow Event</p></b-col
          ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
        >
        <b-row
          ><b-col
            ><b-card
              ><p class="cardbody" v-if="c1DeviceInfo.Pipe2.FlowRead != 'N/A'">
                {{ c1DeviceInfo.Pipe2.FlowRead }} hours ago
              </p>
              <p class="cardbody" v-if="c1DeviceInfo.Pipe2.FlowRead == 'N/A'">
                {{ c1DeviceInfo.Pipe2.FlowRead }}
              </p></b-card
            ></b-col
          ><b-col
            ><b-card
              ><p class="cardbody">
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == '1'"
                  variant="success"
                  >Level 1</b-badge
                >
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == '2'"
                  variant="warning"
                  >Level 2</b-badge
                >
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == '3'"
                  variant="warning"
                  >Level 3</b-badge
                >
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == '4'"
                  class="highRisk"
                  >Level 4</b-badge
                >
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == '5'"
                  variant="danger"
                  >Level 5</b-badge
                >
                <b-badge
                  v-if="c1DeviceInfo.Pipe2.PathogenRead == 'NoBio'"
                  variant="info"
                  >No Data</b-badge
                >
              </p></b-card
            ></b-col
          ></b-row
        >
        <b-row
          ><b-col><br /></b-col
        ></b-row>
        <b-row
          ><b-col><p class="cardhead">Min</p></b-col
          ><b-col><p class="cardhead">Max</p></b-col
          ><b-col><p class="cardhead">Avg</p></b-col></b-row
        >
        <b-row
          ><b-col
            ><b-card
              ><p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempLo == 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempLo }}
              </p>
              <p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempLo != 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempLo }}c
              </p>
            </b-card></b-col
          ><b-col
            ><b-card
              ><p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempHi == 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempHi }}
              </p>
              <p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempHi != 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempHi }}c
              </p></b-card
            ></b-col
          ><b-col
            ><b-card
              ><p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempMed == 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempMed }}
              </p>
              <p class="cardbody" v-if="c1DeviceInfo.Pipe2.TempMed != 'N/A'">
                {{ c1DeviceInfo.Pipe2.TempMed }}c
              </p></b-card
            ></b-col
          ></b-row
        >
      </b-card>-->
      <br /> 

      <b-card footer-tag="footer">
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="left"
          v-b-tooltip.hover
          title="Notes"
          @click="fetchNotes(c1DeviceInfo.DeviceID, c1DeviceInfo.HumanName)"
          ><BIconFileEarmarkMedical></BIconFileEarmarkMedical
        ></b-avatar>
        <b-avatar
          button
          rounded
          variant="outline-info"
          v-b-tooltip.hover
          title="Calibrate"
          v-if="!this.UserProfile.includes('CLI')"
          v-on:click="showCALWizard(c1DeviceInfo.DeviceID,'C1')"
          >
          <BIconWrench></BIconWrench
        ></b-avatar>
        <b-avatar
          button
          rounded
          variant="outline-info"
          class="right"
          v-b-tooltip.hover
          title="File Upload"
          @click="deviceFileUpload('C-1')"
          ><BIconCloudUpload></BIconCloudUpload
        ></b-avatar>
        <template #footer>
          <b-row
            ><b-col
              ><b-button
                block
                variant="outline-info"
                size="sm"
                @click="
                  showFurtherDetail(
                    c1DeviceInfo.DeviceID,
                    c1DeviceInfo.HumanName,
                    'C-1'
                  )
                "
                >Device Details</b-button
              ></b-col
            >
            <b-col
              ><b-button
                block
                size="sm"
                variant="outline-info"
                v-on:click="DeviceReportGen(c1DeviceInfo, 'C-1')"
                >Trend Reports</b-button
              ></b-col
            >
          </b-row>
        </template>
      </b-card>
    </b-modal>
    <b-modal
      ref="NotesModal"
      id="NotesModal"
      hide-footer
      title="Current Notes"
      content-class="Modal"
    >
      <div class="NotesModalContainerDiv">
        <h5>Notes for Device {{ this.NoteHumanName }}</h5>
        <div>
          <div
            id="NotesDiv"
            v-for="(id, idx) in NotesTextArray"
            :key="idx"
            class="notePreivewContent"
          >
            <div v-if="id != null">
              <b-card
                border-variant="secondary"
                header-bg-variant="light"
                header-text-variant="dark"
                :header="id.NoteTitle"
                style="margin-bottom:1rem;"
              >
                <template #header>
                  <b-row
                    ><b-col cols="2">{{ id.NoteID }}</b-col>
                    <b-col cols="8"> {{ id.NoteTitle }} </b-col>
                    <b-col cols="2"> </b-col>
                  </b-row>
                </template>
                <b-row>
                  <b-col>
                    <p class="noteDetails">{{ id.Date }}</p>
                  </b-col>
                  <b-col>
                    <p class="noteDetails">{{ id.Time }}</p>
                  </b-col>
                  <b-col>
                    <p class="noteDetails">{{ id.NoteCreator }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      v-b-toggle="'Notes' + idx"
                      variant="outline-info"
                      size="sm"
                    >
                      Show More
                    </b-button>
                  </b-col>
                </b-row>
                <b-collapse :id="'Notes' + idx">
                  <br />

                  <b-card>
                    <p class="noteTitleP">{{ id.NoteTitle }}</p>
                    <p>{{ id.NoteText }}</p>
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      v-on:click="deleteNote(id)"
                    >
                      Delete Note
                    </b-button>
                  </b-card>
                </b-collapse>
              </b-card>
            </div>
          </div>
          <div v-if="NotesTextArray == ''">
            <h5>No notes for selected device</h5>
          </div>
        </div>
        <br />
        <p id="Selector">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="addNewNote(NoteDeviceID)"
            >Add New Note</b-button
          >
        </p>
      </div>
    </b-modal>
    <b-modal
      ref="NewNotesModal"
      id="NewNotesModal"
      hide-footer
      title="New Note"
      content-class="Modal"
    >
      <div class="NewNoteModal">
        <!-- USER INPUTS -->
        <b-row class="NewNoteTopRow">
          <b-col cols="2"> </b-col>
          <b-col cols="8">
            <input
              type="text"
              placeholder="Note Title"
              v-model="NewNoteTitle"
              required
              maxlength="40"
              @focus="modal = false"
              class="NewNoteTitle"
            />
          </b-col>
          <b-col cols="2"> </b-col>
        </b-row>
        <b-row class="NewNoteBottomRow">
          <b-col cols="2"> </b-col>
          <b-col cols="8">
            <textarea
              class="supportTextArea"
              v-model="NewNoteText"
              placeholder="Note Text"
              rows=""
              cols=""
              @focus="modal = false"
              maxlength="300"
            ></textarea>
          </b-col>
          <b-col cols="2"> </b-col>
        </b-row>
        <p id="Selector">
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="submitNewNote()"
            >Submit Note</b-button
          >
          <b-button
            variant="outline-info"
            size="sm"
            v-on:click="returnToNotesModal('NewNotesModal')"
            >Return</b-button
          >
        </p>
      </div>
    </b-modal>
    <b-modal
      ref="DeviceCalibrationInput"
      id="DeviceCalibrationInput"
      hide-footer
      title="Device Calibration"
      content-class="Modal"
    >
      <div class="NewNoteModal">
        <div>
          <b-card
            border-variant="secondary"
            header-bg-variant="light"
            header-text-variant="dark"
          >
            <template #header>
              Calibration for Device ID: {{ CalibHumanName }}
            </template>
            <b-card-body v-if="calibDeviceType == 'C-1'">
              <!-- <p class="">Please enter all times in UTC/GMT+0.</p> -->
              <p v-if="calibrationNoOfPipes.includes('1')">Pipe 1</p>
              <label for="TimeRaised">Time of Calibration:</label>
              <b-form-timepicker
                id="TimeRaised"
                v-model="calibrationTime1"
                now-button
                locale="en"
              ></b-form-timepicker>
              <label for="DateRaised">Date:</label>
              <b-form-datepicker
                type="date"
                id="DateRaised"
                v-model="calibrationDate"
                @focus="modal = false"
              />
              <br />

              Temperature (C):

              <b-form-input
                type="text"
                placeholder="Temperature (C)"
                v-model="calibTemperature"
                required
                min="0"
                max="9999"
                step="0.1"
                onkeydown="return event.keyCode !== 69"
                @focus="modal = false"
                v-b-popover.hover.top="
                  'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                "
              />

              Flow :
              <b-form-checkbox
                id="checkbox-4"
                v-model="flowCheckBox"
                name="checkbox-4"
                value="TRUE"
                unchecked-value="FALSE"
                class=""
                v-b-popover.hover.bottom="
                  'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                "
              >
              </b-form-checkbox>
            </b-card-body>
            <b-card-body
              v-if="
                calibrationNoOfPipes.includes('2') & (calibDeviceType == 'C-1')
              "
            >
              <hr />
              <p v-if="calibrationNoOfPipes.includes('2')">Pipe 2</p>
              <label for="TimeRaised">Time of Calibration:</label>
              <b-form-timepicker v-model="calibrationTime2" now-button
              locale="en"></b-form-timepicker>
              <label for="DateRaised">Date:</label>
              <b-form-datepicker
                type="date"
                v-model="calibrationDate2"
                @focus="modal = false"
              />
              <br />
              Temperature (C):
              <b-form-input
                type="text"
                placeholder="Temperature (C)"
                v-model="calibTemperature2"
                required
                min="0"
                max="9999"
                step="0.1"
                onkeydown="return event.keyCode !== 69"
                @focus="modal = false"
                v-b-popover.hover.top="
                  'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                "
              />
              Flow :
              <b-form-checkbox
                id="checkbox-5"
                v-model="flowCheckBox2"
                name="checkbox-4"
                value="TRUE"
                unchecked-value="FALSE"
                class=""
                v-b-popover.hover.bottom="
                  'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                "
              >
              </b-form-checkbox>
            </b-card-body>
            <!-- C1 Calib End -->
            <!-- O1 Calib Start -->
            <b-card-body v-if="calibDeviceType == 'O-1'">
              <!-- <p class="">Please enter all times in UTC/GMT+0.</p> -->

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    v-if="O1DeviceInfo.Probe1Active == 'TRUE'"
                    block
                    v-b-toggle.accordion-1
                    variant="outline-secondary"
                  >
                    <b-row>
                      <b-col cols="8"> Probe 1 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconCheck
                            v-if="this.accord1Valid.variant == 'success'"
                            :variant="this.accord1Valid.variant"
                            stacked
                          >
                          </BIconCheck>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                  <b-button
                    v-if="O1DeviceInfo.Probe1Active == 'FALSE'"
                    block
                    variant="outline-secondary"
                    disabled
                  >
                    <b-row>
                      <b-col cols="8"> Probe 1 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconX variant="danger" stacked> </BIconX>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                </b-card-header>

                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <label for="TimeRaised">Time of Calibration:</label>
                    <b-form-timepicker
                      id="TimeRaised"
                      :state="O1CalibTime1Check"
                      v-model="O1calibrationTimeProbe1"
                      now-button
                      locale="en"
                    ></b-form-timepicker>
                    <label for="DateRaised">Date:</label>
                    <b-form-datepicker
                      type="date"
                      :state="O1CalibDate1Check"
                      id="DateRaised"
                      v-model="O1calibrationDateProbe1"
                      @focus="modal = false"
                    />
                    <br />

                    Temperature (C):

                    <b-form-input
                      type="number"
                      placeholder="Temperature (C)"
                      v-model="O1calibTemperatureProbe1"
                      required
                      min="0"
                      max="9999"
                      step="0.1"
                      onkeydown="return event.keyCode !== 69"
                      :state="O1calibTemp1Check"
                      @focus="modal = false"
                      v-b-popover.hover.top="
                        'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                      "
                    />

                    Flow :
                    <b-form-checkbox
                      id="checkbox-4"
                      v-model="O1flowCheckBoxProbe1"
                      name="checkbox-4"
                      value="TRUE"
                      unchecked-value="FALSE"
                      v-b-popover.hover.bottom="
                        'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                      "
                    >
                    </b-form-checkbox>
                  </b-card-body>
                </b-collapse>

                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    v-if="O1DeviceInfo.Probe2Active == 'TRUE'"
                    block
                    v-b-toggle.accordion-2
                    variant="outline-secondary"
                  >
                    <b-row>
                      <b-col cols="8"> Probe 2 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconCheck
                            v-if="this.accord2Valid.variant == 'success'"
                            :variant="this.accord2Valid.variant"
                            stacked
                          >
                          </BIconCheck>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                  <b-button
                    v-if="O1DeviceInfo.Probe2Active == 'FALSE'"
                    block
                    variant="outline-secondary"
                    disabled
                  >
                    <b-row>
                      <b-col cols="8"> Probe 2 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconX variant="danger" stacked> </BIconX>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <label for="TimeRaised">Time of Calibration:</label>
                    <b-form-timepicker
                      id="TimeRaised2"
                      :state="O1CalibTime2Check"
                      v-model="O1calibrationTimeProbe2"
                      now-button
                      locale="en"
                    ></b-form-timepicker>
                    <label for="DateRaised">Date:</label>
                    <b-form-datepicker
                      type="date"
                      id="DateRaised2"
                      :state="O1CalibDate2Check"
                      v-model="O1calibrationDateProbe2"
                      @focus="modal = false"
                    />
                    <br />

                    Temperature (C):

                    <b-form-input
                      type="number"
                      placeholder="Temperature (C)"
                      v-model="O1calibTemperatureProbe2"
                      required
                      min="0"
                      max="9999"
                      step="0.1"
                      onkeydown="return event.keyCode !== 69"
                      :state="O1calibTemp2Check"
                      @focus="modal = false"
                      v-b-popover.hover.top="
                        'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                      "
                    />

                    Flow :
                    <b-form-checkbox
                      id="checkbox-5"
                      v-model="O1flowCheckBoxProbe2"
                      name="checkbox-5"
                      value="TRUE"
                      unchecked-value="FALSE"
                      v-b-popover.hover.bottom="
                        'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                      "
                    >
                    </b-form-checkbox>
                  </b-card-body>
                </b-collapse>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    v-if="O1DeviceInfo.Probe3Active == 'TRUE'"
                    block
                    v-b-toggle.accordion-3
                    variant="outline-secondary"
                  >
                    <b-row>
                      <b-col cols="8"> Probe 3 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconCheck
                            v-if="this.accord3Valid.variant == 'success'"
                            :variant="this.accord3Valid.variant"
                            stacked
                          >
                          </BIconCheck>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                  <b-button
                    v-if="O1DeviceInfo.Probe3Active == 'FALSE'"
                    block
                    variant="outline-secondary"
                    disabled
                  >
                    <b-row>
                      <b-col cols="8"> Probe 3 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconX variant="danger" stacked> </BIconX>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <label for="TimeRaised">Time of Calibration:</label>
                    <b-form-timepicker
                      id="TimeRaised3"
                      v-model="O1calibrationTimeProbe3"
                      now-button
                      locale="en"
                    ></b-form-timepicker>
                    <label for="DateRaised3">Date:</label>
                    <b-form-datepicker
                      type="date"
                      :state="O1CalibDate3Check"
                      id="DateRaised"
                      v-model="O1calibrationDateProbe3"
                      @focus="modal = false"
                    />
                    <br />

                    Temperature (C):

                    <b-form-input
                      type="number"
                      placeholder="Temperature (C)"
                      v-model="O1calibTemperatureProbe3"
                      required
                      min="0"
                      max="9999"
                      step="0.1"
                      onkeydown="return event.keyCode !== 69"
                      :state="O1calibTemp3Check"
                      @focus="modal = false"
                      v-b-popover.hover.top="
                        'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                      "
                    />

                    Flow :
                    <b-form-checkbox
                      id="checkbox-4"
                      v-model="O1flowCheckBoxProbe3"
                      name="checkbox-4"
                      value="TRUE"
                      unchecked-value="FALSE"
                      v-b-popover.hover.bottom="
                        'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                      "
                    >
                    </b-form-checkbox>
                  </b-card-body>
                </b-collapse>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-if="O1DeviceInfo.Probe4Active == 'TRUE'"
                    v-b-toggle.accordion-4
                    variant="outline-secondary"
                  >
                    <b-row>
                      <b-col cols="8"> Probe 4 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconCheck
                            v-if="this.accord4Valid.variant == 'success'"
                            :variant="this.accord4Valid.variant"
                            stacked
                          >
                          </BIconCheck>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                  <b-button
                    v-if="O1DeviceInfo.Probe4Active == 'FALSE'"
                    block
                    variant="outline-secondary"
                    disabled
                  >
                    <b-row>
                      <b-col cols="8"> Probe 4 </b-col>
                      <b-col cols="4">
                        <BIconstack font-scale="1">
                          <BIconSquare variant="secondary" stacked>
                          </BIconSquare>
                          <BIconX variant="danger" stacked> </BIconX>
                        </BIconstack>
                      </b-col> </b-row
                  ></b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <label for="TimeRaised">Time of Calibration:</label>
                    <b-form-timepicker
                      id="TimeRaised4"
                      v-model="O1calibrationTimeProbe4"
                      now-button
                      locale="en"
                    ></b-form-timepicker>
                    <label for="DateRaised">Date:</label>
                    <b-form-datepicker
                      type="date"
                      id="DateRaised4"
                      :state="O1CalibDate4Check"
                      v-model="O1calibrationDateProbe4"
                      @focus="modal = false"
                    />
                    <br />

                    Temperature (C):

                    <b-form-input
                      type="number"
                      placeholder="Temperature (C)"
                      v-model="O1calibTemperatureProbe4"
                      required
                      min="0"
                      max="9999"
                      step="0.1"
                      onkeydown="return event.keyCode !== 69"
                      :state="O1calibTemp4Check"
                      @focus="modal = false"
                      v-b-popover.hover.top="
                        'In order to ensure accuracy please allow water temperatures to stabilise prior to taking calibration temperature reading and provide them to two decimal places. For example (65.34)'
                      "
                    />

                    Flow :
                    <b-form-checkbox
                      id="checkbox-4"
                      v-model="O1flowCheckBoxProbe4"
                      name="checkbox-4"
                      value="TRUE"
                      unchecked-value="FALSE"
                      v-b-popover.hover.bottom="
                        'A minimum flow duration of 30 seconds is recommended to ensure sufficient data quality.'
                      "
                    >
                    </b-form-checkbox>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-card-body>
          </b-card>
          <br />

          <div>
            <b-row>
              <b-col>
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="submitNewCalibration(calibDeviceType)"
                >
                  Confirm
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="resetForm(calibDeviceType)"
                >
                  Clear
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="outline-info"
                  size="sm"
                  v-on:click="cancelCalibration()"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
     <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="CalWizard"
            id="CalWizard"
            title="Device Calibrations"
            hide-footer>
            <b-card>
            <CALWizard @WizardComplete="FinishCALWizard" :Type="Type" :ID="ID"/>
            </b-card>

        </b-modal>
    <b-modal
      ref="DeviceFileUpload"
      id="DeviceFileUpload"
      title="Device File Upload"
      content-class="Modal"
    >
      <b-card> <FileUpload></FileUpload> </b-card>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { IDToHuman } from "../CustomFunctions/HumanName.js";
import { UTCToTimeZone } from "../CustomFunctions/Timezone.js";

import {
  BIconFileEarmarkMedical,
  BIconCloudUpload,
  BIconArrowDownRightSquare,
  BIconDashSquare,
  BIconArrowUpRightSquare,
  BIconArrowDownUp,
  // BIconShare,
  // BIconHouse,
  BIconWrench,
  // BIconPlusCircle,
  BIconDropletHalf,
  BIconSquare,
  BIconstack,
  BIconCheck,
  BIconX,
  BIconWifi,
  BIconWifiOff,
  BIconWater,
  BIconExclamationTriangleFill 
} from "bootstrap-vue";
import FileUpload from "../views/FileUpload.vue";
import DetailData from "../components/DetailData.vue";
import CALWizard from "../components/CalibrationWizard/CALWizard.vue";
import VueApexCharts from "vue-apexcharts";
export default {
  props:['DataPass','Type','ID'],
  components: {
    FileUpload,
    BIconCloudUpload,
    BIconstack,
    BIconFileEarmarkMedical,
    BIconArrowDownRightSquare,
    BIconArrowUpRightSquare,
    BIconArrowDownUp,
    // BIconShare,
    // BIconHouse,
    BIconDashSquare,
    BIconWrench,
    // BIconPlusCircle,
    BIconExclamationTriangleFill,

    VueApexCharts,
    DetailData,
    BIconDropletHalf,
    BIconSquare,
    BIconCheck,
    BIconX,
    BIconWifi,
    BIconWifiOff,
    BIconWater,
    CALWizard
  },
  computed: {
    O1CalibDate1Check() {
      return this.CheckDate1();
    },
    O1CalibDate2Check() {
      return this.CheckDate2();
    },
    O1CalibDate3Check() {
      return this.CheckDate3();
    },
    O1CalibDate4Check() {
      return this.CheckDate4();
    },
    O1CalibTime1Check() {
      return this.CheckTime1();
    },
    O1CalibTime2Check() {
      return this.CheckTime2();
    },
    O1CalibTime3Check() {
      return this.CheckTime3();
    },
    O1CalibTime4Check() {
      return this.CheckTime4();
    },
    O1calibTemp1Check() {
      return this.CheckTemp1();
    },
    O1calibTemp2Check() {
      return this.CheckTemp2();
    },
    O1calibTemp3Check() {
      return this.CheckTemp3();
    },
    O1calibTemp4Check() {
      return this.CheckTemp4();
    },
    rows() {
      return this.NotesTextArray.length;
    },
    accord1Valid() {
      return this.accord1Validation();
    },
    accord2Valid() {
      return this.accord2Validation();
    },
    accord3Valid() {
      return this.accord3Validation();
    },
    accord4Valid() {
      return this.accord4Validation();
    },
  },
  data() {
    return {
      C1Loaded: false,
      O1Loaded: false,
      UserAccess: localStorage.getItem("accessGroup"),
      UserProfile: localStorage.getItem("profileportal"),

      accord1: {
        CheckVariant: "success",
      },
      CalibHumanName: "",
      screenWidth: window.innerWidth,
      MaxHeight: 0,
      O1calibrationTimeProbe4: "",
      O1calibrationTimeProbe2: "",
      O1calibrationTimeProbe1: "",
      O1calibrationTimeProbe3: "",
      O1calibrationDateProbe1: "",
      O1calibTemperatureProbe1: "",
      O1flowCheckBoxProbe1: "FALSE",
      O1calibrationDateProbe2: "",
      O1calibTemperatureProbe2: "",
      O1flowCheckBoxProbe2: "FALSE",
      O1calibrationDateProbe3: "",
      O1calibTemperatureProbe3: "",
      O1flowCheckBoxProbe3: "FALSE",
      O1calibrationDateProbe4: "",
      O1calibTemperatureProbe4: "",
      O1flowCheckBoxProbe4: "FALSE",
      O1DeviceInfo: null,
      calibDeviceType: "",
      tabNo: null,
      C1DayTrendData: "",
      C1CurrentDeviceStatusCounts: "",
      FilterName: [],
      FilterVar: [],
      O1ExtHiCount: 0,
      O1HiCount: 0,
      O1ModCount: 0,
      O1LowCount: 0,
      O1Scores: "",
      C1ExtHiCount: "",
      C1HiCount: "",
      C1ModCount: "",
      C1LowCount: "",
      detailToShow: this.$DetailToShow,
      headerText: "som txt",
      O1Array: [],
      furtherDeviceInfo: [],
      perPage: 5,
      currentPage: 1,
      AlarmItems: [],
      UserHeaders: [],
      ArrTest: [],
      ErrorHeaders: [],
      ErrorItems: [],
      SupportItems: [],
      SupportHeaders: [],
      ServiceItems: [],
      ServiceHeaders: [],
      location: "",
      locations: [],
      filteredlocations: [],
      modal: false,
      GreenCount: "--",
      AmberCount: "--",
      RedCount: "--",
      responseArray: [],
      responselist: [],
      CompanyName: this.$Company,
      GoodState: "",
      ExcellentState: "",
      BadState: "",
      FairState: "",
      locationsArray: [],
      locationsList: [],
      deviceLocation: "",
      hover: false,
      TodayDate: "",
      TotalDevices: "",
      time: "",
      value: "1000",
      max: "1000",
      DeviceMessage: "",
      resetButtonDisable: false,
      submitButtonDisable: false,
      feedList: [],
      Positions: [],
      feedArray: [],
      PositionArray: [],
      subgroupListArray: [],
      subgroupList: "",
      dbFilterRecirculatory: "",
      dbFilterOutdoor: "",
      dbFilterMultiplePipe: "",
      dbFilterBattery: "",
      dbFilterHealthcare: "",
      dbFilterRiskLevel: "",
      dbFilterPosition: "",
      dbFilterFeed: "",
      dbFilterDeviceLocation: "",
      dbFilterDeviceOrder: "",
      dbFilterSubgroup: "",
      dbFilterHot: "",
      dbFilterCold: "",
      dbFilterMixed: "",
      dbFilterReturn: "",
      filterArray: [],
      NotesArray: [],
      NotesTextArray: [],
      NoteDeviceID: "",
      NewNoteDeviceID: "",
      NewNoteText: "",
      NewNoteTitle: "",
      NewNoteCreatorUserURN: "",
      NewNoteCreatorFirstName: "",
      NewNoteCreatorLastName: "",
      NewNoteCreatorUserType: "",
      DeleteNoteCreatorUserURN: "",
      DeleteNoteCreatorFirstName: "",
      DeleteNoteCreatorLastName: "",
      DeleteNoteCreatorUserType: "",
      calibrateDeviceID: "",
      flowCheckBox: "",
      calibTemperature: "",
      calibrationTimeMinutes: "",
      calibrationTimeHour: "",
      calibrationDate: "",
      calibrationNoOfPipes: "",
      calibMultipipe: "",
      flowCheckBox2: "",
      calibTemperature2: "",
      calibrationTimeMinutes2: "",
      calibrationTimeHour2: "",
      calibrationDate2: "",
      calibrationTime1: "",
      calibrationTime2: "",
      type: "",
      searchname: "",
      c1DeviceInfo: "",
      filterInfo: [],
      selectedlocation: localStorage.getItem("CurrentLocation"),
      C1Count: "--",
      O1Count: "--",
      hotarray: ['Hot Outlet','TMV Hot In','Hot Water Storage','Combi Boiler','Point of Use Heater','Calorifier'],
      coldarray: ['Cold Outlet','Cold Water Supply','TMV Cold In','Cold Water Storage','Cooling Tower'],
      mixedarray: ['TMV Mixed Out'],
      returnarray: ['Hot Water Return'],
      chartOptionsLine: {
        dataLabels: {
          enabled: false,
        },
        title: {
          text: "7 Day Device Trend",
          align: "center",
        },
        legend: {
          show: true,
        },
        chart: {
          stacked: true,
        },
        sparkline: {
          enabled: true,
        },
        fill: {
          opacity: 1,
        },
        xaxis: {
          categories: [
            "Day 7",
            "Day 6",
            "Day 5",
            "Day 4",
            "Day 3",
            "Day 2",
            "Day 1",
          ],
          labels: {
            show: true,
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        colors: ["#dc3546", "#f05f16", "#ffc107", "#28a746"],
        grid: {
          show: true, // you can either change hear to disable all grids
          xaxis: {
            lines: {
              show: true, //or just here to disable only x axis grids
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false, //or just here to disable only y axis
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
        },
      },
      seriesLine: [
        {
          name: "Extremely High Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "High Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Moderate Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Low Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      seriesLine2: [
        {
          name: "Extremely High Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "High Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Moderate Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Low Risk",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      optionsDonut: {
        type: "donut",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ",",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            },
          },
          autoSelected: "zoom",
        },
        title: {
          text: "Current Device Status",
          align: "center",
        },
        labels: [
          "Extremely High Risk",
          "High Risk",
          "Moderate Risk",
          "Low Risk",
        ],
        colors: ["#dc3545", "#F05E16", "#ffc107", "#28a745"],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  color: "#000000"
                },
              },
            },
          },
        },
      },
      donutSeries: [0, 0, 0, 0],
      donutSeries2: [0, 0, 0, 0],

      DeviceIDToChange: { C1: [], O1: [] },

      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      NoteHumanName: "",
      DataFiltered: false,
    };
  },

  beforeMount() {
    this.tabNo = this.$tab;
    Vue.prototype.$tab = 0;
    this.C1Loaded = false;
    this.O1Loaded = false;
  },

  async mounted() {
    this.updateScreenWidth();
    this.onScreenResize();

    if (this.detailToShow === "C-1") {
      this.headerText = "" + this.detailToShow + " Device: " + this.$DeviceID;
    }
  
    this.LoadO1Data([],'','','')
    // this.O1Loaded = true;
    this.C1Loaded = true;
  

    /* SECTION END */
    this.donutSeries = [2, 1, 3, 5];
    let lookUpUrlStatusCounts =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/statuscounts";
    let LookUpHeadersStatusCount = this.$apikeyPost;
    let LookUpDataStatusCount = {
      RequestType: "RiskLevelLocation",
      RequestVariable: this.selectedlocation,
    };
    axios
      .post(
        lookUpUrlStatusCounts,
        LookUpDataStatusCount,
        LookUpHeadersStatusCount
      )
      .then((response) => {
        
        this.C1ExtHiCount = response.data.ExtremelyHighRisk[0];
        this.C1HiCount = response.data.HighRisk[0];
        this.C1ModCount = response.data.ModerateRisk[0];
        this.C1LowCount = response.data.LowRisk[0];


        this.O1ExtHiCount = response.data.O1Scores["Extremely High Risk"] || 0 ;
        this.O1HiCount = response.data.O1Scores["High Risk"] || 0 ;
        this.O1ModCount = response.data.O1Scores["Moderate Risk"] || 0 ;
        this.O1LowCount = response.data.O1Scores["Low Risk"] || 0 ;
 
      });
    let LookUpURLCount =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/counts";
    let LookUpHeadersCount = this.$apikeyPost;
    let LookUpDataCount = {
      RequestType: "ClarenceDeviceCount",
      RequestVariable: this.selectedlocation,
    };
    axios
      .post(LookUpURLCount, LookUpDataCount, LookUpHeadersCount)
      .then((response) => {
        this.C1Count = response.data.C1ActiveCount;
        this.O1Count = response.data.O1ActiveCount;
      });

    // let LookUpURL =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/dashboard";
    // let LookUpHeaders = this.$apikeyPost;
    // let LookUpData = {
    //   Report: "DeviceReport",
    //   RequestType: "",
    //   RequestVariable: this.selectedlocation,
    //   DataDict: [
    //     {
    //       FilterType: ["Device"],
    //       DeviceSort: "Asc",
    //       Location: this.selectedlocation,
    //       Subgroup: this.dbFilterSubgroup,
    //       Feed: this.dbFilterFeed,
    //       Position: this.dbFilterPosition.text,
    //       State: this.dbFilterRiskLevel,
    //     },
    //   ],
    // };
    // axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {
      
    //   (this.chartOptionsLine = {
    //     dataLabels: {
    //       enabled: false,
    //     },
    //     title: {
    //       text: "7 Day Device Trend",
    //       align: "center",
    //     },
    //     legend: {
    //       show: true,
    //     },
    //     chart: { stacked: true },
    //     sparkline: {
    //       enabled: true,
    //     },
    //     fill: {
    //       opacity: 1,
    //     },
    //     xaxis: {
    //       categories: response.data.DayDeviceTrend.DateList,
    //       labels: {
    //         show: true,
    //       },
    //     },
    //     yaxis: {
    //       labels: {
    //         show: true,
    //       },
    //     },
    //     colors: ["#dc3546", "#f05f16", "#ffc107", "#28a746"],
    //     grid: {
    //       show: true, // you can either change hear to disable all grids
    //       xaxis: {
    //         lines: {
    //           show: true, //or just here to disable only x axis grids
    //         },
    //         labels: {
    //           show: false,
    //         },
    //       },
    //       yaxis: {
    //         lines: {
    //           show: false, //or just here to disable only y axis
    //         },
    //         axisBorder: {
    //           show: false,
    //         },
    //         labels: {
    //           show: false,
    //         },
    //         axisTicks: {
    //           show: false,
    //         },
    //       },
    //     },
    //   }),
    //     (this.seriesLine = [
    //       {
    //         name: "Extremely High Risk",
    //         data: response.data.DayDeviceTrend.ExtHighCounts,
    //       },
    //       {
    //         name: "High Risk",
    //         data: response.data.DayDeviceTrend.HighCounts,
    //       },
    //       {
    //         name: "Moderate Risk",
    //         data: response.data.DayDeviceTrend.ModCounts,
    //       },
    //       {
    //         name: "Low Risk",
    //         data: response.data.DayDeviceTrend.LowCounts,
    //       },
    //     ]),
    //     (this.filterInfo = []);
    //    this.C1DayTrendData = response.data.DayDeviceTrend;
    //    this.C1CurrentDeviceStatusCounts = response.data.DeviceStatusCounts;
    //    this.donutSeries = [
    //     this.C1CurrentDeviceStatusCounts.ExtremelyHighRiskCount,
    //     this.C1CurrentDeviceStatusCounts.HighRiskCount,
    //     this.C1CurrentDeviceStatusCounts.ModerateRiskCount,
    //     this.C1CurrentDeviceStatusCounts.LowRiskCount,
    //   ];



    //   if (response.data.Values == "") {
    //     this.responseArray = [];
    //     this.responseArray = ["No Data"];
    //   } else if (response.data.Values != "") {
    //     this.responselist = response.data.Values;
    //     let IDArray = [];
    //     for (let i = 0; i < this.responselist.length; i++) {
    //       IDArray.push([this.responselist[i][0], i]);
    //     }
       
    //     for (let i = 0; i < this.responselist.length; i++) {
         
    //       let probe1tag = 'No Tag';
    //       let probe2tag = 'No Tag';

    //       let probe1tagclass = "light";
    //       let probe2tagclass = "light";

    //       let probe1class = "lightbackicon";
    //       let probe2class = "lightbackicon";

    //       let probe1title = "Probe1: No Feed";
    //       let probe2title = "Probe2: No Feed";

    //       let p1biovar = 'light';
    //       let p2biovar = 'light';

    //       let probeArray = this.responselist[i][51]

    //       for(let x=0;x<probeArray.length;x++){ 
    //         if (probeArray[x].length > 0){
    //            for(let y =0; y<probeArray[x].length;y++){
    //             if(probeArray[x][y][0] == '1'){
    //               probe1tag = probeArray[x][y][1]
    //               if(this.hotarray.includes(probe1tag)){
    //                 probe1class = 'hotbackicon',
    //                 probe1title = 'Probe1: Hot Feed',
    //                 probe1tagclass = "danger"
    //               } else if(this.coldarray.includes(probe1tag)){
    //                 probe1class = 'coldbackicon',
    //                 probe1title = 'Probe1: Cold Feed',
    //                 probe1tagclass = "coldicon"
    //               } else if(this.mixedarray.includes(probe1tag)){
    //                 probe1class = 'mixedbackicon',
    //                 probe1title = 'Probe1: Mixed Feed',
    //                 probe1tagclass = "mixedicon"
    //               } else if(this.returnarray.includes(probe1tag)){
    //                 probe1class = 'returnbackicon',
    //                 probe1title = 'Probe1: Return Feed',
    //                 probe1tagclass = "returnicon"
    //               }
    //             } else if(probeArray[x][y][0] == '2'){
    //               probe2tag = probeArray[x][y][1]
    //               if(this.hotarray.includes(probe2tag)){
    //                 probe2class = 'hotbackicon',
    //                 probe2title = 'Probe2: Hot Feed',
    //                 probe2tagclass = "danger"
    //               } else if(this.coldarray.includes(probe2tag)){
    //                 probe2class = 'coldbackicon',
    //                 probe2title = 'Probe2: Cold Feed',
    //                 probe2tagclass = "coldicon"
    //               } else if(this.mixedarray.includes(probe2tag)){
    //                 probe2class = 'mixedbackicon',
    //                 probe2title = 'Probe2: Mixed Feed',
    //                 probe2tagclass = "mixedicon"
    //               } else if(this.returnarray.includes(probe2tag)){
    //                 probe2class = 'returnbackicon',
    //                 probe2title = 'Probe2: Return Feed',
    //                 probe2tagclass = "returnicon"
    //               }
    //             }
    //           }
    //         }
    //       }

    //       if(this.responselist[i][3] == "TRUE"){
    //         if((this.responselist[i][49][0]>=1)&&(this.responselist[i][49][0]<=1.49)){
    //           p1biovar = "success"
    //         } else if((this.responselist[i][49][0]>=1.5) && (this.responselist[i][49][0]<=2.49)){
    //           p1biovar = "warning"
    //         } else if((this.responselist[i][49][0]>=2.5) && (this.responselist[i][49][0]<=4)){
    //           p1biovar = "highRisk"
    //         } else if(this.responselist[i][49][0]>=4.1){
    //           p1biovar = "danger"
    //         } else{
    //           p1biovar = 'light'
    //         }
    //       }

    //       let Probe1MinRnd = Math.round(this.responselist[i][10]);
    //       let Probe1TempRnd = Math.round(this.responselist[i][11]);
    //       this.Probe1TempLimit = Math.round(this.responselist[i][9]);
    //       let Probe1TempVariant = this.getProbeRiskLevel(this.responselist[i][9]);
    //       let Probe1FlowVariant = '';
    //       let Probe1ScoreVariant = '';
         
    //       if (this.responselist[i][3] == "TRUE") {
   
    //         if (this.responselist[i][7] == "Extremely High Risk") {
    //           Probe1ScoreVariant = "danger";
    //         } else if (this.responselist[i][7] == "High Risk") {
    //           Probe1ScoreVariant = "highRisk";
    //         } else if (this.responselist[i][7] == "Moderate Risk") {
    //           Probe1ScoreVariant = "warning";
    //         } else if (this.responselist[i][7] == "Low Risk") {
    //           Probe1ScoreVariant = "success";
    //         } else{
    //           Probe1ScoreVariant = "light"
    //         }
    //       }

    //       if (this.responselist[i][3] == "TRUE") {     
    //         if (this.responselist[i][13] == null || this.responselist[i][14] == null) {
    //           this.time = "N/A";
    //           Probe1FlowVariant = "light";
    //         } else {
             
    //           let FlowTimeDate = this.responselist[i][13] + "T" + this.responselist[i][14];
    //           let d1 = new Date().toUTCString();

    //           d1 = new Date(d1).getTime();

    //           let d2 = new Date(FlowTimeDate);

    //           d2 = new Date(d2).getTime();

    //           this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);

    //           if (this.time <= 8) {
    //             Probe1FlowVariant = "success";
    //           }
    //           if ((this.time >= 9) & (this.time <= 24)) {
    //             Probe1FlowVariant = "warning";
    //           }
    //           if ((this.time >= 25) & (this.time <= 47)) {
    //             Probe1FlowVariant = "warning";
    //           }
    //           if (this.time >= 48) {
    //             Probe1FlowVariant = "danger";
    //           }
    //         }
    //       }
          
    //         let Probe2MinRnd = Math.round(this.responselist[i][30]);
    //         let Probe2TempRnd = Math.round(this.responselist[i][31]);
    //         this.Probe2TempLimit = Math.round(this.responselist[i][29])
    //         let Probe2TempVariant = this.getProbeRiskLevel(this.responselist[i][29]);
    //         let Probe2FlowVariant = '';
    //         let Probe2ScoreVariant = '';
    //         let timeProbe2 = '';

    //       if (this.responselist[i][23] == "TRUE") {
    //         if (this.responselist[i][27] == "Extremely High Risk") {
    //           Probe2ScoreVariant = "danger";
    //         } else if (this.responselist[i][27] == "High Risk") {
    //           Probe2ScoreVariant = "highRisk";
    //         } else if (this.responselist[i][27] == "Moderate Risk") {
    //           Probe2ScoreVariant = "warning";
    //         } else if (this.responselist[i][27] == "Low Risk") {
    //           Probe2ScoreVariant = "success";
    //         }else{
    //           Probe2ScoreVariant = "light";
    //         }
    //       }

    //       if(this.responselist[i][23] == "TRUE"){
    //         if(this.responselist[i][49][1]>=1&&(this.responselist[i][49][1]<=1.49)){
    //           p2biovar = "success"
    //         } else if((this.responselist[i][49][1]>=1.5) && (this.responselist[i][49][1]<=2.49)){
    //           p2biovar = "warning"
    //         } else if((this.responselist[i][49][1]>=2.5) && (this.responselist[i][49][1]<=4)){
    //           p2biovar = "highRisk"
    //         } else if(this.responselist[i][49][1]>=4.1){
    //           p2biovar = "danger"
    //         } else{
    //           p2biovar = 'light'
    //         }
    //       }

    //       let headervariant = '';
    //       if (this.responselist[i][44] == "Moderate Risk") {
    //         headervariant = "warning";
    //       } else if (this.responselist[i][44] == "Low Risk") {
    //         headervariant = "success";
    //       } else if (this.responselist[i][44] == "High Risk") {
    //         headervariant = "highRisk";
    //       } else {
    //         headervariant = "danger";
    //       }


    //       if (this.responselist[i][23] == "TRUE") {     
    //         if (this.responselist[i][33] == null || this.responselist[i][34] == null) {
    //           timeProbe2 = "N/A";
    //           Probe2FlowVariant = "light";
    //         } else {
             
    //           let FlowTimeDate = this.responselist[i][33] + "T" + this.responselist[i][34];
    //           let d1 = new Date().toUTCString();

    //           d1 = new Date(d1).getTime();

    //           let d2 = new Date(FlowTimeDate);

    //           d2 = new Date(d2).getTime();

    //           timeProbe2 = Math.floor((d1 - d2) / 1000 / 60 / 60);

    //           if (timeProbe2 <= 8) {
    //             Probe2FlowVariant = "success";
    //           }
    //           if ((timeProbe2 >= 9) & (timeProbe2 <= 24)) {
    //             Probe2FlowVariant = "warning";
    //           }
    //           if ((timeProbe2 >= 25) & (timeProbe2 <= 47)) {
    //             Probe2FlowVariant = "warning";
    //           }
    //           if (timeProbe2 >= 48) {
    //             Probe2FlowVariant = "danger";
    //           }
    //         }
    //       }

    //       let DeviceLastReadingDate = this.responselist[i][46];
    //       let DeviceLastReadingTime = this.responselist[i][47];
    //       let ReadingDateTime =
    //         DeviceLastReadingDate + "T" + DeviceLastReadingTime;
    //       let now = new Date();
    //       let ReadingDate = new Date(ReadingDateTime);
    //       let oneday = 24 * 60 * 60 * 1000;

    //       let DeviceOnline = "";
    //       if (now - ReadingDate > oneday) {
    //         DeviceOnline = "FALSE";
    //       } else if (
    //         (this.responselist[i][46] != null) &
    //         (this.responselist[i][47] != null)
    //       ) {
    //         DeviceOnline = "TRUE";
    //       }

    //       if (this.responselist[i][46] == null || this.responselist[i][47] == null) {
    //         DeviceOnline = "FALSE";
    //       }

    //       let p1trend = this.responselist[i][8]
    //       let p2trend = this.responselist[i][28]
    //       let DeviceTrend = ''

    //       if(this.responselist[i][23] == 'FALSE'){
    //         DeviceTrend = p1trend
    //       } else if(p1trend == p2trend){
    //         DeviceTrend = p1trend
    //       } else if (p1trend == 'UP' || p2trend == 'UP'){
    //         DeviceTrend = 'UP'
    //       }else if(p1trend == 'DOWN' || p2trend == 'DOWN'){
    //         DeviceTrend = 'DOWN'
    //       } else{
    //         DeviceTrend = 'STABLE'
    //       }

    //       let LoopEnd = false;

    //       if (i == this.responselist.length - 1) {
    //         LoopEnd = true;
    //       }
    //       this.IDGetArrays(this.responselist[i][0], "C1", LoopEnd);


    //       this.responseArray.push({
    //         DeviceID: this.responselist[i][0],
    //         Location: this.responselist[i][2],
    //         DeptFloor: this.responselist[i][1],
    //         Probe1Active: this.responselist[i][3],
    //         Probe1Feed: this.responselist[i][4],
    //         Probe1Position: this.responselist[i][5],
    //         Probe1AvgTemp: this.responselist[i][12],
    //         Probe1TempLimit: this.Probe1TempLimit,
    //         Probe1MinTemp: Probe1MinRnd,
    //         Probe1AvgTempRounded: Probe1TempRnd,
    //         Probe1TempVariant: Probe1TempVariant,
    //         Probe1FlowVariant: Probe1FlowVariant,
    //         Probe1LastFlowDate: this.responselist[i][13],
    //         Probe1LastFlowTime: this.responselist[i][14],
    //         Probe1TimeSinceLastFlow: this.time,
    //         Probe1ScoreVariant: Probe1ScoreVariant,
    //         Probe1Tag: probe1tag,
    //         Probe1Class: probe1class,
    //         Probe1TagClass: probe1tagclass,
    //         Probe1Title: probe1title,
    //         Probe1Bio: this.responselist[i][49][0],
    //         Probe1BioVariant: p1biovar,
    //         Probe2Active: this.responselist[i][23],
    //         Probe2Feed: this.responselist[i][24],
    //         Probe2Position: this.responselist[i][25],
    //         Probe2AvgTemp: this.responselist[i][32],
    //         Probe2TempLimit: this.Probe2TempLimit,
    //         Probe2MinTemp: Probe2MinRnd,
    //         Probe2AvgTempRounded: Probe2TempRnd,
    //         Probe2TempVariant: Probe2TempVariant,
    //         Probe2FlowVariant: Probe2FlowVariant,
    //         Probe2TimeSinceLastFlow: timeProbe2,
    //         Probe2ScoreVariant: Probe2ScoreVariant,
    //         Probe2LastFlowDate: this.responselist[i][33],
    //         Probe2LastFlowTime: this.responselist[i][34],
    //         Probe2Tag: probe2tag,
    //         Probe2Class: probe2class,
    //         Probe2TagClass: probe2tagclass,
    //         Probe2Title: probe2title,
    //         Probe2Bio: this.responselist[i][49][1],
    //         Probe2BioVariant: p2biovar,
    //         HCEnvironment: this.responselist[i][43],
    //         Trending: DeviceTrend,
    //         HumanName: this.responselist[i][46],
    //         variant: headervariant,
    //         DeviceOnline: DeviceOnline,
    //         Breaches: this.responselist[i][50]

    //       })
    //       }
    //   }
    //   this.C1Loaded = true;

    //   this.DeviceMessage = "Total Devices for " + this.selectedlocation;
    // });
    let LookUpURL2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/statuscounts";
    let LookUpHeaders2 = this.$apikeyPost;
    let LookUpData2 = {
      RequestType: "Company",
      RequestVariable: this.CompanyName,
    };
    axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
      response;
    });
    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = {
      RequestType: "Location",
      Company: this.CompanyName,
    };
    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersFeed = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.Positions = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ id: QuoteStr, value: this.feedList[i][1] });
        }
        for (let i = 0; i < this.Positions.length; i++) {
          var QuoteStr2 = this.Positions[i][0];
          this.PositionArray.push({
            id: QuoteStr2,
            value: this.Positions[i][1],
          });
        }
      });
  },
  methods: {

    LoadC1Data(filter1,filter2,filter3,filter4) {
      
    let FilterTypes = filter1
    let FilterState = filter2
    let FilterName = filter3
    let FilterFeed = filter4

    if (typeof FilterTypes == 'undefined'){
      FilterTypes = []
    }
    if (typeof FilterState == 'undefined'){
      FilterState = ""
    }
    if (typeof FilterName == 'undefined'){
      FilterName = ""
    }
    if (typeof FilterFeed == 'undefined'){
      FilterFeed = ""
    } else if (FilterFeed.length == 0){
      FilterFeed = ""
    } else{
      FilterFeed = FilterFeed[0]
    }

    if (FilterState == 4){
      FilterState = "Low Risk"
    }
    if (FilterState == 3){
      FilterState = "Moderate Risk"
    }
    if (FilterState == 2){
      FilterState = "High Risk"
    }
    if (FilterState == 1){
      FilterState = "Extremely High Risk"
    }

      if (this.DataFiltered == true){
        return;
      }
      else {

      this.responseArray = [];

      this.C1Loaded = false;

      let LookUpURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/dashboard";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpData = {
      Report: "DeviceReport",
      RequestType: "",
      RequestVariable: this.selectedlocation,
      DataDict: [
        {
          FilterType: FilterTypes,
          State: FilterState,
          DeviceName: FilterName,
          Feed: FilterFeed
        },
      ],
    };
    axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {  
      (this.chartOptionsLine = {
        dataLabels: {
          enabled: false,
        },
        title: {
          text: "7 Day Device Trend",
          align: "center",
        },
        legend: {
          show: true,
        },
        chart: { stacked: true },
        sparkline: {
          enabled: true,
        },
        fill: {
          opacity: 1,
        },
        xaxis: {
          categories: response.data.DayDeviceTrend.DateList,
          labels: {
            show: true,
          },
        },
        // xaxis: {
        //   categories: [
        //     "Day 7",
        //     "Day 6",
        //     "Day 5",
        //     "Day 4",
        //     "Day 3",
        //     "Day 2",
        //     "Day 1",
        //   ],
        //   labels:
        //   {
        //     show:true
        //   }
        // },
        yaxis: {
          labels: {
            show: true,
          },
        },
        colors: ["#dc3546", "#f05f16", "#ffc107", "#28a746"],
        grid: {
          show: true, // you can either change hear to disable all grids
          xaxis: {
            lines: {
              show: true, //or just here to disable only x axis grids
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false, //or just here to disable only y axis
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
        },
      }),
        (this.seriesLine = [
          {
            name: "Extremely High Risk",
            data: response.data.DayDeviceTrend.ExtHighCounts,
          },
          {
            name: "High Risk",
            data: response.data.DayDeviceTrend.HighCounts,
          },
          {
            name: "Moderate Risk",
            data: response.data.DayDeviceTrend.ModCounts,
          },
          {
            name: "Low Risk",
            data: response.data.DayDeviceTrend.LowCounts,
          },
        ]),
   
        this.C1LowCount = 0;
        this.C1ModCount = 0;
        this.C1HiCount = 0;
        this.C1ExtHiCount = 0;

        this.C1LowCount = response.data.DeviceStatusCounts.LowRiskCount;
        this.C1ModCount = response.data.DeviceStatusCounts.ModerateRiskCount;
        this.C1HiCount = response.data.DeviceStatusCounts.HighRiskCount;
        this.C1ExtHiCount = response.data.DeviceStatusCounts.ExtremelyHighRiskCount;


      this.C1DayTrendData = response.data.DayDeviceTrend;
      this.C1CurrentDeviceStatusCounts = response.data.DeviceStatusCounts;
      this.donutSeries = [
        this.C1CurrentDeviceStatusCounts.ExtremelyHighRiskCount,
        this.C1CurrentDeviceStatusCounts.HighRiskCount,
        this.C1CurrentDeviceStatusCounts.ModerateRiskCount,
        this.C1CurrentDeviceStatusCounts.LowRiskCount,
      ];


      if (response.data.Values == "") {
        this.responseArray = [];
        this.responseArray = ["No Data"];
      } else if (response.data.Values != "") {
        this.responselist = response.data.Values;
        let IDArray = [];
        for (let i = 0; i < this.responselist.length; i++) {
          IDArray.push([this.responselist[i][0], i]);
        }
       
        for (let i = 0; i < this.responselist.length; i++) {

          let probe1tag = 'No Tag';
          let probe2tag = 'No Tag';

          let probe1tagclass = "light";
          let probe2tagclass = "light";

          let probe1class = "lightbackicon";
          let probe2class = "lightbackicon";

          let probe1title = "Probe1: No Feed";
          let probe2title = "Probe2: No Feed";

          let p1biovar = 'light';
          let p2biovar = 'light';

          let probeArray = this.responselist[i][51]

          for(let x=0;x<probeArray.length;x++){ 
            if (probeArray[x].length > 0){
               for(let y =0; y<probeArray[x].length;y++){
                if(probeArray[x][y][0] == '1'){
                  probe1tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe1tag)){
                    probe1class = 'hotbackicon',
                    probe1title = 'Probe1: Hot Feed',
                    probe1tagclass = "danger"
                  } else if(this.coldarray.includes(probe1tag)){
                    probe1class = 'coldbackicon',
                    probe1title = 'Probe1: Cold Feed',
                    probe1tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe1tag)){
                    probe1class = 'mixedbackicon',
                    probe1title = 'Probe1: Mixed Feed',
                    probe1tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe1tag)){
                    probe1class = 'returnbackicon',
                    probe1title = 'Probe1: Return Feed',
                    probe1tagclass = "returnicon"
                  }
                } else if(probeArray[x][y][0] == '2'){
                  probe2tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe2tag)){
                    probe2class = 'hotbackicon',
                    probe2title = 'Probe2: Hot Feed',
                    probe2tagclass = "danger"
                  } else if(this.coldarray.includes(probe2tag)){
                    probe2class = 'coldbackicon',
                    probe2title = 'Probe2: Cold Feed',
                    probe2tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe2tag)){
                    probe2class = 'mixedbackicon',
                    probe2title = 'Probe2: Mixed Feed',
                    probe2tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe2tag)){
                    probe2class = 'returnbackicon',
                    probe2title = 'Probe2: Return Feed',
                    probe2tagclass = "returnicon"
                  }
                }
              }
            }
          }

          if(this.responselist[i][3] == "TRUE"){
            if((this.responselist[i][49][0]>=1)&&(this.responselist[i][49][0]<=1.49)){
              p1biovar = "success"
            } else if((this.responselist[i][49][0]>=1.5) && (this.responselist[i][49][0]<=2.49)){
              p1biovar = "warning"
            } else if((this.responselist[i][49][0]>=2.5) && (this.responselist[i][49][0]<=4)){
              p1biovar = "highRisk"
            } else if(this.responselist[i][49][0]>=4.1){
              p1biovar = "danger"
            } else{
              p1biovar = 'light'
            }
          }

          let Probe1MinRnd = Math.round(this.responselist[i][10]);
          let Probe1TempRnd = Math.round(this.responselist[i][11]);
          this.Probe1TempLimit = Math.round(this.responselist[i][9]);
          let Probe1TempVariant = this.getProbeRiskLevel(this.responselist[i][9]);
          let Probe1FlowVariant = '';
          let Probe1ScoreVariant = '';
         
          if (this.responselist[i][3] == "TRUE") {
   
            if (this.responselist[i][7] == "Extremely High Risk") {
              Probe1ScoreVariant = "danger";
            } else if (this.responselist[i][7] == "High Risk") {
              Probe1ScoreVariant = "highRisk";
            } else if (this.responselist[i][7] == "Moderate Risk") {
              Probe1ScoreVariant = "warning";
            } else if (this.responselist[i][7] == "Low Risk") {
              Probe1ScoreVariant = "success";
            } else{
              Probe1ScoreVariant = "light"
            }
          }

          if (this.responselist[i][3] == "TRUE") {     
            if (this.responselist[i][13] == null || this.responselist[i][14] == null) {
              this.time = "N/A";
              Probe1FlowVariant = "light";
            } else {
             
              let FlowTimeDate = this.responselist[i][13] + "T" + this.responselist[i][14];
              let d1 = new Date().toUTCString();

              d1 = new Date(d1).getTime();

              let d2 = new Date(FlowTimeDate);

              d2 = new Date(d2).getTime();

              this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);

              if (this.time <= 8) {
                Probe1FlowVariant = "success";
              }
              if ((this.time >= 9) & (this.time <= 24)) {
                Probe1FlowVariant = "warning";
              }
              if ((this.time >= 25) & (this.time <= 47)) {
                Probe1FlowVariant = "warning";
              }
              if (this.time >= 48) {
                Probe1FlowVariant = "danger";
              }
            }
          }
          
            let Probe2MinRnd = Math.round(this.responselist[i][30]);
            let Probe2TempRnd = Math.round(this.responselist[i][31]);
            this.Probe2TempLimit = Math.round(this.responselist[i][29])
            let Probe2TempVariant = this.getProbeRiskLevel(this.responselist[i][29]);
            let Probe2FlowVariant = '';
            let Probe2ScoreVariant = '';
            let timeProbe2 = '';

          if (this.responselist[i][23] == "TRUE") {
            if (this.responselist[i][27] == "Extremely High Risk") {
              Probe2ScoreVariant = "danger";
            } else if (this.responselist[i][27] == "High Risk") {
              Probe2ScoreVariant = "highRisk";
            } else if (this.responselist[i][27] == "Moderate Risk") {
              Probe2ScoreVariant = "warning";
            } else if (this.responselist[i][27] == "Low Risk") {
              Probe2ScoreVariant = "success";
            }else{
              Probe2ScoreVariant = "light";
            }
          }

          if(this.responselist[i][23] == "TRUE"){
            if(this.responselist[i][49][1]>=1&&(this.responselist[i][49][1]<=1.49)){
              p2biovar = "success"
            } else if((this.responselist[i][49][1]>=1.5) && (this.responselist[i][49][1]<=2.49)){
              p2biovar = "warning"
            } else if((this.responselist[i][49][1]>=2.5) && (this.responselist[i][49][1]<=4)){
              p2biovar = "highRisk"
            } else if(this.responselist[i][49][1]>=4.1){
              p2biovar = "danger"
            } else{
              p2biovar = 'light'
            }
          }

          let headervariant = '';
          if (this.responselist[i][44] == "Moderate Risk") {
            headervariant = "warning";
          } else if (this.responselist[i][44] == "Low Risk") {
            headervariant = "success";
          } else if (this.responselist[i][44] == "High Risk") {
            headervariant = "highRisk";
          } else {
            headervariant = "danger";
          }


          if (this.responselist[i][23] == "TRUE") {     
            if (this.responselist[i][33] == null || this.responselist[i][34] == null) {
              timeProbe2 = "N/A";
              Probe2FlowVariant = "light";
            } else {
             
              let FlowTimeDate = this.responselist[i][33] + "T" + this.responselist[i][34];
              let d1 = new Date().toUTCString();

              d1 = new Date(d1).getTime();

              let d2 = new Date(FlowTimeDate);

              d2 = new Date(d2).getTime();

              timeProbe2 = Math.floor((d1 - d2) / 1000 / 60 / 60);

              if (timeProbe2 <= 8) {
                Probe2FlowVariant = "success";
              }
              if ((timeProbe2 >= 9) & (timeProbe2 <= 24)) {
                Probe2FlowVariant = "warning";
              }
              if ((timeProbe2 >= 25) & (timeProbe2 <= 47)) {
                Probe2FlowVariant = "warning";
              }
              if (timeProbe2 >= 48) {
                Probe2FlowVariant = "danger";
              }
            }
          }

          let DeviceLastReadingDate = this.responselist[i][46];
          let DeviceLastReadingTime = this.responselist[i][47];
          let ReadingDateTime =
            DeviceLastReadingDate + "T" + DeviceLastReadingTime;
          let now = new Date();
          let ReadingDate = new Date(ReadingDateTime);
          let oneday = 24 * 60 * 60 * 1000;

          let DeviceOnline = "";
          if (now - ReadingDate > oneday) {
            DeviceOnline = "FALSE";
          } else if (
            (this.responselist[i][46] != null) &
            (this.responselist[i][47] != null)
          ) {
            DeviceOnline = "TRUE";
          }

          if (this.responselist[i][46] == null || this.responselist[i][47] == null) {
            DeviceOnline = "FALSE";
          }

          let p1trend = this.responselist[i][8]
          let p2trend = this.responselist[i][28]
          let DeviceTrend = ''

          if(this.responselist[i][23] == 'FALSE'){
            DeviceTrend = p1trend
          } else if(p1trend == p2trend){
            DeviceTrend = p1trend
          } else if (p1trend == 'UP' || p2trend == 'UP'){
            DeviceTrend = 'UP'
          }else if(p1trend == 'DOWN' || p2trend == 'DOWN'){
            DeviceTrend = 'DOWN'
          } else{
            DeviceTrend = 'STABLE'
          }

          let LoopEnd = false;

          if (i == this.responselist.length - 1) {
            LoopEnd = true;
          }
          this.IDGetArrays(this.responselist[i][0], "C1", LoopEnd);


          this.responseArray.push({
            DeviceID: this.responselist[i][0],
            Location: this.responselist[i][2],
            DeptFloor: this.responselist[i][1],
            Probe1Active: this.responselist[i][3],
            Probe1Feed: this.responselist[i][4],
            Probe1Position: this.responselist[i][5],
            Probe1AvgTemp: this.responselist[i][12],
            Probe1TempLimit: this.Probe1TempLimit,
            Probe1MinTemp: Probe1MinRnd,
            Probe1AvgTempRounded: Probe1TempRnd,
            Probe1TempVariant: Probe1TempVariant,
            Probe1FlowVariant: Probe1FlowVariant,
            Probe1LastFlowDate: this.responselist[i][13],
            Probe1LastFlowTime: this.responselist[i][14],
            Probe1TimeSinceLastFlow: this.time,
            Probe1ScoreVariant: Probe1ScoreVariant,
            Probe1Tag: probe1tag,
            Probe1Class: probe1class,
            Probe1TagClass: probe1tagclass,
            Probe1Title: probe1title,
            Probe1Bio: this.responselist[i][49][0],
            Probe1BioVariant: p1biovar,
            Probe2Active: this.responselist[i][23],
            Probe2Feed: this.responselist[i][24],
            Probe2Position: this.responselist[i][25],
            Probe2AvgTemp: this.responselist[i][32],
            Probe2TempLimit: this.Probe2TempLimit,
            Probe2MinTemp: Probe2MinRnd,
            Probe2AvgTempRounded: Probe2TempRnd,
            Probe2TempVariant: Probe2TempVariant,
            Probe2FlowVariant: Probe2FlowVariant,
            Probe2TimeSinceLastFlow: timeProbe2,
            Probe2ScoreVariant: Probe2ScoreVariant,
            Probe2LastFlowDate: this.responselist[i][33],
            Probe2LastFlowTime: this.responselist[i][34],
            Probe2Tag: probe2tag,
            Probe2Class: probe2class,
            Probe2TagClass: probe2tagclass,
            Probe2Title: probe2title,
            Probe2Bio: this.responselist[i][49][1],
            Probe2BioVariant: p2biovar,
            HCEnvironment: this.responselist[i][43],
            Trending: DeviceTrend,
            HumanName: this.responselist[i][46],
            variant: headervariant,
            DeviceOnline: DeviceOnline,
            Breaches: this.responselist[i][50]

          })
          }
      }
      this.C1Loaded = true;
      this.O1Loaded = true;

      this.DeviceMessage = "Total Devices for " + this.selectedlocation;

    });
    }},

    LoadO1Data(filter1,filter2,filter3,filter4) {

    let FilterTypes = filter1
    let FilterState = filter2
    let FilterName = filter3
    let FilterFeed = filter4

    if (typeof FilterTypes == 'undefined'){
      FilterTypes = []
    }
    if (typeof FilterState == 'undefined'){
      FilterState = ""
    }
    if (typeof FilterName == 'undefined'){
      FilterName = ""
    }
    if (typeof FilterFeed == 'undefined'){
      FilterFeed = ""
    } else if (FilterFeed.length == 0){
      FilterFeed = ""
    } else{
      FilterFeed = FilterFeed[0]
    }

    if (FilterState == 4){
      FilterState = "Low Risk"
    }
    if (FilterState == 3){
      FilterState = "Moderate Risk"
    }
    if (FilterState == 2){
      FilterState = "High Risk"
    }
    if (FilterState == 1){
      FilterState = "Extremely High Risk"
    }

      if(this.DataFiltered == true){
        return;
      }
      else{

      this.O1Array = [];
      this.O1Loaded = false;
      let LookUpUrlO1 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/dashboard";
    let LookUpHeaders01 = this.$apikeyPost;
        this.LookUpRequest = {
      Report: "NewO1Report",
      RequestVariable: this.selectedlocation,
      DataDict: [
        {
          FilterType: FilterTypes,
          State: FilterState,
          DeviceName: FilterName,
          Feed: FilterFeed
        },
      ],
    };
    axios
      .post(LookUpUrlO1, this.LookUpRequest, LookUpHeaders01)
      .then((response) => {
        let O1DataList = response.data.Values;

        this.O1LowCount = 0;
        this.O1ModCount = 0;
        this.O1HiCount = 0;
        this.O1ExtHiCount = 0;

        this.O1LowCount = response.data.DeviceStatusCounts.LowRiskCount;
        this.O1ModCount = response.data.DeviceStatusCounts.ModerateRiskCount;
        this.O1HiCount = response.data.DeviceStatusCounts.HighRiskCount;
        this.O1ExtHiCount = response.data.DeviceStatusCounts.ExtremelyHighRiskCount;

        this.seriesLine2 = [
          {
            name: "Extremely High Risk",
            data: response.data.DayDeviceTrend.ExtHighCounts,
          },
          {
            name: "High Risk",
            data: response.data.DayDeviceTrend.HighCounts,
          },
          {
            name: "Moderate Risk",
            data: response.data.DayDeviceTrend.ModCounts,
          },
          {
            name: "Low Risk",
            data: response.data.DayDeviceTrend.LowCounts,
          },
        ];
        this.donutSeries2 = [
          response.data.DeviceStatusCounts.ExtremelyHighRiskCount,
          response.data.DeviceStatusCounts.HighRiskCount,
          response.data.DeviceStatusCounts.ModerateRiskCount,
          response.data.DeviceStatusCounts.LowRiskCount,
        ];

        let O1Local = [];
        for (let i = 0; i < O1DataList.length; i++) {
          let Probe1TempVariant = "";
          let Probe2TempVariant = "";
          let Probe3TempVariant = "";
          let Probe4TempVariant = "";

          let Probe1FlowVariant = "";
          let Probe2FlowVariant = "";
          let Probe3FlowVariant = "";
          let Probe4FlowVariant = "";

          // Adding in the logic from lambda for temperatures, starting with HOT TEMPS

          if (O1DataList[i][3] == "TRUE") {
           this.Probe1TempLimit = Math.round(O1DataList[i][8]);
           Probe1TempVariant = this.getProbeRiskLevel(O1DataList[i][10])
          } else if (O1DataList[i][3] == "FALSE") {
            Probe1TempVariant = "light";
            Probe1FlowVariant = "light";
          }
          //PROBE 2

          if (O1DataList[i][14] == "TRUE") {
            this.Probe2TempLimit = Math.round(O1DataList[i][19]);
            Probe2TempVariant = this.getProbeRiskLevel(O1DataList[i][21])
          } else if (O1DataList[i][14] == "FALSE") {
            Probe2TempVariant = "light";
            Probe2FlowVariant = "light";
          }

          // Probe 3 
          if (O1DataList[i][25] == "TRUE") {
            this.Probe3TempLimit = Math.round(O1DataList[i][30]);
            Probe3TempVariant = this.getProbeRiskLevel(O1DataList[i][32])
          } else if (O1DataList[i][25] == "FALSE") {
            Probe3TempVariant = "light";
            Probe3FlowVariant = "light";
          }
          //Probe 4 
          if (O1DataList[i][36] == "TRUE") {
           this.Probe4TempLimit = Math.round(O1DataList[i][41]);
           Probe4TempVariant = this.getProbeRiskLevel(O1DataList[i][43])
          } else if (O1DataList[i][36] == "FALSE") {
            Probe4TempVariant = "light";
            Probe4FlowVariant = "light";
          }

          let Probe1ScoreVariant = "";
          let Probe2ScoreVariant = "";
          let Probe3ScoreVariant = "";
          let Probe4ScoreVariant = "";

          if (O1DataList[i][3] == "TRUE") {
   
            if (O1DataList[i][7] == "Extremely High Risk") {
              Probe1ScoreVariant = "danger";
            } else if (O1DataList[i][7] == "High Risk") {
              Probe1ScoreVariant = "highRisk";
            } else if (O1DataList[i][7] == "Moderate Risk") {
              Probe1ScoreVariant = "warning";
            } else if (O1DataList[i][7] == "Low Risk") {
              Probe1ScoreVariant = "success";
            }
          }
          if (O1DataList[i][14] == "TRUE") {

            if (O1DataList[i][18] == "Extremely High Risk") {
              Probe2ScoreVariant = "danger";
            } else if (O1DataList[i][18] == "High Risk") {
              Probe2ScoreVariant = "highRisk";
            } else if (O1DataList[i][18] == "Moderate Risk") {
              Probe2ScoreVariant = "warning";
            } else if (O1DataList[i][18] == "Low Risk") {
              Probe2ScoreVariant = "success";
            }
          }
          if (O1DataList[i][25] == "TRUE") {
            if (O1DataList[i][29] == "Extremely High Risk") {
              Probe3ScoreVariant = "danger";
            } else if (O1DataList[i][29] == "High Risk") {
              Probe3ScoreVariant = "highRisk";
            } else if (O1DataList[i][29] == "Moderate Risk") {
              Probe3ScoreVariant = "warning";
            } else if (O1DataList[i][29] == "Low Risk") {
              Probe3ScoreVariant = "success";
            }
          }
          if (O1DataList[i][36] == "TRUE") {

            if (O1DataList[i][40] == "Extremely High Risk") {
              Probe4ScoreVariant = "danger";
            } else if (O1DataList[i][40] == "High Risk") {
              Probe4ScoreVariant = "highRisk";
            } else if (O1DataList[i][40] == "Moderate Risk") {
              Probe4ScoreVariant = "warning";
            } else if (O1DataList[i][40] == "Low Risk") {
              Probe4ScoreVariant = "success";
            }
          }

          //Probe 1
          //PROBE 1 TIME
          if (O1DataList[i][3] == "TRUE") {
            
            if (O1DataList[i][12] == null || O1DataList[i][13] == null) {
              this.time = "N/A";
              Probe1FlowVariant = "light";
            } else {
             
              let FlowTimeDate = O1DataList[i][12] + "T" + O1DataList[i][13];
              let d1 = new Date().toUTCString();

              d1 = new Date(d1).getTime();

              // NEW DATETIME TEST CODE FOR SAFARI

              // FlowTimeDate = FlowTimeDate.replace(/ /g, "T");
              // FlowTimeDate = "2017-01-22T11:57:00";

              let d2 = new Date(FlowTimeDate);

              // d2 = d2.toLocaleString("en-US", { timeZone: "UTC" });

              d2 = new Date(d2).getTime();

              this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);

              if (this.time <= 8) {
                Probe1FlowVariant = "success";
              }
              if ((this.time >= 9) & (this.time <= 24)) {
                Probe1FlowVariant = "warning";
              }
              if ((this.time >= 25) & (this.time <= 47)) {
                Probe1FlowVariant = "warning";
              }
              if (this.time >= 48) {
                Probe1FlowVariant = "danger";
              }
            }
          }
          //Probe 2
          // PROBE 2 TIME
          if (O1DataList[i][14] == "TRUE") {
            //probe flow date and time now [i][23] & [i][24]
            if (O1DataList[i][23] == null || O1DataList[i][24] == null) {
              timeProbe2 = "N/A";
              Probe2FlowVariant = "light";
            } else {
              // let adjustedTime = null;
              let FlowTimeDateProbe2 =
                O1DataList[i][23] + "T" + O1DataList[i][24];
              // this.UpdateTimeDate(O1DataList[i][17], O1DataList[i][18]).then(
              //   (TimeResponse) => {
              //     adjustedTime = TimeResponse;
              //   }
              // );

              let d1Probe2 = new Date().toUTCString();
              d1Probe2 = new Date(d1Probe2).getTime();
              let d2Probe2 = new Date(FlowTimeDateProbe2).getTime();
              var timeProbe2 = Math.floor(
                (d1Probe2 - d2Probe2) / 1000 / 60 / 60
              );
              if (timeProbe2 <= 8) {
                Probe2FlowVariant = "success";
              }
              if ((timeProbe2 >= 9) & (timeProbe2 <= 24)) {
                Probe2FlowVariant = "warning";
              }
              if ((timeProbe2 >= 25) & (timeProbe2 <= 47)) {
                Probe2FlowVariant = "warning";
              }
              if (timeProbe2 >= 48) {
                Probe2FlowVariant = "danger";
              }
            }
          }
          //Probe3
          // PROBE 3 TIME
          if (O1DataList[i][25] == "TRUE") {
            if (O1DataList[i][34] == null || O1DataList[i][35] == null) {
              timeProbe3 = "N/A";
              Probe3FlowVariant = "light";
            } else {
              let FlowTimeDateProbe3 =
                O1DataList[i][34] + "T" + O1DataList[i][35];
              let d1Probe3 = new Date().toUTCString();
              d1Probe3 = new Date(d1Probe3).getTime();
              let d2Probe3 = new Date(FlowTimeDateProbe3).getTime();
              var timeProbe3 = Math.floor(
                (d1Probe3 - d2Probe3) / 1000 / 60 / 60
              );
              if (timeProbe3 <= 8) {
                Probe3FlowVariant = "success";
              }
              if ((timeProbe3 >= 9) & (timeProbe3 <= 24)) {
                Probe3FlowVariant = "warning";
              }
              if ((timeProbe3 >= 25) & (timeProbe3 <= 47)) {
                Probe3FlowVariant = "warning";
              }
              if (timeProbe3 >= 48) {
                Probe3FlowVariant = "danger";
              }
            }
          }
          //Probe 4
          // PROBE 4 TIME
          if (O1DataList[i][36] == "TRUE") {
            //probe flow date and time now [i][45] & [i][46]
            if (O1DataList[i][45] == null || O1DataList[i][46] == null) {
              timeProbe4 = "N/A";
              Probe4FlowVariant = "light";
            } else {
              let FlowTimeDateProbe4 =
                O1DataList[i][45] + "T" + O1DataList[i][46];
              let d1Probe4 = new Date().toUTCString();
              d1Probe4 = new Date(d1Probe4).getTime();
              let d2Probe4 = new Date(FlowTimeDateProbe4).getTime();
              var timeProbe4 = Math.floor(
                (d1Probe4 - d2Probe4) / 1000 / 60 / 60
              );
              if (timeProbe4 <= 8) {
                Probe4FlowVariant = "success";
              }
              if ((timeProbe4 >= 9) & (timeProbe4 <= 24)) {
                Probe4FlowVariant = "warning";
              }
              if ((timeProbe4 >= 25) & (timeProbe4 <= 47)) {
                Probe4FlowVariant = "warning";
              }
              if (timeProbe4 >= 48) {
                Probe4FlowVariant = "danger";
              }
            }
          }


          let Probe1TempRnd = Math.round(O1DataList[i][10]);
          let Probe2TempRnd = Math.round(O1DataList[i][21]);
          let Probe3TempRnd = Math.round(O1DataList[i][32]);
          let Probe4TempRnd = Math.round(O1DataList[i][43]);
          let HeaderVariant = "";

          let Probe1MinRnd = Math.round(O1DataList[i][9]);
          let Probe2MinRnd = Math.round(O1DataList[i][20]);
          let Probe3MinRnd = Math.round(O1DataList[i][31]);
          let Probe4MinRnd = Math.round(O1DataList[i][42]);
    
          if (O1DataList[i][49] == "Moderate Risk") {
            HeaderVariant = "warning";
          } else if (O1DataList[i][49] == "Low Risk") {
            HeaderVariant = "success";
          } else if (O1DataList[i][49] == "High Risk") {
            HeaderVariant = "highRisk";
          } else {
            HeaderVariant = "danger";
          }

          let DeviceLastReadingDate = O1DataList[i][51];
          let DeviceLastReadingTime = O1DataList[i][52];
          let ReadingDateTime =
            DeviceLastReadingDate + "T" + DeviceLastReadingTime;
          let now = new Date();
          let ReadingDate = new Date(ReadingDateTime);
          let oneday = 24 * 60 * 60 * 1000;

          let DeviceOnline = "";
          if (now - ReadingDate > oneday) {
            DeviceOnline = "FALSE";
          } else if (
            (O1DataList[i][51] != null) &
            (O1DataList[i][52] != null)
          ) {
            DeviceOnline = "TRUE";
          }

          if (O1DataList[i][51] == null || O1DataList[i][52] == null) {
            DeviceOnline = "FALSE";
          }

          let probe1tag = 'No Tag';
          let probe2tag = 'No Tag';
          let probe3tag = 'No Tag';
          let probe4tag = 'No Tag';

          let probe1tagclass = "light";
          let probe2tagclass = "light";
          let probe3tagclass = "light";
          let probe4tagclass = "light";

          let probe1class = "lightbackicon";
          let probe2class = "lightbackicon";
          let probe3class = "lightbackicon";
          let probe4class = "lightbackicon";

          let probe1title = "Probe1: No Feed";
          let probe2title = "Probe2: No Feed";
          let probe3title = "Probe3: No Feed";
          let probe4title = "Probe4: No Feed";


          let probeArray = O1DataList[i][55]

          for(let x=0;x<probeArray.length;x++){ 
            if (probeArray[x].length > 0){
               for(let y =0; y<probeArray[x].length;y++){
                if(probeArray[x][y][0] == '1'){
                  probe1tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe1tag)){
                    probe1class = 'hotbackicon',
                    probe1title = 'Probe1: Hot Feed',
                    probe1tagclass = "danger"
                  } else if(this.coldarray.includes(probe1tag)){
                    probe1class = 'coldbackicon',
                    probe1title = 'Probe1: Cold Feed',
                    probe1tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe1tag)){
                    probe1class = 'mixedbackicon',
                    probe1title = 'Probe1: Mixed Feed',
                    probe1tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe1tag)){
                    probe1class = 'returnbackicon',
                    probe1title = 'Probe1: Return Feed',
                    probe1tagclass = "returnicon"
                  }
                } else if(probeArray[x][y][0] == '2'){
                  probe2tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe2tag)){
                    probe2class = 'hotbackicon',
                    probe2title = 'Probe2: Hot Feed',
                    probe2tagclass = "danger"
                  } else if(this.coldarray.includes(probe2tag)){
                    probe2class = 'coldbackicon',
                    probe2title = 'Probe2: Cold Feed',
                    probe2tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe2tag)){
                    probe2class = 'mixedbackicon',
                    probe2title = 'Probe2: Mixed Feed',
                    probe2tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe2tag)){
                    probe2class = 'returnbackicon',
                    probe2title = 'Probe2: Return Feed',
                    probe2tagclass = "returnicon"
                  }
                } else if(probeArray[x][y][0] == '3'){
                  probe3tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe3tag)){
                    probe3class = 'hotbackicon',
                    probe3title = 'Probe3: Hot Feed',
                    probe3tagclass = "danger"
                  } else if(this.coldarray.includes(probe3tag)){
                    probe3class = 'coldbackicon',
                    probe3title = 'Probe3: Cold Feed',
                    probe3tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe3tag)){
                    probe3class = 'mixedbackicon',
                    probe3title = 'Probe3: Mixed Feed',
                    probe3tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe3tag)){
                    probe3class = 'returnbackicon',
                    probe3title = 'Probe3: Return Feed',
                    probe3tagclass = "returnicon"
                  }
                } else if(probeArray[x][y][0] == '4'){
                  probe4tag = probeArray[x][y][1]
                  if(this.hotarray.includes(probe4tag)){
                    probe4class = 'hotbackicon',
                    probe4title = 'Probe4: Hot Feed',
                    probe4tagclass = "danger"
                  } else if(this.coldarray.includes(probe4tag)){
                    probe4class = 'coldbackicon',
                    probe4title = 'Probe4: Cold Feed',
                    probe4tagclass = "coldicon"
                  } else if(this.mixedarray.includes(probe4tag)){
                    probe4class = 'mixedbackicon',
                    probe4title = 'Probe4: Mixed Feed',
                    probe4tagclass = "mixedicon"
                  } else if(this.returnarray.includes(probe4tag)){
                    probe4class = 'returnbackicon',
                    probe4title = 'Probe4: Return Feed',
                    probe4tagclass = "returnicon"
                  }
                }
               }
            } else{
               probe1tag = 'No Tag';
               probe2tag = 'No Tag';
               probe3tag = 'No Tag';
               probe4tag = 'No Tag';
            }
          }

          let LoopEnd = false;

          if (i == O1DataList.length - 1) {
            LoopEnd = true;
          }
          this.IDGetArrays(O1DataList[i][0], "O1", LoopEnd);

          O1Local.push({
            DeviceID: O1DataList[i][0],
            Location: O1DataList[i][1],
            Department: O1DataList[i][2],
            Probe1Active: O1DataList[i][3],
            Probe1Feed: O1DataList[i][4],
            Probe1Position: O1DataList[i][5],
            Probe1Score: O1DataList[i][6],
            Probe1Offset: O1DataList[i][7],
            Probe1AvgTemp: O1DataList[i][10],
            Probe1TempLimit: this.Probe1TempLimit,
            Probe1MinTemp: Probe1MinRnd,
            Probe1AvgTempRounded: Probe1TempRnd,
            Probe1TempVariant: Probe1TempVariant,
            Probe1FlowVariant: Probe1FlowVariant,
            Probe1LastFlowDate: O1DataList[i][12],
            Probe1LastFlowTime: O1DataList[i][13],
            Probe1TimeSinceLastFlow: this.time,
            Probe1ScoreVariant: Probe1ScoreVariant,
            Probe1Tag: probe1tag,
            Probe1Class: probe1class,
            Probe1TagClass: probe1tagclass,
            Probe1Title: probe1title,

            Probe2Active: O1DataList[i][14],
            Probe2Feed: O1DataList[i][15],
            Probe2Position: O1DataList[i][16],
            Probe2Score: O1DataList[i][14],
            Probe2Offset: O1DataList[i][15],
            Probe2AvgTemp: O1DataList[i][21],
            Probe2TempLimit: this.Probe2TempLimit,
            Probe2MinTemp: Probe2MinRnd,
            Probe2AvgTempRounded: Probe2TempRnd,
            Probe2TempVariant: Probe2TempVariant,
            Probe2FlowVariant: Probe2FlowVariant,
            Probe2TimeSinceLastFlow: timeProbe2,
            Probe2ScoreVariant: Probe2ScoreVariant,
            Probe2LastFlowDate: O1DataList[i][23],
            Probe2LastFlowTime: O1DataList[i][24],
            Probe2Tag: probe2tag,
            Probe2Class: probe2class,
            Probe2TagClass: probe2tagclass,
            Probe2Title: probe2title,

            Probe3Active: O1DataList[i][25],
            Probe3Feed: O1DataList[i][26],
            Probe3Position: O1DataList[i][27],
            Probe3Score: O1DataList[i][22],
            Probe3Offset: O1DataList[i][23],
            Probe3AvgTemp: O1DataList[i][32],
            Probe3TempLimit: this.Probe3TempLimit,
            Probe3MinTemp: Probe3MinRnd,
            Probe3AvgTempRounded: Probe3TempRnd,
            Probe3TempVariant: Probe3TempVariant,
            Probe3FlowVariant: Probe3FlowVariant,
            Probe3TimeSinceLastFlow: timeProbe3,
            Probe3ScoreVariant: Probe3ScoreVariant,
            Probe3LastFlowDate: O1DataList[i][34],
            Probe3LastFlowTime: O1DataList[i][35],
            Probe3Tag: probe3tag,
            Probe3Class: probe3class,
            Probe3TagClass: probe3tagclass,
            Probe3Title: probe3title,

            Probe4Active: O1DataList[i][36],
            Probe4Feed: O1DataList[i][37],
            Probe4Position: O1DataList[i][38],
            Probe4Score: O1DataList[i][30],
            Probe4Offset: O1DataList[i][31],
            Probe4AvgTemp: O1DataList[i][43],
            Probe4TempLimit: this.Probe4TempLimit,
            Probe4MinTemp: Probe4MinRnd,
            Probe4AvgTempRounded: Probe4TempRnd,
            Probe4TempVariant: Probe4TempVariant,
            Probe4FlowVariant: Probe4FlowVariant,
            Probe4TimeSinceLastFlow: timeProbe4,
            Probe4ScoreVariant: Probe4ScoreVariant,
            Probe4LastFlowDate: O1DataList[i][45],
            Probe4LastFlowTime: O1DataList[i][46],
            Probe4Tag: probe4tag,
            Probe4Class: probe4class,
            Probe4TagClass: probe4tagclass,
            Probe4Title: probe4title,

            Recirculatory: O1DataList[i][6],
            HCEnvironment: O1DataList[i][47],
            Trending: O1DataList[i][48],
            HumanName: O1DataList[i][50],
            HeaderVariant: HeaderVariant,
            DeviceOnline: DeviceOnline,
            Breaches: O1DataList[i][54]
          });
        }
        this.O1Array = O1Local;
        this.O1Loaded = true;
        this.C1Loaded = true;
      });

    }},

    UpdateTimeDate(Date, Time) {
      let timeDate = UTCToTimeZone(Date, Time);
      return timeDate;
    },
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        if (this.IDsToChange.O1.length === 0) return;
        let Names = await IDToHuman(this.IDsToChange.O1, Type);
        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        if (this.IDsToChange.C1.length === 0) return;
        let Names = await IDToHuman(this.IDsToChange.C1, Type);
        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      let ClarenceType = "";
      if (Type == "CL") {
        if (data[0] == "e") {
          ClarenceType = "O1";
        } else {
          ClarenceType = "C1";
        }
      }

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }

      return data;
    },

    async IDGetArrays(ID, Type, LoopEnd) {
      if (LoopEnd == false) {
        if (Type == "C1") {
          if (
            this.IDsIhaveChanged.C1.includes(ID) ||
            this.IDsToChange.C1.includes(ID)
          ) {
            return;
          } else if (
            this.IDsIhaveChanged.C1.includes(ID) == false &&
            this.IDsToChange.C1.includes(ID) == false
          ) {
            this.IDsToChange.C1.push(ID);
          }
        }
        if (Type == "O1") {
          if (
            this.IDsIhaveChanged.O1.includes(ID) ||
            this.IDsToChange.O1.includes(ID)
          ) {
            return;
          } else if (
            this.IDsIhaveChanged.O1.includes(ID) == false &&
            this.IDsToChange.O1.includes(ID) == false
          ) {
            this.IDsToChange.O1.push(ID);
          }
        }
      } else if (LoopEnd == true) {
        if (Type == "C1") {
          if (
            this.IDsIhaveChanged.C1.includes(ID) ||
            this.IDsToChange.C1.includes(ID)
          ) {
            this.SwitchToHuman("C1");
            this.SwitchToHuman("O1");
            return;
          } else if (
            this.IDsIhaveChanged.C1.includes(ID) == false &&
            this.IDsToChange.C1.includes(ID) == false
          ) {
            this.IDsToChange.C1.push(ID);
            this.SwitchToHuman("C1");
            this.SwitchToHuman("O1");
          }
        }
        if (Type == "O1") {
          if (
            this.IDsIhaveChanged.O1.includes(ID) ||
            this.IDsToChange.O1.includes(ID)
          ) {
            this.SwitchToHuman("C1");
            this.SwitchToHuman("O1");
            return;
          } else if (
            this.IDsIhaveChanged.O1.includes(ID) == false &&
            this.IDsToChange.O1.includes(ID) == false
          ) {
            this.IDsToChange.O1.push(ID);
            this.SwitchToHuman("C1");
            this.SwitchToHuman("O1");
          }
        }
      }
    },

    // New Name stuff above

    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    showModal(Modal) {
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    showFurtherDetail(id, name, type) {
      Vue.prototype.$DeviceID = id;
      Vue.prototype.$HumanName = name;
      Vue.prototype.$DetailToShow = type;
      this.showModal("FurtherDeviceDetail");
    },
    deviceFileUpload(type) {
      if (type == "C-1") {
        Vue.prototype.$DeviceID = this.c1DeviceInfo.DeviceID;
        Vue.prototype.$HumanName = this.c1DeviceInfo.HumanName;
      }
      if (type == "O-1") {
        Vue.prototype.$DeviceID = this.furtherDeviceInfo.DeviceID;
        Vue.prototype.$HumanName = this.furtherDeviceInfo.HumanName;
      }
      this.showModal("DeviceFileUpload");
    },
    resetForm(calibDeviceType) {
      if (calibDeviceType == "C-1") {
        (this.flowCheckBox = ""),
          (this.calibrationDate = ""),
          (this.calibrationTime1 = ""),
          (this.calibTemperature = ""),
          (this.flowCheckBox2 = ""),
          (this.calibrationDate2 = ""),
          (this.calibrationTime2 = ""),
          (this.calibTemperature2 = "");
      } else if (calibDeviceType == "O-1") {
        this.O1calibrationDateProbe1 = "";
        this.O1calibrationTimeProbe1 = "";
        this.O1calibTemperatureProbe1 = "";
        this.O1flowCheckBoxProbe1 = "";

        this.O1calibrationDateProbe2 = "";
        this.O1calibrationTimeProbe2 = "";
        this.O1calibTemperatureProbe2 = "";
        this.O1flowCheckBoxProbe2 = "";

        this.O1calibrationDateProbe3 = "";
        this.O1calibrationTimeProbe3 = "";
        this.O1calibTemperatureProbe3 = "";
        this.O1flowCheckBoxProbe3 = "";

        this.O1calibrationDateProbe4 = "";
        this.O1calibrationTimeProbe4 = "";
        this.O1calibTemperatureProbe4 = "";
        this.O1flowCheckBoxProbe4 = "";
      }
    },
    cancelCalibration() {
      (this.flowCheckBox = ""),
        (this.calibrationDate = ""),
        (this.calibrationTime1 = ""),
        (this.calibTemperature = ""),
        (this.flowCheckBox2 = ""),
        (this.calibrationDate2 = ""),
        (this.calibrationTime2 = ""),
        (this.calibTemperature2 = "");
      this.hideModal("DeviceCalibrationInput");
    },

    showboxdetails(value) {
    
      this.c1DeviceInfo = "";
      this.c1DeviceInfo = value;
      let TempName = this.getNewName(this.c1DeviceInfo.DeviceID, "CL");
      this.c1DeviceInfo.HumanName = TempName;
      this.$refs["BoxDetailsModal"].show();
    },
    calibrateDevice(DeviceType, Info, HumanName) {
      this.calibDeviceType = DeviceType;
      this.CalibHumanName = HumanName;
      if (this.calibDeviceType == "C-1") {
        this.flowCheckBox = "FALSE";
        this.calibTemperature = "";
        this.calibrationTimeMinutes = "";
        this.calibrationTimeHour = "";
        this.calibrationDate = "";
        this.flowCheckBox2 = "FALSE";
        this.calibTemperature2 = "";
        this.calibrationTimeMinutes2 = "";
        this.calibrationTimeHour2 = "";
        this.calibrationTime1 = "";
        this.calibrationTime2 = "";
        this.calibrationDate2 = "";
        let MultiPipe = "";
        if (this.c1DeviceInfo.type == "double") {
          this.calibrationNoOfPipes = ["1", "2"];
          MultiPipe = "TRUE";
        } else {
          this.calibrationNoOfPipes = ["1"];
          MultiPipe = "FALSE";
        }
        this.calibMultipipe = MultiPipe;
        this.calibrateDeviceID = this.c1DeviceInfo.DeviceID;
      }
      if (this.calibDeviceType == "O-1") {
        this.calibrateDeviceID = Info.DeviceID;
        this.O1DeviceInfo = Info;
      }
      this.showModal("DeviceCalibrationInput");
    },
    submitNewCalibration(DeviceType) {
      if (DeviceType == "C-1") {
        var UserReading = "";
        var FlowChecked = "";
        var CalibrationDate = "";
        var CalibrationTime = "";
        var DataValidated = false;
        if (this.calibMultipipe == "TRUE") {
          if (
            (this.calibTemperature != "") &
            (this.calibTemperature2 != "") &
            (this.flowCheckBox != "") &
            (this.flowCheckBox2 != "") &
            (this.calibrationDate != "") &
            (this.calibrationDate2 != "") &
            (this.calibrationTime1 != "") &
            (this.calibrationTime2 != "")
          ) {
            let convertedreturn1 = this.convertToUTC(
              this.calibrationDate,
              this.calibrationTime1
            );
            let convertedreturn2 = this.convertToUTC(
              this.calibrationDate2,
              this.calibrationTime2
            );

            UserReading = [this.calibTemperature, this.calibTemperature2];
            FlowChecked = [this.flowCheckBox, this.flowCheckBox2];
            CalibrationTime = [
              convertedreturn1.submittime,
              convertedreturn2.submittime,
            ];
            CalibrationDate = [
              convertedreturn1.submitdate,
              convertedreturn2.submitdate,
            ];

            DataValidated = true;
          } else if (
            this.calibTemperature == "" ||
            this.calibTemperature2 == "" ||
            this.flowCheckBox == "" ||
            this.flowCheckBox2 == "" ||
            this.calibrationDate == "" ||
            this.calibrationDate2 == "" ||
            this.calibrationTime1 == "" ||
            this.calibrationTime2 == ""
          ) {
            DataValidated = false;
          }
        } else if (this.calibMultipipe != "TRUE") {
          if (
            (this.calibTemperature != "") &
            (this.flowCheckBox != "") &
            (this.calibrationDate != "") &
            (this.calibrationTime1 != "")
          ) {
            let convertedreturn1 = this.convertToUTC(
              this.calibrationDate,
              this.calibrationTime1
            );

            UserReading = [this.calibTemperature];
            FlowChecked = [this.flowCheckBox];
            CalibrationTime = [convertedreturn1.submittime];
            CalibrationDate = [convertedreturn1.submitdate];
            DataValidated = true;
          } else if (
            this.calibTemperature == "" ||
            this.flowCheckBox == "" ||
            this.calibrationDate == "" ||
            this.calibrationTime1 == ""
          ) {
            DataValidated = false;
          }
        }
        if (DataValidated == true) {
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "Calibrate",
            DeviceDict: [
              {
                DeviceID: this.calibrateDeviceID,
                User: this.$UserURN,
                Calibrated: "TRUE",
                UserReading: UserReading,
                FlowChecked: FlowChecked,
                CalibrationDate: CalibrationDate,
                CalibrationTime: CalibrationTime,
              },
            ],
          };
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Calibration information submitted");
              this.resetCalibModal();
            });
        } else if (DataValidated == false) {
          alert("Please ensure all fields are filled");
        }
      } else if (DeviceType == "O-1") {
        if (
          ((this.accord1Valid.variant == "success") &
            (this.O1DeviceInfo.Probe1Active == "TRUE") ||
            this.O1DeviceInfo.Probe1Active == "FALSE") &
          ((this.accord2Valid.variant == "success") &
            (this.O1DeviceInfo.Probe2Active == "TRUE") ||
            this.O1DeviceInfo.Probe2Active == "FALSE") &
          ((this.accord3Valid.variant == "success") &
            (this.O1DeviceInfo.Probe3Active == "TRUE") ||
            this.O1DeviceInfo.Probe3Active == "FALSE") &
          ((this.accord4Valid.variant == "success") &
            (this.O1DeviceInfo.Probe4Active == "TRUE") ||
            this.O1DeviceInfo.Probe4Active == "FALSE")
        ) {
          let ProbeListData = [];

          if (this.accord1Valid.variant == "success") {
            let convertedreturn1 = this.convertToUTC(
              this.O1calibrationDateProbe1,
              this.O1calibrationTimeProbe1
            );

            ProbeListData.push({
              Probe: "Probe1",
              ProbeFeed: this.O1DeviceInfo.Probe1Feed,
              Position: this.O1DeviceInfo.Probe1Position,
              UserReading: this.O1calibTemperatureProbe1,
              FlowChecked: this.O1flowCheckBoxProbe1,
              CalibrationDate: convertedreturn1.submitdate,
              CalibrationTime: convertedreturn1.submittime,
            });
          }
          if (this.accord2Valid.variant == "success") {
            let convertedreturn2 = this.convertToUTC(
              this.O1calibrationDateProbe2,
              this.O1calibrationTimeProbe2
            );

            ProbeListData.push({
              Probe: "Probe2",
              ProbeFeed: this.O1DeviceInfo.Probe2Feed,
              Position: this.O1DeviceInfo.Probe2Position,
              UserReading: this.O1calibTemperatureProbe2,
              FlowChecked: this.O1flowCheckBoxProbe2,
              CalibrationDate: convertedreturn2.submitdate,
              CalibrationTime: convertedreturn2.submittime,
            });
          }
          if (this.accord3Valid.variant == "success") {
            let convertedreturn3 = this.convertToUTC(
              this.O1calibrationDateProbe3,
              this.O1calibrationTimeProbe3
            );

            ProbeListData.push({
              Probe: "Probe3",
              ProbeFeed: this.O1DeviceInfo.Probe3Feed,
              Position: this.O1DeviceInfo.Probe3Position,
              UserReading: this.O1calibTemperatureProbe3,
              FlowChecked: this.O1flowCheckBoxProbe3,
              CalibrationDate: convertedreturn3.submitdate,
              CalibrationTime: convertedreturn3.submittime,
            });
          }
          if (this.accord4Valid.variant == "success") {
            let convertedreturn4 = this.convertToUTC(
              this.O1calibrationDateProbe4,
              this.O1calibrationTimeProbe4
            );

            ProbeListData.push({
              Probe: "Probe4",
              ProbeFeed: this.O1DeviceInfo.Probe4Feed,
              Position: this.O1DeviceInfo.Probe4Position,
              UserReading: this.O1calibTemperatureProbe4,
              FlowChecked: this.O1flowCheckBoxProbe4,
              CalibrationDate: convertedreturn4.submitdate,
              CalibrationTime: convertedreturn4.submittime,
            });
          }
          let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
          let LookUpHeaders = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "O1Calibrate",
            DeviceDict: [
              {
                DeviceID: this.calibrateDeviceID,
                User: this.$UserURN,
                ProbeList: ProbeListData,
              },
            ],
          };
          axios
            .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
            .then((response) => {
              response;
              alert("Calibration information submitted");
              this.resetCalibModal();
            });
        } else {
          alert(
            "Please ensure all fields are filled before submitting calibration"
          );
        }
      }
    },

    addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    convertToUTC(date, time) {
      let splittime = time.split(":");
      let splitdate = date.split("-");
      let convertDateTime = new Date(
        splitdate[0],
        splitdate[1] - 1,
        splitdate[2],
        splittime[0],
        splittime[1],
        splittime[2]
      );
      let month = convertDateTime.getMonth() + 1; //months from 1-12
      let day = convertDateTime.getDate();
      let year = convertDateTime.getFullYear();

      let h = this.addZero(convertDateTime.getUTCHours());
      let m = this.addZero(convertDateTime.getUTCMinutes());
      let s = this.addZero(convertDateTime.getUTCSeconds());

      let submitdate = year + "-" + month + "-" + day;
      let submittime = h + ":" + m + ":" + s;

      return { submitdate, submittime };
    },
    resetCalibModal() {
      this.O1calibTemperatureProbe4 = "";
      this.O1flowCheckBoxProbe4 = "";
      this.O1calibrationDateProbe4 = "";
      this.O1calibrationTimeProbe4 = "";

      this.O1DeviceInfo = [];
      this.O1calibTemperatureProbe3 = "";
      this.O1flowCheckBoxProbe3 = "";
      this.O1calibrationDateProbe3 = "";
      this.O1calibrationTimeProbe3 = "";

      this.O1calibTemperatureProbe3 = "";
      this.O1flowCheckBoxProbe3 = "";
      this.O1calibrationDateProbe3 = "";
      this.O1calibrationTimeProbe3 = "";

      this.O1calibTemperatureProbe3 = "";
      this.O1flowCheckBoxProbe3 = "";
      this.O1calibrationDateProbe3 = "";
      this.O1calibrationTimeProbe3 = "";

      this.calibrationTime1 = "";
      this.calibrationTime2 = "";
      this.flowCheckBox = "";
      this.calibTemperature = "";
      this.calibrationTimeHour = "";
      this.calibrationTimeMinutes = "";
      this.calibrationDate = "";
      this.flowCheckBox2 = "";
      this.calibTemperature2 = "";
      this.calibrationTimeHour2 = "";
      this.calibrationTimeMinutes2 = "";
      this.calibrationDate2 = "";
      this.hideModal("DeviceCalibrationInput");
    },
    showdetails(id) {
      this.furtherDeviceInfo = id;
      this.$refs["O1DetailsModal"].show();
    },
    fetchNotes(DeviceID, humanname) {
      this.NoteDeviceID = DeviceID;
      (this.NoteHumanName = humanname), (this.NotesArray = []);
      this.NotesTextArray = [];
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "WMCLoadAll",
        RequestVariable: DeviceID,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          let Notes = response.data.Values;
          for (let i = 0; i < Notes.length; i++) {
            this.NotesTextArray.push({
              NoteID: Notes[i][0],
              Date: Notes[i][2],
              Time: Notes[i][3],
              NoteStatus: Notes[i][4],
              NoteTitle: Notes[i][5],
              NoteText: Notes[i][6],
              NoteCreator: Notes[i][8] + " " + Notes[i][9],
            });
          }
          this.NotesArray.push({
            DeviceID: DeviceID,
            NoteInfo: this.NotesTextArray,
          });
          this.showModal("NotesModal");
        });
    },
    addNewNote(DeviceID) {
      this.NewNoteDeviceID = DeviceID;
      this.hideModal("NotesModal");
      this.showModal("NewNotesModal");
    },
    submitNewNote() {
      this.NewNoteCreatorUserURN = this.$UserURN;
      let Name = this.$FullName;
      let SplitName = Name.split(/(\s+)/);
      this.NewNoteCreatorFirstName = SplitName[0];
      this.NewNoteCreatorLastName = SplitName[2];
      this.NewNoteCreatorUserType = this.$ProfilePortal;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/notes";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.NewNoteDeviceID,
            NoteTitle: this.NewNoteTitle,
            Note: this.NewNoteText,
            CreatorURN: this.NewNoteCreatorUserURN,
            CreatorFirstName: this.NewNoteCreatorFirstName,
            CreatorLastName: this.NewNoteCreatorLastName,
            CreatorUserType: this.NewNoteCreatorUserType,
            Location: this.selectedlocation
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          alert("Note Submitted");
          this.hideModal("NewNotesModal");
          this.NewNoteText = "";
          this.NewNoteTitle = "";
          this.fetchNotes(this.NewNoteDeviceID);
        });
    },
    deleteNote(Data) {
      if (confirm("Confirm if you want to delete this note") == true) {
        this.DeleteNoteCreatorUserURN = this.$UserURN;
        let Name = this.$FullName;
        let SplitName = Name.split(/(\s+)/);
        this.DeleteNoteCreatorFirstName = SplitName[0];
        this.DeleteNoteCreatorLastName = SplitName[2];
        this.DeleteNoteCreatorUserType = this.$ProfilePortal;
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/notes";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Delete",
          RequestVariable: Data.NoteID,
          DataDict: [
            {
              ClearedURN: this.DeleteNoteCreatorUserURN,
              ClearedFirstName: this.DeleteNoteCreatorFirstName,
              ClearedLastName: this.DeleteNoteCreatorLastName,
            },
          ],
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Note Deleted");
            this.fetchNotes(this.NoteDeviceID);
          });
      } else {
        alert("Note has not been deleted");
      }
    },
    returnToNotesModal(CurrentModal) {
      if (CurrentModal == "NewNotesModal") {
        this.NewNoteText = "";
        this.NewNoteTitle = "";
      }
      this.hideModal(CurrentModal);
      this.fetchNotes(this.NoteDeviceID);
    },
    boxHeight() {
      let TextBoxHeight =
        document.getElementsByClassName("DashSubHeadText") || "";
      this.MaxHeight = 0;
      for (let i = 0; i < TextBoxHeight.length; i++) {
        if (TextBoxHeight[i].offsetHeight > this.MaxHeight) {
          this.MaxHeight = TextBoxHeight[i].offsetHeight;
        }
      }
      var r = document.querySelector(":root");
      r.style.setProperty("--MaxHeightCalc", this.MaxHeight + "px");
    },
    filterDashboardData() {
      this.C1Loaded = false;
      this.O1Loaded = false;

      /* Check what dashboard its filtering */
      this.submitButtonDisable = true;
      this.resetButtonDisable = true;
      this.filterArray = [];
      let feedArray = [];
      this.$root.$emit("bv::toggle::collapse", "collapse-2");

      // if (this.dbFilterDeviceOrder != "") {
      //   this.filterArray.push("Device");
      // }
      // if (this.dbFilterDeviceLocation != "") {
      //   this.filterArray.push("Location");
      // }
      // if (this.dbFilterSubgroup != "") {
      //   this.filterArray.push("Subgroup");
      // }
      if (
        this.dbFilterHot != "" ||
        this.dbFilterCold != "" ||
        this.dbFilterMixed != "" ||
        this.dbFilterReturn != ""
      ) {
        this.filterArray.push("Feed");
      }
      // if (this.dbFilterPosition != "") {
      //   this.filterArray.push("Position");
      // }
      if (this.dbFilterRiskLevel != "") {
        this.filterArray.push("State");
      }
      // if (this.dbFilterHealthcare != "") {
      //   this.filterArray.push("Healthcare");
      // }
      // if (this.dbFilterRecirculatory != "") {
      //   this.filterArray.push("Recirculatory");
      // }
      // if (this.dbFilterMultiplePipe != "") {
      //   this.filterArray.push("MultiPipe");
      // }
      // if (this.dbFilterOutdoor != "") {
      //   this.filterArray.push("Outdoor");
      // }
      if (this.searchname != "") {
        this.filterArray.push("DeviceName");
      }
      if (this.dbFilterHot != "") {
        feedArray.push("Hot");
      }
      if (this.dbFilterCold != "") {
        feedArray.push("Cold");
      }
      if (this.dbFilterMixed != "") {
        feedArray.push("Mixed");
      }
      if (this.dbFilterReturn != "") {
        feedArray.push("Return");
      }

      if (this.filterArray.length == 0){
        alert("Please ensure a filter has been selected before submitting");
        this.O1Loaded = true;
        this.DataFiltered = false;
        this.C1Loaded = true;
      }
      else {
      this.responseArray = [];
      this.responselist = [];
      this.locations = [];
      this.deviceLocation = "";
      this.location = "";
      this.modal = false;

      this.filterInfo= []
      for (let i=0;i<this.filterArray.length;i++){
        this.filterInfo.push(this.filterArray[i])
      }
       
       this.LoadO1Data(this.filterArray,this.dbFilterRiskLevel,this.searchname,feedArray,)
       this.LoadC1Data(this.filterArray,this.dbFilterRiskLevel,this.searchname,feedArray);
       

       this.O1Loaded = true;
       this.DataFiltered = true;
      } 
    },
    getProbeRiskLevel(temp){
      let riskval = ""
      if((temp < 19.99 && temp != null) || (temp > 55.00) ){
        riskval = "success"
      } else if((temp >= 20.00 && temp <=24.99)||(temp >=45.00 && temp <=54.99)){
        riskval = "highRisk"
      } else if(temp >=25.00 && temp <=44.99){
        riskval = "danger"
      } else{
        riskval = "secondary"
      }
      return riskval;
    },
    resetValue: function() {
      this.C1Loaded = false;
      this.O1Loaded = false;
      this.DataFiltered = false;
      this.submitButtonDisable = true;
      this.resetButtonDisable = true;
      (this.responseArray = []), (this.responselist = []);
      this.locations = [];
      (this.deviceLocation = ""), (this.location = "");
      this.dbFilterRecirculatory = "";
      this.dbFilterOutdoor = "";
      this.dbFilterMultiplePipe = "";
      this.dbFilterBattery = "";
      this.dbFilterHealthcare = "";
      this.dbFilterDeviceLocation = "";
      this.dbFilterDeviceOrder = "";
      this.dbFilterSubgroup = "";
      this.dbFilterFeed = "";
      this.dbFilterPosition = "";
      this.dbFilterRiskLevel = "";
      this.dbFilterHot = "";
      this.dbFilterCold = "";
      this.dbFilterMixed = "";
      this.dbFilterReturn = "";
      this.searchname = "";
      this.$root.$emit("bv::toggle::collapse", "collapse-2");
      this.modal = false;
      this.filterInfo = [];

      this.LoadO1Data([],"","","");
      this.LoadC1Data([],"","","");


      // let LookUpURL =
      //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //   this.$environment +
      //   "/dashboard";
      // let LookUpHeaders = this.$apikeyPost;
      // let LookUpData = {
      //   Report: "DeviceReport",
      //   RequestType: "",
      //   RequestVariable: this.selectedlocation,
      //   DataDict: [
      //     {
      //       FilterType: ["Device"],
      //       DeviceSort: "Asc",
      //       Location: this.dbFilterDeviceLocation.text,
      //       Subgroup: this.dbFilterSubgroup,
      //       Feed: this.dbFilterFeed,
      //       Position: this.dbFilterPosition.text,
      //       State: this.dbFilterRiskLevel,
      //     },
      //   ],
      // };
      // axios.post(LookUpURL, LookUpData, LookUpHeaders).then((response) => {
      //   this.filterInfo = [];
      //   // var DeviceSort = "";
      //   // if (LookUpData.DataDict[0].FilterType.includes("Device")) {
      //   //   if (LookUpData.DataDict[0].DeviceSort == "Asc") {
      //   //     DeviceSort = "Ascending";
      //   //   }
      //   //   if (LookUpData.DataDict[0].DeviceSort == "Desc") {
      //   //     DeviceSort = "Descending";
      //   //   }
      //   //   this.filterInfo.push({ FilterName: "Order", FilterVar: DeviceSort });
      //   // }
      //   this.C1ExtHiCount = 0;
      //   this.C1HiCount = 0;
      //   this.C1ModCount = 0;
      //   this.C1LowCount = 0;

      //   this.C1ExtHiCount =
      //     response.data.DeviceStatusCounts.ExtremelyHighRiskCount;
      //   this.C1HiCount = response.data.DeviceStatusCounts.HighRiskCount;
      //   this.C1ModCount = response.data.DeviceStatusCounts.ModerateRiskCount;
      //   this.C1LowCount = response.data.DeviceStatusCounts.LowRiskCount;

      //   (this.chartOptionsLine = {
      //     dataLabels: {
      //       enabled: false,
      //     },
      //     title: {
      //       text: "7 Day Device Trend",
      //       align: "center",
      //     },
      //     legend: {
      //       show: true,
      //     },
      //     chart: {},
      //     sparkline: {
      //       enabled: true,
      //     },
      //     fill: {
      //       opacity: 1,
      //     },
      //     xaxis: {
      //       categories: response.data.DayDeviceTrend.DateList,
      //       labels: {
      //         show: true,
      //       },
      //     },
      //     yaxis: {
      //       labels: {
      //         show: true,
      //       },
      //     },
      //     colors: ["#dc3546", "#f05f16", "#ffc107", "#28a746"],
      //     grid: {
      //       show: true, // you can either change hear to disable all grids
      //       xaxis: {
      //         lines: {
      //           show: true, //or just here to disable only x axis grids
      //         },
      //         labels: {
      //           show: false,
      //         },
      //       },
      //       yaxis: {
      //         lines: {
      //           show: false, //or just here to disable only y axis
      //         },
      //         axisBorder: {
      //           show: false,
      //         },
      //         labels: {
      //           show: false,
      //         },
      //         axisTicks: {
      //           show: false,
      //         },
      //       },
      //     },
      //   }),
      //     (this.seriesLine = [
      //       {
      //         name: "Extremely High Risk",
      //         data: response.data.DayDeviceTrend.ExtHighCounts,
      //       },
      //       {
      //         name: "High Risk",
      //         data: response.data.DayDeviceTrend.HighCounts,
      //       },
      //       {
      //         name: "Moderate Risk",
      //         data: response.data.DayDeviceTrend.ModCounts,
      //       },
      //       {
      //         name: "Low Risk",
      //         data: response.data.DayDeviceTrend.LowCounts,
      //       },
      //     ]),
      //     (this.filterInfo = []);
      //   this.C1DayTrendData = response.data.DayDeviceTrend;
      //   this.C1CurrentDeviceStatusCounts = response.data.DeviceStatusCounts;
      //   this.donutSeries = [
      //     this.C1CurrentDeviceStatusCounts.ExtremelyHighRiskCount,
      //     this.C1CurrentDeviceStatusCounts.HighRiskCount,
      //     this.C1CurrentDeviceStatusCounts.ModerateRiskCount,
      //     this.C1CurrentDeviceStatusCounts.LowRiskCount,
      //   ];
      //   // var DeviceSort = "";
      //   // if (LookUpData.DataDict[0].FilterType.includes("Device")) {
      //   //   if (LookUpData.DataDict[0].DeviceSort == "Asc") {
      //   //     DeviceSort = "Ascending";
      //   //   }
      //   //   if (LookUpData.DataDict[0].DeviceSort == "Desc") {
      //   //     DeviceSort = "Descending";
      //   //   }
      //   //   this.filterInfo.push({ FilterName: "Order", FilterVar: DeviceSort });
      //   // }
      //   if (response.data.Values == "") {
      //     this.responseArray = [];
      //     this.responseArray = ["No Data"];
      //   } else if (response.data.Values != "") {
      //     this.responselist = response.data.Values;
      //     let IDArray = [];
      //     for (let i = 0; i < this.responselist.length; i++) {
      //       IDArray.push([this.responselist[i][0], i]);
      //     }
      //     /* let current = new Date();

      // this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */

      //     for (let i = 0; i < this.responselist.length; i++) {
      //       var QuoteStr = this.responselist[i][0];
      //       var FlowTime = "";
      //       var FlowDate = "";
      //       var FlowTimeDate = "";
      //       var BioFilmLvl = "";
      //       let DeviceLastReadingDate = this.responselist[i][18];
      //       let DeviceLastReadingTime = this.responselist[i][19];
      //       let ReadingDateTime =
      //         DeviceLastReadingDate + "T" + DeviceLastReadingTime;
      //       let now = new Date();
      //       let ReadingDate = new Date(ReadingDateTime);
      //       let oneday = 24 * 60 * 60 * 1000;

      //       let DeviceOnline = "";

      //       if (now - ReadingDate > oneday) {
      //         DeviceOnline = "FALSE";
      //       } else {
      //         DeviceOnline = "TRUE";
      //       }
      //       BioFilmLvl = this.responselist[i][10];
      //       FlowDate = this.responselist[i][8];
      //       FlowTime = this.responselist[i][9];
      //       if (FlowDate != "N/A") {
      //         FlowTimeDate = FlowDate + "T" + FlowTime;
      //         let d1 = new Date().toUTCString();
      //         d1 = new Date(d1).getTime();
      //         let d2 = new Date(FlowTimeDate).getTime();
      //         this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
      //       } else if (FlowDate === "N/A") {
      //         this.time = "N/A";
      //       }
      //       if (BioFilmLvl == "N/A") {
      //         BioFilmLvl = "NoBio";
      //       }
      //       if (QuoteStr.includes("A")) {
      //         let FlowDate2 = this.responselist[i][8];
      //         let FlowTime2 = this.responselist[i][9];
      //         let DevID = QuoteStr.slice(0, 9);
      //         let a = IDArray;
      //         let term = DevID;
      //         let b = a.filter(
      //           (item) => item[0].toLowerCase().indexOf(term) > -1
      //         );
      //         if (FlowDate2 != "N/A") {
      //           let FlowTimeDate2 = FlowDate2 + "T" + FlowTime2;
      //           let d1 = new Date().toUTCString();
      //           d1 = new Date(d1).getTime();
      //           let d2 = new Date(FlowTimeDate2).getTime();
      //           var time2 = Math.floor((d1 - d2) / 1000 / 60 / 60);
      //         } else if (FlowDate2 === "N/A") {
      //           time2 = "N/A";
      //         }
      //         let BioFilmLvl2 = this.responselist[b[1][1]][10];
      //         if (BioFilmLvl2 == "N/A") {
      //           BioFilmLvl2 = "NoBio";
      //         }
      //         let WorstScoreLvl = "";
      //         if (this.responselist[i][4] > this.responselist[b[1][1]][4]) {
      //           WorstScoreLvl = this.responselist[b[1][1]][4];
      //         }
      //         if (this.responselist[i][4] < this.responselist[b[1][1]][4]) {
      //           WorstScoreLvl = this.responselist[i][4];
      //         }
      //         if (this.responselist[i][4] == this.responselist[b[1][1]][4]) {
      //           WorstScoreLvl = this.responselist[i][4];
      //         }
      //         let VariantColour = "";
      //         if (this.responselist[i][4] < 150) {
      //           VariantColour = "danger";
      //         }
      //         if (
      //           (this.responselist[i][4] >= 150) &
      //           (this.responselist[i][4] < 500)
      //         ) {
      //           VariantColour = "highRisk";
      //         }
      //         if (
      //           (this.responselist[i][4] >= 500) &
      //           (this.responselist[i][4] < 850)
      //         ) {
      //           VariantColour = "warning";
      //         }
      //         if (this.responselist[i][4] >= 850) {
      //           VariantColour = "success";
      //         }
      //         let VariantColour2 = "";
      //         if (this.responselist[b[1][1]][4] < 150) {
      //           VariantColour2 = "danger";
      //         }
      //         if (
      //           (this.responselist[b[1][1]][4] >= 150) &
      //           (this.responselist[b[1][1]][4] < 500)
      //         ) {
      //           VariantColour2 = "highRisk";
      //         }
      //         if (
      //           (this.responselist[b[1][1]][4] >= 500) &
      //           (this.responselist[b[1][1]][4] < 850)
      //         ) {
      //           VariantColour2 = "warning";
      //         }
      //         if (this.responselist[b[1][1]][4] >= 850) {
      //           VariantColour2 = "success";
      //         }
      //         this.responseArray.push({
      //           type: "double",
      //           variant: VariantColour,
      //           DeviceID: QuoteStr,
      //           BuildingName: this.responselist[i][1],
      //           Position: this.responselist[i][2],
      //           Recirculatory: this.responselist[i][11],
      //           Healthcare: this.responselist[i][12],
      //           Outdoor: this.responselist[i][13],
      //           Multipipe: this.responselist[i][15],
      //           Battery: this.responselist[i][14],
      //           DeptFloor: this.responselist[i][16],
      //           Trending: "none",
      //           Dropdown: "False",
      //           DeviceOnline: DeviceOnline,
      //           Pipe1: {
      //             variant: VariantColour,
      //             Score: this.responselist[i][4],
      //             TempHi: this.responselist[i][5],
      //             TempLo: this.responselist[i][6],
      //             TempMed: this.responselist[i][7],
      //             FlowRead: this.time,
      //             PathogenRead: BioFilmLvl,
      //             Feed: this.responselist[i][3],
      //             Trending: this.responselist[1][17],
      //           },
      //           Pipe2: {
      //             variant: VariantColour2,
      //             Score: this.responselist[b[1][1]][4],
      //             TempHi: this.responselist[b[1][1]][5],
      //             TempLo: this.responselist[b[1][1]][6],
      //             TempMed: this.responselist[b[1][1]][7],
      //             FlowRead: time2,
      //             PathogenRead: BioFilmLvl2,
      //             Feed: this.responselist[b[1][1]][3],
      //             Trending: this.responselist[b[1][1]][17],
      //           },
      //           WorstScore: WorstScoreLvl,
      //         });
      //       } else if (QuoteStr.length == 9) {
      //         let VariantColour = "";
      //         if (this.responselist[i][4] < 150) {
      //           VariantColour = "danger";
      //         }
      //         if (
      //           (this.responselist[i][4] >= 150) &
      //           (this.responselist[i][4] < 500)
      //         ) {
      //           VariantColour = "highRisk";
      //         }
      //         if (
      //           (this.responselist[i][4] >= 500) &
      //           (this.responselist[i][4] < 850)
      //         ) {
      //           VariantColour = "warning";
      //         }
      //         if (this.responselist[i][4] >= 850) {
      //           VariantColour = "success";
      //         }
      //         this.responseArray.push({
      //           type: "Single",
      //           variant: VariantColour,
      //           DeviceID: QuoteStr,
      //           DeviceOnline: DeviceOnline,
      //           BuildingName: this.responselist[i][1],
      //           Position: this.responselist[i][2],
      //           Feed: this.responselist[i][3],
      //           Score: this.responselist[i][4],
      //           TempHi: this.responselist[i][5],
      //           TempLo: this.responselist[i][6],
      //           TempMed: this.responselist[i][7],
      //           FlowRead: this.time,
      //           PathogenRead: BioFilmLvl,
      //           Recirculatory: this.responselist[i][11],
      //           Healthcare: this.responselist[i][12],
      //           Outdoor: this.responselist[i][13],
      //           Multipipe: this.responselist[i][15],
      //           Battery: this.responselist[i][14],
      //           DeptFloor: this.responselist[i][16],
      //           Dropdown: "False",
      //           Trending: this.responselist[i][17],
      //         });
      //       }
      //       //  this.responseArray.push({DeviceID: QuoteStr,BuildingName: this.responselist[i][1],Position:this.responselist[i][2],Feed:this.responselist[i][3],Score:this.responselist[i][4],TempHi:this.responselist[i][5],TempLo:this.responselist[i][6],TempMed:this.responselist[i][7],FlowRead:this.time,PathogenRead:BioFilmLvl, Recirculatory:this.responselist[i][11], Healthcare: this.responselist[i][12], Outdoor:this.responselist[i][13], Multipipe:this.responselist[i][15], Battery:this.responselist[i][14], Dropdown: 'False' })
      //       /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
          //  }
        //  }
        this.C1Loaded = true;

        this.DeviceMessage = "Total Devices for " + this.selectedlocation;
      // });
      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/statuscounts";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        RequestType: "Company",
        RequestVariable: this.CompanyName,
      };
      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        this.BadState = response.data.Bad[0];
        this.FairState = response.data.Fair[0];
        this.GoodState = response.data.Good[0];
        this.ExcellentState = response.data.Excellent[0];
        this.TotalDevices = response.data.Total[0];
      });
      this.DataFiltered = false;
    },
    /* NO LONGER USED */
    LookUpState: function(State) {
      if (this.deviceLocation != "") {
        (this.responseArray = []), (this.responselist = []);
        let StateType = State;
        let LookUpURLState =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersState = this.$apikeyPost;
        let LookUpDataState = {
          RequestType: "StateLocation",
          Report: "DeviceReport",
          RequestVariable: StateType,
          Company: this.CompanyName,
          Location: this.deviceLocation.text,
        };
        axios
          .post(LookUpURLState, LookUpDataState, LookUpHeadersState)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
  this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";
              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + "T" + FlowTime;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }
              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }
              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
                Recirculatory: this.responselist[i][11],
                Healthcare: this.responselist[i][12],
                Outdoor: this.responselist[i][13],
                Multipipe: this.responselist[i][15],
                Battery: this.responselist[i][14],
                Dropdown: "False",
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }
            var StateWord = "";
            if (StateType == 4) {
              StateWord = "Low Risk";
              this.TotalDevices = this.ExcellentState;
            }
            if (StateType == 3) {
              StateWord = "Moderate Risk";
              this.TotalDevices = this.GoodState;
            }
            if (StateType == 2) {
              StateWord = "High Risk";
              this.TotalDevices = this.FairState;
            }
            if (StateType == 1) {
              StateWord = "Extremely High Risk";
              this.TotalDevices = this.BadState;
            }
            this.DeviceMessage =
              "Total Devices in " +
              StateWord +
              " State in " +
              this.deviceLocation.text;
          });
      } else {
        (this.responseArray = []), (this.responselist = []);
        let StateType = State;
        let LookUpURLState =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersState = this.$apikeyPost;
        let LookUpDataState = {
          RequestType: "State",
          Report: "DeviceReport",
          RequestVariable: StateType,
          Company: this.CompanyName,
        };
        axios
          .post(LookUpURLState, LookUpDataState, LookUpHeadersState)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
  this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";
              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + "T" + FlowTime;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }
              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }
              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
                Recirculatory: this.responselist[i][11],
                Healthcare: this.responselist[i][12],
                Outdoor: this.responselist[i][13],
                Multipipe: this.responselist[i][15],
                Battery: this.responselist[i][14],
                Dropdown: "False",
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }
            var StateWord = "";
            if (StateType == 4) {
              StateWord = "Low Risk";
              this.TotalDevices = this.ExcellentState;
            }
            if (StateType == 3) {
              StateWord = "Moderate Risk";
              this.TotalDevices = this.GoodState;
            }
            if (StateType == 2) {
              StateWord = "High Risk";
              this.TotalDevices = this.FairState;
            }
            if (StateType == 1) {
              StateWord = "Extremely High Risk";
              this.TotalDevices = this.BadState;
            }
            this.DeviceMessage =
              "Total Devices in " +
              StateWord +
              " State for " +
              this.CompanyName;
          });
      }
    },
    submitLocation() {
      if (this.deviceLocation != "") {
        this.submitButtonDisable = true;
        this.resetButtonDisable = true;
        (this.responseArray = []),
          (this.responselist = []),
          (this.BadState = "");
        this.FairState = "";
        this.GoodState = "";
        this.ExcellentState = "";
        this.TotalDevices = "";
        let LookUpURLLocation =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersLocation = this.$apikeyPost;
        let LookUpDataLocation = {
          RequestType: "Location",
          Report: "DeviceReport",
          RequestVariable: this.deviceLocation.text,
          Company: this.CompanyName,
        };
        axios
          .post(LookUpURLLocation, LookUpDataLocation, LookUpHeadersLocation)
          .then((response) => {
            this.responselist = response.data.Values;
            /* let current = new Date();
  this.TodayDate = current.getFullYear()+','+(current.getMonth()+1)+','+current.getDate()+','+current.getHours()+','+current.getMinutes()+','+current.getSeconds(); */
            for (let i = 0; i < this.responselist.length; i++) {
              var QuoteStr = this.responselist[i][0];
              var FlowTime = "";
              var FlowDate = "";
              var FlowTimeDate = "";
              var BioFilmLvl = "";
              BioFilmLvl = this.responselist[i][10];
              FlowDate = this.responselist[i][8];
              FlowTime = this.responselist[i][9];
              if (FlowDate != "N/A") {
                FlowTimeDate = FlowDate + "T" + FlowTime;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);
              } else if (FlowDate === "N/A") {
                this.time = "N/A";
              }
              if (BioFilmLvl == "N/A") {
                BioFilmLvl = "NoBio";
              }
              this.responseArray.push({
                DeviceID: QuoteStr,
                BuildingName: this.responselist[i][1],
                Position: this.responselist[i][2],
                Feed: this.responselist[i][3],
                Score: this.responselist[i][4],
                TempHi: this.responselist[i][5],
                TempLo: this.responselist[i][6],
                TempMed: this.responselist[i][7],
                FlowRead: this.time,
                PathogenRead: BioFilmLvl,
                Recirculatory: this.responselist[i][11],
                Healthcare: this.responselist[i][12],
                Outdoor: this.responselist[i][13],
                Multipipe: this.responselist[i][15],
                Battery: this.responselist[i][14],
                Dropdown: "False",
                DeptFloor: this.responselist[i][16],
              });
              /* this.chartData.push({Label:"Value", Risk:this.responselist[i][3]}) */
            }
            this.DeviceMessage = "Total Devices in " + this.deviceLocation.text;
            setTimeout(
              () => (this.submitButtonDisable = false),
              (this.resetButtonDisable = false),
              1000
            );
          });
        let LookUpURL2 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/statuscounts";
        let LookUpHeaders2 = this.$apikeyPost;
        let LookUpData2 = {
          RequestType: "Location",
          RequestVariable: this.deviceLocation.text,
          Company: this.CompanyName,
        };
        axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
          this.BadState = response.data.Bad[0];
          this.FairState = response.data.Fair[0];
          this.GoodState = response.data.Good[0];
          this.ExcellentState = response.data.Excellent[0];
          this.TotalDevices = response.data.Total[0];
        });
      } else {
        alert("Please select a location to further filter the data");
      }
    },
    DeviceReportGen: function(Data, DeviceType) {
      if (typeof Data === "object") {
        Vue.prototype.$DeviceID = Data.DeviceID;
        Vue.prototype.$DeviceVariant = Data.variant;
        Vue.prototype.$DetailToShow = DeviceType;
        Vue.prototype.$HumanName = Data.HumanName;
      } else {
        Vue.prototype.$DeviceID = Data;
        Vue.prototype.$DetailToShow = DeviceType;
        Vue.prototype.$HumanName = Data.HumanName;
      }
      this.$router.push("/TrendData");
    },
    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
    seriesDonut() {
      return this.donutSeries;
    },
    seriesDonut2() {
      return this.donutSeries2;
    },
    setChartOptions() {
      return {
        legend: {
          display: true,
          position: "right",
        },
        cutoutPercentage: 60,
        borderAlign: "center",
        title: {
          display: false,
          text: "Devices",
        },
        responsive: true,
        maintainAspectRatio: false,
      };
    },
    subgroupReturn() {
      let LookUpUrlDevice =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeadersDevice = this.$apikeyPost;
      let LookUpRequestDevice = {
        RequestType: "LocationSubgroup",
        Location: this.dbFilterDeviceLocation.text,
      };
      axios
        .post(LookUpUrlDevice, LookUpRequestDevice, LookUpHeadersDevice)
        .then((response) => {
          this.subgroupListArray = [];
          this.subgroupList = response.data.Values;
          for (let i = 0; i < this.subgroupList.length; i++) {
            this.subgroupListArray.push({ Name: this.subgroupList[i][0] });
          }
        });
    },
    CheckDate1() {
      if (this.O1calibrationDateProbe1 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckDate2() {
      if (this.O1calibrationDateProbe2 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckDate3() {
      if (this.O1calibrationDateProbe3 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckDate4() {
      if (this.O1calibrationDateProbe4 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckTime1() {
      if (this.O1calibrationTimeProbe1 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckTime2() {
      if (this.O1calibrationTimeProbe2 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckTime3() {
      if (this.O1calibrationTimeProbe3 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckTime4() {
      if (this.O1calibrationTimeProbe4 != "") {
        return true;
      } else {
        return false;
      }
    },
    CheckTemp1() {
      var regExp = /[a-zA-Z]/g;
      if (regExp.test(this.O1calibTemperatureProbe1)) {
        this.O1calibTemperatureProbe1 = this.O1calibTemperatureProbe1.slice(
          0,
          -1
        );
        return false;
      } else {
        if (this.O1calibTemperatureProbe1 != "") {
          return true;
        }
      }
    },
    CheckTemp2() {
      var regExp = /[a-zA-Z]/g;
      if (regExp.test(this.O1calibTemperatureProbe2)) {
        this.O1calibTemperatureProbe2 = this.O1calibTemperatureProbe2.slice(
          0,
          -1
        );
        return false;
      } else {
        if (this.O1calibTemperatureProbe2 != "") {
          return true;
        }
      }
    },
    CheckTemp3() {
      var regExp = /[a-zA-Z]/g;
      if (regExp.test(this.O1calibTemperatureProbe3)) {
        this.O1calibTemperatureProbe3 = this.O1calibTemperatureProbe3.slice(
          0,
          -1
        );
        return false;
      } else {
        if (this.O1calibTemperatureProbe3 != "") {
          return true;
        }
      }
    },
    CheckTemp4() {
      var regExp = /[a-zA-Z]/g;
      if (regExp.test(this.O1calibTemperatureProbe4)) {
        this.O1calibTemperatureProbe4 = this.O1calibTemperatureProbe4.slice(
          0,
          -1
        );
        return false;
      } else {
        if (this.O1calibTemperatureProbe4 != "") {
          return true;
        }
      }
    },
    accord1Validation() {
      /* If it passes data test return with an object saying its all good with success variant */
      if (
        (this.O1calibrationDateProbe1 != "") &
        (this.O1calibTemperatureProbe1 != "") &
        (this.O1calibrationTimeProbe1 != "") &
        (this.O1flowCheckBoxProbe1 != "FALSE")
      ) {
        return { variant: "success" };
      } else {
        return { variant: "light" };
      }
    },
    accord2Validation() {
      /* If it passes data test return with an object saying its all good with success variant */
      if (
        (this.O1calibrationDateProbe2 != "") &
        (this.O1calibTemperatureProbe2 != "") &
        (this.O1calibrationTimeProbe2 != "") &
        (this.O1flowCheckBoxProbe2 != "FALSE")
      ) {
        return { variant: "success" };
      } else {
        return { variant: "light" };
      }
    },
    accord3Validation() {
      /* If it passes data test return with an object saying its all good with success variant */
      if (
        (this.O1calibrationDateProbe3 != "") &
        (this.O1calibTemperatureProbe3 != "") &
        (this.O1calibrationTimeProbe3 != "") &
        (this.O1flowCheckBoxProbe3 != "FALSE")
      ) {
        return { variant: "success" };
      } else {
        return { variant: "light" };
      }
    },
    accord4Validation() {
      /* If it passes data test return with an object saying its all good with success variant */
      if (
        (this.O1calibrationDateProbe4 != "") &
        (this.O1calibTemperatureProbe4 != "") &
        (this.O1calibrationTimeProbe4 != "") &
        (this.O1flowCheckBoxProbe4 != "FALSE")
      ) {
        return { variant: "success" };
      } else {
        return { variant: "light" };
      }
    },
    DashboardLoaded() {
      if ((this.O1Loaded == true) & (this.C1Loaded == true)) {
        this.$emit("DashLoad", "Loaded");
      } else {
        this.$emit("DashLoad", "Loading");
      }
    },
    showCALWizard(id,devicetype){
          this.ID = id,
          this.Type = devicetype,
          this.$refs["CalWizard"].show();
        },
        FinishCALWizard(){
            this.$refs["CalWizard"].hide();
        },
  },

  updated: function() {
    this.$nextTick(function() {
      this.boxHeight();
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
  watch: {

    O1Loaded() {
      this.DashboardLoaded();
    },
    C1Loaded() {
      this.DashboardLoaded();
    },

    dbFilterDeviceLocation() {
      this.subgroupReturn();
    },
    O1calibrationDateProbe1() {
      this.accord1Validation();
    },
    O1calibTemperatureProbe1() {
      this.accord1Validation();
    },
    O1calibrationTimeProbe1() {
      this.accord1Validation();
    },
    O1flowCheckBoxProbe1() {
      this.accord1Validation();
    },
    O1calibrationDateProbe2() {
      this.accord2Validation();
    },
    O1calibTemperatureProbe2() {
      this.accord2Validation();
    },
    O1calibrationTimeProbe2() {
      this.accord2Validation();
    },
    O1flowCheckBoxProbe2() {
      this.accord2Validation();
    },
    O1calibrationDateProbe3() {
      this.accord3Validation();
    },
    O1calibTemperatureProbe3() {
      this.accord3Validation();
    },
    O1calibrationTimeProbe3() {
      this.accord3Validation();
    },
    O1flowCheckBoxProbe3() {
      this.accord3Validation();
    },
    O1calibrationDateProbe4() {
      this.accord4Validation();
    },
    O1calibTemperatureProbe4() {
      this.accord4Validation();
    },
    O1calibrationTimeProbe4() {
      this.accord4Validation();
    },
    O1flowCheckBoxProbe4() {
      this.accord4Validation();
    },
  },
};
</script>
<style scoped>

:root {
  --MaxHeightCalc: 140px;
}

h4 {
  text-align: center;
}

.mobileRow {
  display: block;
  padding: 1rem;
}

.TwoWideRepeatDash {
  min-width: 100%;
  margin-bottom: 1rem !important;
}

#leftRow {
  margin: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
h5 {
  font-size: 0.95rem;
  padding-top: 5px;
  padding-bottom: 5px;
}
#TempCol {
  text-align: center;
  margin-bottom: 5px;
}
#TempColMid {
  text-align: center;
  margin-bottom: 5px;
  margin-left: 5px;
  margin-right: 5px;
}
#ScoreBar {
  height: 100%;
  width: 85%;
  margin: 0 auto;
  padding-top: 5%;
  padding-bottom: 5%;
}
#OverallScoreContainer {
  position: relative;
  border: solid 1px black;
}

#Selector {
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}
#ButtonRow {
  padding-bottom: 1.5rem;
  border-bottom: solid 2px gray;
  margin-left: 3rem;
  margin-right: 3rem;
}
#FilterButtonRow {
  padding-bottom: 1.5rem;
}
label {
  margin: 0;
}
.DeviceOverview {
  width: 48%;
  float: left;
  color: black;
  margin-right: 2%;
  flex: 1;
}
.PieChartDiv {
  width: 50%;
  float: right;
}
.DeviceInfoTop {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.chartBox {
  height: 95%;
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  background-color: #eeeeee;
  border: 0;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.DoughnutChart {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 225px;
}
/* Updates 240122 */
.totalText {
  width: 100%;
  text-align: center;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  font-size: 1rem;
}
.rightCountBox {
  float: right;
  width: 48%;
}
.leftCountBox {
  float: left;
  width: 48%;
}
.totalBox {
  margin: 1rem 1rem 0rem 1rem;
  padding: 1rem 1.5rem 1rem 1.5rem;
  text-align: center;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
}
.stateCountText {
  font-size: 3rem;
  padding: 0 !important;
}
.lowRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.modRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.highRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  text-align: left;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.extHighRiskCount {
  margin: 1rem 1rem 0rem 1rem;
  text-align: left;
  padding: 0rem 1.5rem 0.5rem 1.5rem;
  width: 100%;
  background-color: #eeeeee;
  border: 0px;
  border-radius: 15px;
  cursor: context-menu;
}
.HealthcareIcon {
  background-color: lightgray;
  height: 1.25rem;
  width: 1.25rem;
  color: red;
  font-size: large;
}
.RecirculatoryIcon {
  background-color: cadetblue;
  height: 1.25rem;
  width: 1.25rem;
}
.MultiplePipe {
  background-color: rgb(0, 0, 0);
  height: 1.25rem;
  width: 1.25rem;
  font-size: medium;
}
.OutdoorIcon {
  background-color: #684e4c;
  height: 1.25rem;
  width: 1.25rem;
}
.legendText {
  color: black;
  font-size: 0.75rem;
}
.checkboxDiv {
  margin-right: 70%;
  border: none;
}
.checkboxWMC {
  margin-bottom: 1rem;
}
.supportTextArea {
  min-height: 5rem;
  width: 100%;
  border-radius: 10px;
  padding: 0.5rem;
}
.noteCol {
  text-align: center;
  background-color: white;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border: solid 1px rgb(180, 180, 180);
  padding: 0.5rem;
}
.noteTitleP {
  text-align: center;
  font-weight: 600;
  padding-top: 0.5rem;
}
.noteDetails {
  text-align: center;
}
.deleteNoteButton {
  background-color: rgb(245, 245, 245);
  border-radius: 15px;
  border: solid 1px black;
}
.deleteNoteButton:hover {
  background-color: rgb(255, 255, 255);
}
/* .notePreivewContent{
} */
.NewNoteModal {
  text-align: center;
  align-items: center;
  align-content: center;
}
.NewNoteTitle {
  width: 100% !important;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 15px;
  background-color: rgb(245, 245, 245);
}
.NewNoteTopRow {
  margin-bottom: 1rem;
}
.NewNoteBottomRow {
  margin-bottom: 1rem;
}
.NotesModalContainerDiv {
  text-align: center;
}
.calibContainer {
  width: 90%;
  border-radius: 15px;
  border: solid 1px rgb(0, 204, 255);
  margin-left: 5%;
  background: #eeeeee;
}
.col-line-mod {
  border-top: solid 1px rgb(200, 200, 200);
  width: 95%;
  margin-left: 2.5%;
  margin-top: 2rem;
}
.flowCheckBox {
  text-align: center;
}
.caliConfirm {
  width: 80%;
  margin-left: 9%;
}
.headFlow {
  margin-top: 4px;
  font-weight: bold;
  color: #585858;
  padding-top: 1rem;
  width: 100%;
  text-align: center;
}
.flowCheck {
  padding-top: 1rem;
  margin-top: 4px;
}
p.cardhead {
  color: gray;
  margin-bottom: 0;
}
p.cardheaddouble {
  color: gray;
  text-decoration: underline;
  font-size: small;
  margin-bottom: 0;
}
p.doublereadings {
  color: black;
  font-size: small;
  padding: 0;
  margin: 0;
}
p.cardbody {
  color: black;
  font-size: medium;
  margin: 0.25rem;
}
p.filterhead {
  color: gray;
  font-size: small;
  margin: 0.25rem;
}
p.filterbody {
  color: gray;
  font-size: small;
  margin: 0.25rem;
}
p.O1CardHead{
  font-size: 0.9rem;
  color: #343a40;
  margin: 0;
  padding: 0;
  text-align: left;
}
.left {
  float: left;
}
.right {
  float: right;
}
.list-group-item {
  border: none;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}
#Table {
  margin: auto;
  text-align: center;
}
#cancel-label {
  color: white;
  font-size: large;
}
.Upload label {
  font-size: 15px;
}
.modal {
  text-align: center;
}
.card-body {
  padding: 10px;
}
.card-footer {
  padding: 0px;
  text-align: center;
}
.right {
  float: right;
}
.centeredList {
  justify-content: center;
}
.HealthcareIcon {
  background-color: lightgray;
  height: 1.25rem;
  width: 1.25rem;
  color: red;
  font-size: large;
}
.BatteryIcon {
  background-color: #29d191;
  height: 1.25rem;
  width: 1.25rem;
}
.MultiplePipe {
  background-color: rgb(0, 0, 0);
  height: 1.25rem;
  width: 1.25rem;
  font-size: medium;
}
.OutdoorIcon {
  background-color: #684e4c;
  height: 1.25rem;
  width: 1.25rem;
  margin: 1px;
}
.legendText {
  color: black;
  font-size: 0.75rem;
}
/* .mixedicon {
  background-color: rgb(160, 87, 228);
} 
.hoticon {
  background-color: red;
}
.coldicon {
  background-color: rgb(83, 83, 255);
}
.returnicon {
  background-color: darkgreen;
}  */
.cardcol {
  border: solid lightgray;
  margin-left: 5px;
  margin-right: 5px;
}
.moderaterisk {
  background-color: rgb(252, 252, 38);
  color: #000;
}
.cardhead {
  color: #808080;
  font-size: 12px;
  text-align: left;
  text-align: center;
}

.ProbeSubHeadText {
  font-size: small;
  margin-bottom: 0;
  text-align: center;
}

.highRisk {
  background-color: #f05e16;
  color: #000;
}
.b-avatar-group .b-avatar-group-inner {
  flex-wrap: wrap;
}
.arrowDownNotes {
  cursor: pointer;
  font-size: 24px;
}
.FlowIconRight {
  margin-left: 0.1em;
}

TempIconLeft {
  margin-right: 0.1em;
}
.bottomO1CardGroup {
  margin-top: 0.5em;
}
.cardTemp {
  padding: 0;
}

.DashSubHeadText {
  font-size: 0.75rem;
  min-height: var(--MaxHeightCalc);
}
.C1DashSubHeadText {
  font-size: 0.8rem;
}

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.newhead {
  color: grey;
  margin-bottom: 0;
  margin-top: 0;
  font-size: medium;
  text-decoration: underline;
}

p.newreadings {
  color: white;
  font-size: small;
  padding: 0;
  margin: 0;
}

.nopad {
  margin-right: 0;
  margin-left: 0;
}
.success {
  background-color: #28a745;
}
.warning {
  background-color: #ffc107;
  color: #000000;
}
.danger {
  background-color: #dc3545;
}

.light {
  background-color: #f8f9fa;
  color: #000000;
}
.breachcol{
  background-color: #3b3b3b;
  color: #ffc107;
  margin: 0;
  border-style: solid;
  border-width: 5px;
  border-color: #3b3b3b;
}
.CardHeader{
  font-size: large;
  font-weight: bold;
  margin: 0px;
}
.CardSubHeader{
  font-size: 10pt;
  font-weight: bold;
  margin: 0px;
  color: #3b3b3b;
}
.smalltag{
  margin: 0;
  font-size: small;
}
.progress{
  background-color: #d3d3d3;
  border-style: solid;
  border-width: 0.5px;
}
.coldbackicon{
  background-color: rgb(83, 83, 255);
  height: 2.5em;
  width: 6em;
}
.lightbackicon{
  background-color:#f8f9fa;
  height:2.5em;
  width: 6em;
}
.noicon{
  background-color:#f8f9fa;
  color: #212529;
}
.coldbackground{
  background-color: rgb(83, 83, 255);
}
.hotbackicon{
  background-color: red;
  height: 2.5em;
  width: 6em;
}
.returnbackicon{
  background-color: darkgreen;
  height: 2.5em;
  width: 6em;
}
.mixedbackicon{
  background-color: rgb(160, 87, 228);;
  height: 2.5em;
  width: 6em;
}
.disclaimer{
  color: grey;
  font-size: small;
}
</style>
